export default function (editor: any, opt: any = {}) {
    const blockManager = editor.BlockManager;
    const category = opt.category;


    blockManager.add('carrerum-nav-with-points', {
        label: 'Хедер с пунктами',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
	<div class="carrerum-nav-with-points">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt="">
            <div>
                <a href="#">Для кого это</a>
                <a href="#">Как устроен курс</a>
                <a href="#">Программа курса</a>
            </div>            
            <a href="#">Забронировать место</a>
        </div>
    </div>`
	});

    blockManager.add('carrerum-nav', {
        label: 'Хедер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-nav">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt=""></div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825424339.png" alt="">
                    <input type="checkbox">
                    <div>
                        <ul>
                            <li><a href="#">О карьеруме</a></li>
                            <li><a href="#">Курсы</a></li>
                            <li><a href="#">Кейсы студентов</a></li>
                            <li><a href="#">Эксперты клубов</a></li>
                            <li><a href="#">Услуги Ольги</a></li>
                            <li><a href="#">Пресса</a></li>
                            <li><a href="#">Блог</a></li>
                            <li><a href="#">Телеграм-бот</a></li>
                            <li><a href="#">Вакансии</a></li>
                        </ul>
                    </div>
                </label>
            </div>
            <div><a href="#">Войти</a></div>
        </div>
    </div>`
	});

	blockManager.add('carrerum-nav-mob', {
		label: 'Хедер (mobile)',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `
		<div class="carrerum-nav-mob">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt=""></div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825424339.png" alt="">
                    <input type="checkbox">
                    <div>
                        <ul>
                            <li><a href="#">О карьеруме</a></li>
                            <li><a href="#">Курсы</a></li>
                            <li><a href="#">Кейсы студентов</a></li>
                            <li><a href="#">Эксперты клубов</a></li>
                            <li><a href="#">Услуги Ольги</a></li>
                            <li><a href="#">Пресса</a></li>
                            <li><a href="#">Блог</a></li>
                            <li><a href="#">Телеграм-бот</a></li>
                            <li><a href="#">Вакансии</a></li>
                            <a href="#">Войти</a>
                        </ul>
                    </div>
                </label>
            </div>
        </div>
    </div>`
	});



    blockManager.add('careerum-nav-with-region', {
		label: 'Навигация с выбором страны',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-nav-with-region">
        <div>
            <div>
                <a href="https://careerum.ru/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267351104.png" alt=""></a>
            </div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267384406.svg" alt="">
                    <input type="checkbox">
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="">
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                                    <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                                    <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                                    <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                                    <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                                    <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                                    <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                                    <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                                    <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                                    <li><a href="https://careerum.ru/blog">Блог</a></li>
                                    <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <div>
                <a href="https://careerum.ru/club/corporate/" data-lang="en">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640255019839.png" alt="">
                    <p>RU</p>
                </a>
                <a href="https://careerum.ru/club/corporate/en/" data-lang="ru">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640254977596.png" alt="">
                    <p>EN</p>
                </a>
            </div>
            <div>
                <div class="regopen"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267450166.svg" alt=""><p></p></div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="" class="regclose">
                    <p>Откуда вы?</p>
                    <div>
                        <input type="radio" name="location" value="Russia" id="locatcheck1"><label for="locatcheck1">Россия</label>
                        <input type="radio" name="location" value="Europe" id="locatcheck2"><label for="locatcheck2">Европа</label>
                        <input type="radio" name="location" value="Other" id="locatcheck3"><label for="locatcheck3">Другие страны</label>
                    </div>
                    
                </div>                
            </div>
            <div><a href="#popup-enter-auth">Войти</a></div>
        </div>
    </div>
	`});

	blockManager.add(`careerum-nav-with-region-tablet`, {
		label: 'Навигация с выбором страны (tablet)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-nav-with-region-tablet">
        <div>
            <div>
                <a href="https://careerum.ru/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267481713.png" alt=""></a>
            </div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267504077.png" alt="">
                    <input type="checkbox">
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="">
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                                    <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                                    <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                                    <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                                    <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                                    <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                                    <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                                    <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                                    <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                                    <li><a href="https://careerum.ru/blog">Блог</a></li>
                                    <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <div>
                <a href="https://careerum.ru/club/corporate/" data-lang="en">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640255019839.png" alt="">
                    <p>RU</p>
                </a>
                <a href="https://careerum.ru/club/corporate/en/" data-lang="ru">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640254977596.png" alt="">
                    <p>EN</p>
                </a>
            </div>
            <div>
                <div class="regopen"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267450166.svg" alt=""><p></p></div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="" class="regclose">
                    <p>Откуда вы?</p>
                    <div>
                        <input type="radio" name="location" value="Russia" id="locatcheck1-tablet"><label for="locatcheck1-tablet">Россия</label>
                        <input type="radio" name="location" value="Europe" id="locatcheck2-tablet"><label for="locatcheck2-tablet">Европа</label>
                        <input type="radio" name="location" value="Other" id="locatcheck3-tablet"><label for="locatcheck3-tablet">Другие страны</label>
                    </div>
                    
                </div>                
            </div>
            <div><a href="#popup-enter-auth">Войти</a></div>
        </div>
    </div>
	`});

	blockManager.add(`careerum-nav-with-region-mobile`, {
		label: 'Навигация с выбором страны (mobile)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-nav-with-region-mobile">
        <div>
            <div><a href="https://careerum.ru/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267351104.png" alt=""></a></div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267384406.svg" alt="">
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="">
                    </div>
                    <div>
                        <div>
                            <ul>
                            <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                            <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                            <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                            <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                            <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                            <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                            <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                            <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                            <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                            <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                            <li><a href="https://careerum.ru/blog">Блог</a></li>
                            <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                            </ul>
                        </div>
                        <div>
                            <div class="regopen"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267529551.svg" alt="">
                                <p></p>
                            </div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1637267425235.svg" alt="" class="regclose">
                                <p>Откуда вы?</p>
                                <div>
                                    <input type="radio" name="location" value="Russia" id="locatcheck1-mobile"><label
                                        for="locatcheck1-mobile">Россия</label>
                                    <input type="radio" name="location" value="Europe" id="locatcheck2-mobile"><label
                                        for="locatcheck2-mobile">Европа</label>
                                    <input type="radio" name="location" value="Other" id="locatcheck3-mobile"><label
                                        for="locatcheck3-mobile">Другие страны</label>
                                </div>

                            </div>
                        </div>
                        <div><a href="mailto:hello@careerum.ru">hello@careerum.ru</a></div>
                        <div>
                            <a target="_blank" href="https://www.facebook.com/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017691879.png" alt=""></a>
                            <a target="_blank" href="https://www.linkedin.com/company/careerum/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017716134.png" alt=""></a>
                            <a target="_blank" href="https://www.instagram.com/careerum.platform/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017733329.png" alt=""></a>
                            <a target="_blank" href="https://youtube.com/c/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017750433.png" alt=""></a>
                        </div>
                    </div>
                </div>
                </label>
            </div>
            <div>
                <a href="https://careerum.ru/club/corporate/" data-lang="en">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640255019839.png" alt="">
                    <p>RU</p>
                </a>
                <a href="https://careerum.ru/club/corporate/en/" data-lang="ru">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640254977596.png" alt="">
                    <p>EN</p>
                </a>
            </div>
            <div><a href="#popup-enter-auth">Войти</a></div>
        </div>
    </div>
	`});



    blockManager.add('careerum-full-width-img', {
		label: 'Картинка на весь экран',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-full-width-img">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1638267001560.jpg" alt="">
        </div>
    </div>
	`});

	blockManager.add(`careerum-full-width-img-tablet`, {
		label: 'Картинка на весь экран (tablet)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-full-width-img-tablet">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1638267001560.jpg" alt="">
        </div>
    </div>
	`});

	blockManager.add(`careerum-full-width-img-mobile`, {
		label: 'Картинка на весь экран (mobile)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="careerum-full-width-img-mobile">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1638267001560.jpg" alt="">
        </div>
    </div>
	`});




    blockManager.add('carrerum-site-header', {
        label: 'Хедер сайта',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-site-header">
        <div>
            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt=""></a></div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825424339.png" alt="">
                    <input type="checkbox">
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/">О карьеруме</a></li>
                                    <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                                    <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                                    <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                                    <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                                    <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                                    <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                                    <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                                    <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                                    <li><a href="https://careerum.ru/blog">Блог</a></li>
                                    <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <div><a href="#popup-enter-auth">Войти</a></div>
        </div>
    </div>`
	});

    
    blockManager.add('carrerum-nav3-tablet', {
        label: 'Хедер сайта (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-nav3-tablet">
        <div>
            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt=""></a></div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825424339.png" alt="">
                    <input type="checkbox">
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/">О карьеруме</a></li>
                                    <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                                    <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                                    <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                                    <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                                    <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                                </ul>
                            </div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                                    <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                                    <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                                    <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                                    <li><a href="https://careerum.ru/blog">Блог</a></li>
                                    <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
            <div><a href="#popup-enter-auth-tablet">Войти</a></div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-nav3-mobile', {
        label: 'Хедер сайта (мобильный)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-nav3-mobile">
        <div>
            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242750.png" alt=""></a></div>
            <div>
                <label>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825424339.png" alt="">
                    <input type="checkbox">
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
                        </div>
                        <div>
                            <div>
                                <ul>
                                    <li><a href="https://careerum.ru/">О карьеруме</a></li>
                                    <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                                    <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                                    <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                                    <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                                    <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                                    <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                                    <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                                    <li><a href="https://careerum.ru/careerbot">Телеграм-бот</a></li>
                                    <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                                    <li><a href="https://careerum.ru/blog">Блог</a></li>
                                    <li><a href="https://careerum.ru/#free">Бесплатное</a></li>
                                </ul>
                            </div>
                            <div><a href="mailto:hello@careerum.ru">hello@careerum.ru</a></div>
                            <div>
                                <a target="_blank" href="https://www.facebook.com/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017691879.png" alt=""></a>
                                <a target="_blank" href="https://www.linkedin.com/company/careerum/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017716134.png" alt=""></a>
                                <a target="_blank" href="https://www.instagram.com/careerum.platform/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017733329.png" alt=""></a>
                                <a target="_blank" href="https://youtube.com/c/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017750433.png" alt=""></a>
                            </div>
                        </div>
                    </div>
                </label>
            </div>
        
        <div><a href="#popup-enter-auth-mobile">Войти</a></div>
    </div>`
	});


	blockManager.add('carrerum-main-with-button', {
        label: '1ый разворот',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-main-with-button">
        <div>
            <div>
                <div>
                    <h1>Карьерум.Старт</h1>
                    <h2>10 шагов к <span>«Я люблю свою работу»</span></h2>
                    <p>Краткое описание курса сразу на первом блоке страницы Краткое описание курса сразу на первом блоке страницы Краткое описание курса сразу на первом блоке страницы</p>
                    <a href="#">Начать обучение</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242685.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <h3>Старт курса</h3>
                    <p>23 марта</p>
                </div>
                <div>
                    <h3>Длительность</h3>
                    <p>5 недель</p>
                </div>
                <div>
                    <h3>Формат обучения</h3>
                    <p>Онлайн</p>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-main-with-button2-mobile', {
        label: '1ый разворот для мобильных',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-main-with-button2-mobile">
        <div>
            <div>
                <div>
                    <div>
                        <h2>Карьерум</h2>
                        <h2>Платформа карьерного развития</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016674620.png" alt="">
                        <p>Работаем, чтобы вы любили свою работу ♥</p>
                        <p>Помогаем русскоязычным профессионалам по всему миру осознанно и с удовольствием строить карьеру, опираться  на свои желания и мыслить <br> за рамками</p>
                        <a href="#carrerum-join-mobile">Начать обучение</a>
                    </div>
                </div>
                <div class="careerum-title-with-columns-mobile">
                    <h2>Карьерум — ваша возможность покорить любую страну, индустрию, компанию. Уже 5000+ выпускников из</h2>
                    <div>
                        <div>
                            <h3>1000+</h3>
                            <p>компаний</p>
                        </div>
                        <div>
                            <h3>28</h3>
                            <p>стран</p>
                        </div>
                        <div>
                            <h3>31</h3>
                            <p>индустрии</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-main-with-button2-tablet', {
        label: '1ый разворот (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-main-with-button2-tablet">
        <div>
            <div>
                <div>
                    <div>
                        <h2>Карьерум</h2>
                        <h2>Платформа карьерного развития</h2>
                        <p>Работаем, чтобы вы любили свою работу ♥</p>
                        <p>Помогаем русскоязычным профессионалам по всему миру осознанно и с удовольствием строить карьеру, опираться  на свои желания и мыслить за рамками</p>
                        <a href="#carrerum-join-tablet">Начать обучение</a>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016674620.png" alt="">
                    </div>
                </div>
                <div class="careerum-title-with-columns-tablet">
                    <h2>Карьерум — ваша возможность покорить любую страну, индустрию, компанию. Уже 5000+ выпускников из</h2>
                    <div>
                        <div>
                            <h3>1000+</h3>
                            <p>компаний</p>
                        </div>
                        <div>
                            <h3>28</h3>
                            <p>стран</p>
                        </div>
                        <div>
                            <h3>31</h3>
                            <p>индустрии</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>
    </div>`
	});


	blockManager.add('carrerum-main-with-button-mob', {
		label: '1ый разворот (mobile)',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `
		<div class="carrerum-main-with-button-mob">
        <div>
            <div>
                <div>
                    <h2>Карьерум.Старт</h2>
                    <h2>10 шагов к <span>«Я люблю свою работу»</span></h2>
                    <p>Краткое описание курса сразу на первом блоке страницы Краткое описание курса сразу на первом блоке страницы Краткое описание курса сразу на первом блоке страницы</p>
                    <a href="#">Начать обучение</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242685.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <h3>Старт курса</h3>
                    <p>23 марта</p>
                </div>
                <div>
                    <h3>Длительность</h3>
                    <p>5 недель</p>
                </div>
                <div>
                    <h3>Формат обучения</h3>
                    <p>Онлайн</p>
                </div>
            </div>
        </div>
		</div>`
	});



    blockManager.add('carrerum-main-with-button2', {
        label: '1ый разворот для сайта',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-main-with-button2">
        <div>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016615286.png" alt="">
                        <h1>Платформа карьерного развития</h1>
                        <p>Работаем, чтобы вы любили свою работу ♥</p>
                        <p>Помогаем русскоязычным профессионалам по всему миру осознанно и с удовольствием строить карьеру, опираться <br> на свои желания и мыслить за рамками</p>
                        <a href="#">Начать обучение</a>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016674620.png" alt="">
                    </div>
                </div>
                <div class="careerum-title-with-columns">
                    <h2>Карьерум — ваша возможность покорить любую страну, индустрию, компанию. Уже 5000+ выпускников из</h2>
                    <div>
                        <div>
                            <h3>1000+</h3>
                            <p>компаний</p>
                        </div>
                        <div>
                            <h3>28</h3>
                            <p>стран</p>
                        </div>
                        <div>
                            <h3>31</h3>
                            <p>индустрии</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>
        
    </div>`
	});


    /* 1ЫЙ РАЗВОРОТ С ПАРТНЁРАМИ */

    blockManager.add('carrerum-main-with-button3', {
        label: '1ый разворот с партнёрами',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-main-with-button3">
            <div>
                <div>
                    <div>
                        <h1>Карьерум.Клуб</h1>
                        <p>Мы совместили два эффективных подхода — обучение и нетворкинг — и создали проект, где русскоязычные специалисты по всему миру учатся управлять карьерой в удовольствие, находят работу мечты, растут в должности и зарплате. Уже 3000+ кейсов</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619747990555.png" alt="">
                    </div>
                </div>
                <div class="clients">
                    <h2>Здесь получают офферы в топовые международные компании в 28 странах</h2>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
                    </div>
                    <div class="columns-without-header">
                        <div>
                            <h3>400+</h3>
                            <p>офферов уже получили с помощью клуба</p>
                        </div>
                        <div>
                            <h3>70%</h3>
                            <p>среднее увеличение дохода участников</p>
                        </div>
                        <div>
                            <h3>300%</h3>
                            <p>рекордное повышение зарплаты в клубе</p>
                        </div>
                        <div>
                            <h3>80+</h3>
                            <p>релокаций в страну мечты — даже в пандемию</p>
                        </div>
                        <div>
                            <h3>55%</h3>
                            <p>участников укрепили самооценку уже в первый месяц</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>`
	});

    blockManager.add('carrerum-main-with-button3-tablet', {
        label: '1ый разворот с партнёрами (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-main-with-button3-tablet">
            <div>
                <div>
                    <div>
                        <h2>Карьерум.Клуб</h2>
                        <p>Мы совместили два эффективных подхода — обучение и нетворкинг — и создали проект, где русскоязычные специалисты по всему миру учатся управлять карьерой в удовольствие, находят работу мечты, растут в должности и зарплате. Уже 3000+ кейсов</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619747990555.png" alt="">
                    </div>
                </div>
                <div>
                    <h2>Здесь получают офферы в топовые международные компании в 28 странах</h2>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
                    </div>
                    <div>
                        <div>
                            <h3>400+</h3>
                            <p>офферов уже получили с помощью клуба</p>
                        </div>
                        <div>
                            <h3>70%</h3>
                            <p>среднее увеличение дохода участников</p>
                        </div>
                        <div>
                            <h3>300%</h3>
                            <p>рекордное повышение зарплаты в клубе</p>
                        </div>
                        <div>
                            <h3>80+</h3>
                            <p>релокаций в страну мечты — даже в пандемию</p>
                        </div>
                        <div>
                            <h3>55%</h3>
                            <p>участников укрепили самооценку уже в первый месяц</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>`
	});

    blockManager.add('carrerum-main-with-button3-mobile', {
        label: '1ый разворот с партнёрами (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-main-with-button3-mobile">
            <div>
                <div>
                    <div>
                        <h2>Карьерум.Клуб</h2>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619747990555.png" alt="">
                        <p>Мы совместили два эффективных подхода — обучение и нетворкинг — и создали проект, где русскоязычные специалисты по всему миру учатся управлять карьерой в удовольствие, находят работу мечты, растут в должности и зарплате. Уже 3000+ кейсов</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                <div>
                    <h2>Здесь получают офферы в топовые международные компании в 28 странах</h2>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
                    </div>
                    <div>
                        <div>
                            <h3>400+</h3>
                            <p>офферов уже получили с помощью клуба</p>
                        </div>
                        <div>
                            <h3>70%</h3>
                            <p>среднее увеличение дохода участников</p>
                        </div>
                        <!-- <div>
                            <h3>300%</h3>
                            <p>рекордное повышение зарплаты в клубе</p>
                        </div> -->
                        <div>
                            <h3>80+</h3>
                            <p>релокаций в страну мечты — даже в пандемию</p>
                        </div>
                        <div>
                            <h3>55%</h3>
                            <p>участников укрепили самооценку уже в первый месяц</p>
                        </div>
                    </div>                
                </div>
            </div>
        </div>`
	});


    /* EDUCATION NETWORKING */

    blockManager.add('carrerum-education-networking', {
        label: 'Обучение \ нетворк',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-education-networking">
            <div>
                <h2>Карьерум.Клуб — карьерное образование и <br> нетворкинг в одном продукте</h2>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749120341.png" alt="">
                        </div>
                        <div>
                            <h3>Образовательная <br> платформа</h3>
                            <ul>
                                <li>250+ часов курсов, вебинаров, мастер-классов на карьерную тематику</li>
                                <li>15 образовательных треков по самым популярным карьерным запросам (вы тоже найдете свой)</li>
                                <li>Новые онлайн-мероприятия каждый месяц</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749152624.png" alt="">
                        </div>
                        <div>
                            <h3>Нетворкинговая <br> платформа</h3>
                            <ul>
                                <li>Сообщество профессионалов со всего мира в одной соцсети</li>
                                <li>Языковые клубы, мастермаинды, нетворк-встречи в разных городах, странах и онлайн</li>
                                <li>Индивидуальная поддержка кураторов</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a href="#">Записаться в лист ожидания</a>
            </div>
        </div>`
	});

    blockManager.add('carrerum-education-networking-tablet', {
        label: 'Обучение \ нетворк (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-education-networking-tablet">
            <div>
                <h2>Карьерум.Клуб — карьерное образование и <br> нетворкинг в одном продукте</h2>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749120341.png" alt="">
                        </div>
                        <div>
                            <h3>Образовательная <br> платформа</h3>
                            <ul>
                                <li>250+ часов курсов, вебинаров, мастер-классов на карьерную тематику</li>
                                <li>15 образовательных треков по самым популярным карьерным запросам (вы тоже найдете свой)</li>
                                <li>Новые онлайн-мероприятия каждый месяц</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749152624.png" alt="">
                        </div>
                        <div>
                            <h3>Нетворкинговая <br> платформа</h3>
                            <ul>
                                <li>Сообщество профессионалов со всего мира в одной соцсети</li>
                                <li>Языковые клубы, мастермаинды, нетворк-встречи в разных городах, странах и онлайн</li>
                                <li>Индивидуальная поддержка кураторов</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a href="#">Записаться в лист ожидания</a>
            </div>
        </div>`
	});

    blockManager.add('carrerum-education-networking-mobile', {
        label: 'Обучение \ нетворк (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-education-networking-mobile">
            <div>
                <h2>Карьерум.Клуб — карьерное образование и нетворкинг <br> в одном продукте</h2>
                <div>
                    <div>
                        <div>
                            <h3>Образовательная платформа</h3>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749120341.png" alt="">                        
                            <ul>
                                <li>250+ часов курсов, вебинаров, мастер-классов на карьерную тематику</li>
                                <li>15 образовательных треков по самым популярным карьерным запросам (вы тоже найдете свой)</li>
                                <li>Новые онлайн-мероприятия каждый месяц</li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Нетворкинговая платформа</h3>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619749152624.png" alt="">

                            
                            <ul>
                                <li>Сообщество профессионалов со всего мира в одной соцсети</li>
                                <li>Языковые клубы, мастермаинды, нетворк-встречи в разных городах, странах и онлайн</li>
                                <li>Индивидуальная поддержка кураторов</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a href="#">Записаться в лист ожидания</a>
            </div>
        </div>`
	});



    /* CLUB TRACKS */

    blockManager.add('carrerum-club-tracks', {
        label: 'Треки в клубе',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
<div class="carrerum-club-tracks">
    <div>
        <h2>Треки, по которым вы можете пойти в клубе</h2>
        <input type="checkbox" id="accord">
        <div>
            <div>
                <div>
                    <h3>«Звездный кандидат»</h3>
                    <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
                    <a href="#popup-track">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620431294153.png" alt="">
                </div> 
            </div>                
            <div>
                <div>
                    <h3>«Карьерная ракета»</h3>
                    <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515246130.png" alt="">
                </div>             
            </div>                
            <div>
                <div>
                    <h3>«Жизнь после оффера»</h3>
                    <p>Научитесь быстро и эффективно вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515315780.png" alt="">
                </div>             
            </div>
            <div>
                <div>
                    <h3>«Самооценка 2.0»</h3>
                    <p>Прокачаете уверенность в своих силах и избавитесь от перфекционизма и синдрома самозванца, чтобы покорять новые карьерные вершины</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515339823.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Real Me: как найти себя в работе и жизни»</h3>
                    <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515363508.png" alt="">
                </div>             
            </div>                
            <div>
                <div>
                    <h3>«Работать не 24/7, а головой»</h3>
                    <p>Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515388064.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Карьера без стресса»</h3>
                    <p>Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515410983.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Выход из декрета»</h3>
                    <p>Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом и легко находить высокооплачиваемую работу</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515431563.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Антикризис: как из лимонов делать лимонад»</h3>
                    <p>Узнаете, как подготовиться к кризису и пережить его не только без потерь, но и с новым оффером или укреплением текущей позиции</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515452604.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Новые горизонты»</h3>
                    <p>Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции, как выбрать новую сферу и стать в ней востребованным</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515478858.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Секреты нетворкинга»</h3>
                    <p>Построите для себя сильное окружение и превратите нетворкинг в эффективный инструмент достижения своих карьерных целей, даже если вы интроверт</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515500185.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Релокация и поиск работы за рубежом»</h3>
                    <p>Узнаете всё о работе и учебе в разных странах, получите инструменты для поиска оффера в новой географии</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515519773.png" alt="">
                </div> 
            </div>
            <div>
                <div>
                    <h3>«Dream Team»</h3>
                    <p>Прокачаете навык управления проектами и научитесь экологично и эффективно достигать целей, благодаря командной работе</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515542139.png" alt="">
                </div> 
            </div>
            
            
            <div>
                <div>
                    <h3>«Высокий старт: как попасть в консалтинг»</h3>
                    <p>Узнаете, как получить работу в одной из самых высокооплачиваемых сфер благодаря инсайдерской информации</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515563631.png" alt="">
                </div> 
            </div>
            
            <div>
                <div>
                    <h3>«Зарубежное образование»</h3>
                    <p>Определите, как образование поможет вам достичь карьерных целей, и начнете процесс подготовки</p>
                    <a href="#">Узнать, что входит</a>
                </div>       
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515580279.png" alt="">
                </div> 
            </div>
            
        </div>
        <label for="accord"><span>Показать еще 9 треков</span><span>Свернуть</span></label>            
        <a href="#">Записаться в лист ожидания</a>
    </div>
</div>`
	});

    blockManager.add('carrerum-club-tracks-tablet', {
        label: 'Треки в клубе (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-club-tracks-tablet">
        <div>
            <h2>Треки, по которым вы можете пойти в клубе</h2>
            <div class="slider slider-block slider-ways">
                <div>
                    <div>
                        <div>
                            <h3>«Звездный кандидат»</h3>
                            <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620431294153.png" alt="">
                        </div> 
                    </div>
                    <a href="#popup-track-tablet">Узнать, что входит</a>                    
                </div>                
                <div>
                    <div>
                        <div>
                            <h3>«Карьерная ракета»</h3>
                            <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515246130.png" alt="">
                        </div>  
                    </div>
                    <a href="#">Узнать, что входит</a>   
                </div>                
                <div>
                    <div>
                        <div>
                            <h3>«Жизнь после оффера»</h3>
                            <p>Научитесь быстро и эффективно вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515315780.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>      
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Самооценка 2.0»</h3>
                            <p>Прокачаете уверенность в своих силах и избавитесь от перфекционизма и синдрома самозванца, чтобы покорять новые карьерные вершины</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515339823.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Real Me: как найти себя в работе и жизни»</h3>
                            <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515363508.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>     
                </div>                
                <div>
                    <div>
                        <div>
                            <h3>«Работать не 24/7, а головой»</h3>
                            <p>Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515388064.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Карьера без стресса»</h3>
                            <p>Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515410983.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Выход из декрета»</h3>
                            <p>Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом и легко находить высокооплачиваемую работу</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515431563.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Антикризис: как из лимонов делать лимонад»</h3>
                            <p>Узнаете, как подготовиться к кризису и пережить его не только без потерь, но и с новым оффером или укреплением текущей позиции</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515452604.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Новые горизонты»</h3>
                            <p>Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции, как выбрать новую сферу и стать в ней востребованным</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515478858.png" alt="">
                        </div>
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Секреты нетворкинга»</h3>
                            <p>Построите для себя сильное окружение и превратите нетворкинг в эффективный инструмент достижения своих карьерных целей, даже если вы интроверт</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515500185.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Релокация и поиск работы за рубежом»</h3>
                            <p>Узнаете всё о работе и учебе в разных странах, получите инструменты для поиска оффера в новой географии</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515519773.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>
                <div>
                    <div>
                        <div>
                            <h3>«Dream Team»</h3>
                            <p>Прокачаете навык управления проектами и научитесь экологично и эффективно достигать целей, благодаря командной работе</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515542139.png" alt="">
                        </div>
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>              
                <div>
                    <div>
                        <div>
                            <h3>«Высокий старт: как попасть в консалтинг»</h3>
                            <p>Узнаете, как получить работу в одной из самых высокооплачиваемых сфер благодаря инсайдерской информации</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515563631.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>               
                <div>
                    <div>
                        <div>
                            <h3>«Зарубежное образование»</h3>
                            <p>Определите, как образование поможет вам достичь карьерных целей, и начнете процесс подготовки</p>
                            
                        </div>       
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515580279.png" alt="">
                        </div> 
                    </div>
                    <a href="#">Узнать, что входит</a>
                </div>                
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
            <a href="#">Записаться в лист ожидания</a>
        </div>
    </div>`
	});

    blockManager.add('carrerum-club-tracks-mobile', {
        label: 'Треки в клубе (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-club-tracks-mobile">
        <div>
        <h2>Треки, по которым вы можете пойти в клубе</h2>
        <div class="slider slider-block slider-ways">
            <div>
                <div>
                    <div>
                        <h3>«Звездный кандидат»</h3>
                        <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620431294153.png" alt="">
                    </div> 
                </div>
                <a href="#popup-track-mobile">Узнать, что входит</a>                    
            </div>                
            <div>
                <div>
                    <div>
                        <h3>«Карьерная ракета»</h3>
                        <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515246130.png" alt="">
                    </div>  
                </div>
                <a href="#">Узнать, что входит</a>   
            </div>                
            <div>
                <div>
                    <div>
                        <h3>«Жизнь после оффера»</h3>
                        <p>Научитесь быстро и эффективно вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515315780.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>      
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Самооценка 2.0»</h3>
                        <p>Прокачаете уверенность в своих силах и избавитесь от перфекционизма и синдрома самозванца, чтобы покорять новые карьерные вершины</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515339823.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Real Me: как найти себя в работе и жизни»</h3>
                        <p>Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515363508.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>     
            </div>                
            <div>
                <div>
                    <div>
                        <h3>«Работать не 24/7, а головой»</h3>
                        <p>Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515388064.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Карьера без стресса»</h3>
                        <p>Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515410983.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Выход из декрета»</h3>
                        <p>Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом и легко находить высокооплачиваемую работу</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515431563.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Антикризис: как из лимонов делать лимонад»</h3>
                        <p>Узнаете, как подготовиться к кризису и пережить его не только без потерь, но и с новым оффером или укреплением текущей позиции</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515452604.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Новые горизонты»</h3>
                        <p>Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции, как выбрать новую сферу и стать в ней востребованным</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515478858.png" alt="">
                    </div>
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Секреты нетворкинга»</h3>
                        <p>Построите для себя сильное окружение и превратите нетворкинг в эффективный инструмент достижения своих карьерных целей, даже если вы интроверт</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515500185.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Релокация и поиск работы за рубежом»</h3>
                        <p>Узнаете всё о работе и учебе в разных странах, получите инструменты для поиска оффера в новой географии</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515519773.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>
            <div>
                <div>
                    <div>
                        <h3>«Dream Team»</h3>
                        <p>Прокачаете навык управления проектами и научитесь экологично и эффективно достигать целей, благодаря командной работе</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515542139.png" alt="">
                    </div>
                </div>
                <a href="#">Узнать, что входит</a>
            </div>              
            <div>
                <div>
                    <div>
                        <h3>«Высокий старт: как попасть в консалтинг»</h3>
                        <p>Узнаете, как получить работу в одной из самых высокооплачиваемых сфер благодаря инсайдерской информации</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515563631.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>               
            <div>
                <div>
                    <div>
                        <h3>«Зарубежное образование»</h3>
                        <p>Определите, как образование поможет вам достичь карьерных целей, и начнете процесс подготовки</p>
                        
                    </div>       
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620515580279.png" alt="">
                    </div> 
                </div>
                <a href="#">Узнать, что входит</a>
            </div>                
        </div>
        <a href="#">Записаться в лист ожидания</a>
    </div>
        </div>`
	});



    /* CURATORS */

    blockManager.add('carrerum-curators', {
        label: 'Кураторы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-curators">
        <div>
            <div>
                <h2>Катализатор вашего обучения на треках — кураторы</h2>
                <p>На нетворкинговой платформе с вами свяжутся <span>Астра и Светлана</span>, помогут определиться с запросом и выбрать нужные материалы. А потом — будут вашими личными коучами все время пребывания в клубе: поддержат на пути к цели, ответят на вопросы, помогут разобраться в сложной рабочей ситуации.</p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620808626989.png" alt="">
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-curators-tablet', {
        label: 'Кураторы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-curators-tablet">
        <div>
            <div>
                <h2>Катализатор вашего обучения на треках — кураторы</h2>
                <p>На нетворкинговой платформе с вами свяжутся <span>Астра и Светлана</span>, помогут определиться с запросом и выбрать нужные материалы. А потом — будут вашими личными коучами все время пребывания в клубе: поддержат на пути к цели, ответят на вопросы, помогут разобраться в сложной рабочей ситуации.</p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620808626989.png" alt="">
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-curators-mobile', {
        label: 'Кураторы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-curators-mobile">
        <div>
            <div>
                <h2>Катализатор вашего обучения на треках — кураторы</h2>
                <p>На нетворкинговой платформе с вами свяжутся <span>Астра и Светлана</span>, помогут определиться с запросом и выбрать нужные материалы. А потом — будут вашими личными коучами все время пребывания в клубе: поддержат на пути к цели, ответят на вопросы, помогут разобраться в сложной рабочей ситуации.</p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620808626989.png" alt="">
            </div>
        </div>
    </div>
    `});


    /* EXPERTS */

    blockManager.add('carrerum-experts', {
        label: 'Эксперты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts">
        <div>
            <h2>Наши эксперты</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809247721.png" alt="">
                    <h3>Ольга Лермонтова</h3>
                    <h4>Италия, MBA, ex-Google, <br> ex-Microsoft</h4>
                    <p>Основательница Карьерума, сертифицированный коуч, эксперт в вопросах развития карьеры</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809264453.png" alt="">
                    <h3>Анна Бабич</h3>
                    <h4>Россия, Сбербанк, Мегафон, 2GIS</h4>
                    <p>Психолог и эксперт по самооценке, корпоративный тренер топ-компаний</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809283563.png" alt="">
                    <h3>Санжар Ибрагимов</h3>
                    <h4>Финляндия, MBA, <br> ex-McKinsey</h4>
                    <p>Эксперт в сфере консалтинга с 15-летним опытом международной карьеры в McKinsey и других компаниях</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809298160.png" alt="">
                    <h3>Sophie Vurpillot</h3>
                    <h4>Испания, бизнес-школа <br> ESCP</h4>
                    <p>Международный рекрутер, ментор и коуч парижской бизнес-школы ESCP</p>
                </div>
            </div>
            <a href="#">Смотреть еще 18 экспертов клуба</a>                        
        </div>
    </div>
    `});

    blockManager.add('carrerum-experts-tablet', {
        label: 'Эксперты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts-tablet">
        <div>
            <h2>Наши эксперты</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809247721.png" alt="">
                    <h3>Ольга <br> Лермонтова</h3>
                    <h4>Италия, MBA, ex-Google, <br> ex-Microsoft</h4>
                    <p>Основательница Карьерума, сертифицированный коуч, эксперт в вопросах развития карьеры</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809264453.png" alt="">
                    <h3>Анна <br> Бабич</h3>
                    <h4>Россия, Сбербанк, Мегафон, 2GIS</h4>
                    <p>Психолог и эксперт по самооценке, корпоративный тренер топ-компаний</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809283563.png" alt="">
                    <h3>Санжар <br> Ибрагимов</h3>
                    <h4>Финляндия, MBA, <br> ex-McKinsey</h4>
                    <p>Эксперт в сфере консалтинга с 15-летним опытом международной карьеры в McKinsey и других компаниях</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809298160.png" alt="">
                    <h3>Sophie <br> Vurpillot</h3>
                    <h4>Испания, бизнес-школа <br> ESCP</h4>
                    <p>Международный рекрутер, ментор и коуч парижской бизнес-школы ESCP</p>
                </div>
            </div>
            <a href="#">Смотреть еще 18 экспертов</a>                        
        </div>
    </div>
    `});

    blockManager.add('carrerum-experts-mobile', {
        label: 'Эксперты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts-mobile">
        <div>
            <h2>Наши эксперты</h2>
            <div class="slider-block slider-carrerum-experts">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809247721.png" alt="">
                    <h3>Ольга <br> Лермонтова</h3>
                    <h4>Италия, MBA, ex-Google, <br> ex-Microsoft</h4>
                    <p>Основательница Карьерума, сертифицированный коуч, эксперт в вопросах развития карьеры</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809264453.png" alt="">
                    <h3>Анна <br> Бабич</h3>
                    <h4>Россия, Сбербанк, Мегафон, 2GIS</h4>
                    <p>Психолог и эксперт по самооценке, корпоративный тренер топ-компаний</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809283563.png" alt="">
                    <h3>Санжар <br> Ибрагимов</h3>
                    <h4>Финляндия, MBA, <br> ex-McKinsey</h4>
                    <p>Эксперт в сфере консалтинга с 15-летним опытом международной карьеры в McKinsey и других компаниях</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620809298160.png" alt="">
                    <h3>Sophie <br> Vurpillot</h3>
                    <h4>Испания, бизнес-школа <br> ESCP</h4>
                    <p>Международный рекрутер, ментор и коуч парижской бизнес-школы ESCP</p>
                </div>
            </div>
            <a href="#">Смотреть еще 18 экспертов</a>                        
        </div>
    </div>
    `});



    /* EVENTS */

    blockManager.add('carrerum-events', {
        label: 'Ближайшие мероприятия',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-events">
        <div>
            <h2>
                Ближайшие мероприятия клуба
            </h2>
            <div>
                <div>
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>19 апреля, 20:00 МСК</p>
                        <h3>Встреча в «Космосе» с Екатериной Громовой</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>28 апреля, 20:00 МСК</p>
                        <h3>Воркшоп «Data-driven: как работать с данными, чтобы принимать решения»</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-events-tablet', {
        label: 'Ближайшие мероприятия (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-events-tablet">
        <div>
            <h2>
                Ближайшие мероприятия клуба
            </h2>
            <div>
                <div>
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>19 апреля, 20:00 МСК</p>
                        <h3>Встреча в «Космосе» с Екатериной Громовой</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>28 апреля, 20:00 МСК</p>
                        <h3>Воркшоп «Data-driven: как работать с данными, чтобы принимать решения»</h3>
                    </div>
                </div>
                <div>
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-events-mobile', {
        label: 'Ближайшие мероприятия (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-events-mobile">
        <div>
            <h2>
                Ближайшие мероприятия клуба
            </h2>
            <div class="slider-block slider-events">
                <div class="event1">
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
                <div class="event2">
                    <div>
                        <p>19 апреля, 20:00 МСК</p>
                        <h3>Встреча в «Космосе» с Екатериной Громовой</h3>
                    </div>
                </div>
                <div class="event3">
                    <div>
                        <p>28 апреля, 20:00 МСК</p>
                        <h3>Воркшоп «Data-driven: как работать с данными, чтобы принимать решения»</h3>
                    </div>
                </div>
                <div class="event4">
                    <div>
                        <p>10 апреля, 12:00 МСК</p>
                        <h3>Рубрика «Профориентация». «Data- и не только: какие аналитики нужны в IT»</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `});



    /* OFFERS */

    blockManager.add('carrerum-offers', {
        label: 'Офферы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-offers">
        <div>
            <h2>Все возможности клуба доступны по подписке — наши участники не доплачивают за новые мероприятия</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811605674.png" alt="">
                    </div>
                    
                    <h3>1 месяц</h3>
                    <p>Вы протестируете для себя формат клуба, начнете строить нетворк и сделаете первые шаги к своей карьерной цели — повышению, релокации, офферу</p>
                    <div>
                        <span></span>
                        <span>8 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811669457.png" alt="">
                    </div>
                    
                    <h3>12 месяца</h3>
                    <p>Вы глубоко погрузитесь в свой запрос — поймете, чего хотите от карьеры, найдете работу, получите повышение, создадите собственное сильное окружение</p>
                    <div>
                        <span>106 800 ₽</span>
                        <span>89 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811688709.png" alt="">
                    </div>
                    
                    <h3>18 месяцев</h3>
                    <p>Вы станете гуру осознанной карьеры, научитесь всегда работать в удовольствие, укрепите нужные вам soft skills и решите любые карьерные задачи</p>
                    <div>
                        <span>160 200 ₽</span>
                        <span>129 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-offers-tablet', {
        label: 'Офферы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-offers-tablet">
        <div>
            <h2>Все возможности клуба доступны по подписке — наши участники не доплачивают за новые мероприятия</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811605674.png" alt="">
                    </div>
                    
                    <h3>1 месяц</h3>
                    <p>Вы протестируете для себя формат клуба, начнете строить нетворк и сделаете первые шаги к своей карьерной цели — повышению, релокации, офферу</p>
                    <div>
                        <span></span>
                        <span>8 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811669457.png" alt="">
                    </div>
                    
                    <h3>12 месяца</h3>
                    <p>Вы глубоко погрузитесь в свой запрос — поймете, чего хотите от карьеры, найдете работу, получите повышение, создадите собственное сильное окружение</p>
                    <div>
                        <span>106 800 ₽</span>
                        <span>89 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811688709.png" alt="">
                    </div>
                    
                    <h3>18 месяцев</h3>
                    <p>Вы станете гуру осознанной карьеры, научитесь всегда работать в удовольствие, укрепите нужные вам soft skills и решите любые карьерные задачи</p>
                    <div>
                        <span>160 200 ₽</span>
                        <span>129 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-offers-mobile', {
        label: 'Офферы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-offers-mobile">
        <div>
            <h2>Все возможности клуба доступны по подписке — наши участники не доплачивают за новые мероприятия</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811605674.png" alt="">
                    </div>
                    
                    <h3>1 месяц</h3>
                    <p>Вы протестируете для себя формат клуба, начнете строить нетворк и сделаете первые шаги к своей карьерной цели — повышению, релокации, офферу</p>
                    <div>
                        <span></span>
                        <span>8 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811669457.png" alt="">
                    </div>
                    
                    <h3>12 месяца</h3>
                    <p>Вы глубоко погрузитесь в свой запрос — поймете, чего хотите от карьеры, найдете работу, получите повышение, создадите собственное сильное окружение</p>
                    <div>
                        <span>106 800 ₽</span>
                        <span>89 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620811688709.png" alt="">
                    </div>
                    
                    <h3>18 месяцев</h3>
                    <p>Вы станете гуру осознанной карьеры, научитесь всегда работать в удовольствие, укрепите нужные вам soft skills и решите любые карьерные задачи</p>
                    <div>
                        <span>160 200 ₽</span>
                        <span>129 900 ₽</span>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    `});


    /* TEXT-COLUMNS */

    blockManager.add('carrerum-text-columns', {
        label: 'Текст 3 колонки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-columns">
        <div>
            <h2>Сейчас вход в клуб закрыт: оформить подписку можно только 3-4 раза в год. Почему?</h2>
            <div>
                <div>
                    <h4>Количество участников в клубе ограничено <br>&nbsp;<br>&nbsp;</h4>
                    <p>Наша задача — установить коннект с каждым из вас. Мы помогаем составить индивидуальный план развития и поддерживаем клубовцев на протяжении всего обучения.</p>
                </div>
                <div>
                    <h4>Мы опираемся на циклы карьерного года — пиковые сезоны поиска работы и повышений</h4>
                    <p>Лучшая информация — та, которая приходит вовремя. Поэтому клуб открывается именно тогда, когда для вас это может быть наиболее актуально. Например, если вы вступаете в клуб, чтобы сменить работу, эффективнее будет это сделать в период, когда компании активнее всего нанимают новых сотрудников.
                    </p>
                </div>
                <div>
                    <h4>Мы даем возможность живого, интерактивного обучения<br>&nbsp;<br>&nbsp;</h4>
                    <p>Окна входа в клуб открываются одновременно с появлением новых live-программ. Вебинары и эфиры, которые выходят между окнами, будут доступны новым участникам в записи.
                    </p>
                </div>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-text-columns-tablet', {
        label: 'Текст 3 колонки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-columns-tablet">
        <div>
            <h2>Сейчас вход в клуб закрыт: оформить подписку можно только 3-4 раза в год. Почему?</h2>
            <div>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Количество участников в клубе ограничено</h3>
                                <p>В клубе собираются люди с разными целями. Кто-то хочет вырасти до СЕО, кто-то — определить свою профессиональную миссию, а кто-то — вернуть себе жизненный баланс. Всех этих людей объединяет желание реализоваться, получать больше энергии от своей работы, ставить цели и уверенно достигать их. Если эти ценности близки вам — добро пожаловать в клуб. И неважно, где и кем вы работаете.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Мы опираемся на циклы карьерного года — пиковые сезоны поиска работы и повышений</h3>
                                <p>Лучшая информация — та, которая приходит вовремя. Поэтому клуб открывается именно тогда, когда для вас это может быть наиболее актуально. Например, если вы вступаете в клуб, чтобы сменить работу, эффективнее будет это сделать в период, когда компании активнее всего нанимают новых сотрудников.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Мы даем возможность живого, интерактивного обучения</h3>
                                <p>Окна входа в клуб открываются одновременно с появлением новых live-программ. Вебинары и эфиры, которые выходят между окнами, будут доступны новым участникам в записи.</p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-text-columns-mobile', {
        label: 'Текст 3 колонки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-columns-mobile">
        <div>
            <h2>Сейчас вход в клуб закрыт: оформить подписку можно только 3-4 раза в год. Почему?</h2>
            <div>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Количество участников в клубе ограничено</h3>
                                <p>В клубе собираются люди с разными целями. Кто-то хочет вырасти до СЕО, кто-то — определить свою профессиональную миссию, а кто-то — вернуть себе жизненный баланс. Всех этих людей объединяет желание реализоваться, получать больше энергии от своей работы, ставить цели и уверенно достигать их. Если эти ценности близки вам — добро пожаловать в клуб. И неважно, где и кем вы работаете.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Мы опираемся на циклы карьерного года — пиковые сезоны поиска работы и повышений</h3>
                                <p>Лучшая информация — та, которая приходит вовремя. Поэтому клуб открывается именно тогда, когда для вас это может быть наиболее актуально. Например, если вы вступаете в клуб, чтобы сменить работу, эффективнее будет это сделать в период, когда компании активнее всего нанимают новых сотрудников.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Мы даем возможность живого, интерактивного обучения</h3>
                                <p>Окна входа в клуб открываются одновременно с появлением новых live-программ. Вебинары и эфиры, которые выходят между окнами, будут доступны новым участникам в записи.</p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    `});


    /* FAQ-2 */

    blockManager.add('carrerum-faq2', {
        label: 'FAQ-2',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-faq2">
        <div>
            <h2>Остались вопросы?</h2>
            <div>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Там у вас, наверное, одни топ-менеджеры, а я линейный сотрудник. Мне нельзя?</h3>
                                <p>В клубе собираются люди с разными целями. Кто-то хочет вырасти до СЕО, кто-то — определить свою профессиональную миссию, а кто-то — вернуть себе жизненный баланс. Всех этих людей объединяет желание реализоваться, получать больше энергии от своей работы, ставить цели и уверенно достигать их. Если эти ценности близки вам — добро пожаловать в клуб. И неважно, где и кем вы работаете.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я хочу стать маркетологом, но ничего об этом не знаю, поможете?</h3>
                                <p>Клуб — не школа профессий, где вы получите новую специальность. Мы помогаем развивать карьерные навыки — строить отношения с коллегами и руководителем, адаптироваться на новом месте, доносить свою ценность через интервью. С нами вы разберетесь, подходит ли вам профессия маркетолога, составите карьерный план и научитесь позиционировать себя.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я предприниматель, мне к вам нельзя?</h3>
                                <p>Не думайте, будто карьерный клуб — только для сотрудников в найме и тех, кто хочет идти вверх по карьерной лестнице. К нам часто присоединяются владельцы своего бизнеса, так как для них тоже важно не выгорать, укреплять свою самооценку и грамотно ставить цели. Этому у нас и учатся предприниматели и фрилансеры из разных сфер — архитектуры, юриспруденции, моды, IT и многих других.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я только из университета/выхожу из декрета/переезжаю в другую страну, мне нужно в клуб?</h3>
                                <p>Лучшее время начать — сейчас, в какой бы точке вы ни находились. Многие участники клуба присылают нам письма, в которых благодарят за материалы, делятся успехами и жалеют только об одном — что не пришли раньше. Если вы хотите по-новому строить карьеру, то клуб для вас — неважно, вы только начинаете или у вас уже 10+ лет опыта.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня уже есть работа, и она мне нравится. Нужен ли мне клуб?</h3>
                                <p>Смена работы — лишь эпизод на фоне всей карьеры. Поэтому если вы не планируете искать работу, есть другие задачи — расти, строить личный бренд, укреплять рабочие отношения, повышать продуктивность, оберегать work-life balance. Все это можно делать в Карьерум.Клубе. И конечно, с нами вы сформируете устойчивость к внезапным кризисам и сокращениям. Если в какой-то момент вы потеряете работу или захотите сменить ее, то уже не будете в панике бегать по рынку.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Почему нельзя купить доступ ко всем материалам без сообщества?</h3>
                                <p>В сообществе работа пойдет быстрее. Вы будете проходить курсы в группах с другими участниками, делиться опытом. Там же вам напишут кураторы — с их поддержкой путь к цели будет не таким тернистым. А вы сами сможете написать Ольге, CV-специалисту и другим экспертам из разных сфер и стран. Сильное окружение поможет найти в себе ресурсы, о которых вы не знали.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я не хочу ни с кем общаться?</h3>
                                <p>Мы ценим выбор клубовцев, которые предпочитают работать самостоятельно. Поэтому давить не будем — вы даже можете отказаться от помощи кураторов, если вам некомфортно получать сообщения. Но если вам захочется общения и поддержки, мы всегда будем на связи.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>В клубе надо много и плотно заниматься, верно? У меня совсем нет времени.</h3>
                                <p>В клубе каждый работает в своем темпе. Все курсы разбиты на небольшие уроки с заданиями, чтобы вы могли уделять обучению 15-30 минут в день, если больше времени у вас нет. Постепенно проходить материалы — эффективнее, чем один трехчасовой тренинг за раз на скорости x2. К тому же, в клубе не обязательно изучать все — на старте вы с куратором выстроите свой личный образовательный трек.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня будет доступ только к будущим мероприятиям из расписания?</h3>
                                <p>Нет. В клубе есть обширная библиотека уже готовых материалов в записи. Курсы, вебинары, мастер-классы по разным темам — более 250 часов! Вы можете выбрать подходящий материал сразу после оформления подписки и начать путь к своей цели, не дожидаясь появления нового.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Если я захочу выйти из клуба, я могу вернуться в любой момент?</h3>
                                <p>Да. Но прежде чем принять решение об отписке, учтите важный момент. Мы постоянно работаем над новыми обучающими мероприятиями, запускаем новые сервисы, организуем групповые активности. Потому ценность клуба будет расти — справедливо, что цена тоже. Для действующих участников клуба стоимость всегда остается той, по которой они вошли. Лучшее — постоянным и лояльным. Потому если вы отмените подписку, то сможете вернуться в клуб по актуальной на момент входа цене.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Можно ли каким-то образом оформить подписку дешевле?</h3>
                                <p>Можно. Со второго месяца подписки вы сможете перейти на тариф Live — 4900 рублей в месяц. Он включает всё, кроме доступа к библиотеке материалов: нетворкинг в сообществе с профессионалами со всего мира, вебинары экспертов в прямом эфире, обратную связь кураторов, поддержку Ольги и команды клуба. Вы сможете легко отрабатывать все знания, полученные в библиотеке.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>И больше никаких распродаж и скидок?</h3>
                                <p>Мы очень ценим вас — тех, кто строит осознанную карьеру и выбирает наш клуб. Потому мы ввели программу лояльности: <br><br>
                                    - После оплаты третьего месяца вы получаете неделю бесплатно.<br>
                                    - После оплаты седьмого месяца — еще две недели.<br><br>
                                    А если вы примете участие в нашей реферальной программе и пригласите друга, то получите на свой бонусный счет 30% от стоимости его подписки. Приглашаете троих друзей — и вы в клубе почти даром! Этими бонусами вы сможете оплатить свое дальнейшее обучение в клубе.
                                    </p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-faq2-tablet', {
        label: 'FAQ-2 (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-faq2-tablet">
        <div>
            <h2>Остались вопросы?</h2>
            <div>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Там у вас, наверное, одни топ-менеджеры, а я линейный сотрудник. Мне нельзя?</h3>
                                <p>В клубе собираются люди с разными целями. Кто-то хочет вырасти до СЕО, кто-то — определить свою профессиональную миссию, а кто-то — вернуть себе жизненный баланс. Всех этих людей объединяет желание реализоваться, получать больше энергии от своей работы, ставить цели и уверенно достигать их. Если эти ценности близки вам — добро пожаловать в клуб. И неважно, где и кем вы работаете.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я хочу стать маркетологом, но ничего об этом не знаю, поможете?</h3>
                                <p>Клуб — не школа профессий, где вы получите новую специальность. Мы помогаем развивать карьерные навыки — строить отношения с коллегами и руководителем, адаптироваться на новом месте, доносить свою ценность через интервью. С нами вы разберетесь, подходит ли вам профессия маркетолога, составите карьерный план и научитесь позиционировать себя.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я предприниматель, мне к вам нельзя?</h3>
                                <p>Не думайте, будто карьерный клуб — только для сотрудников в найме и тех, кто хочет идти вверх по карьерной лестнице. К нам часто присоединяются владельцы своего бизнеса, так как для них тоже важно не выгорать, укреплять свою самооценку и грамотно ставить цели. Этому у нас и учатся предприниматели и фрилансеры из разных сфер — архитектуры, юриспруденции, моды, IT и многих других.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я только из университета/выхожу из декрета/переезжаю в другую страну, мне нужно в клуб?</h3>
                                <p>Лучшее время начать — сейчас, в какой бы точке вы ни находились. Многие участники клуба присылают нам письма, в которых благодарят за материалы, делятся успехами и жалеют только об одном — что не пришли раньше. Если вы хотите по-новому строить карьеру, то клуб для вас — неважно, вы только начинаете или у вас уже 10+ лет опыта.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня уже есть работа, и она мне нравится. Нужен ли мне клуб?</h3>
                                <p>Смена работы — лишь эпизод на фоне всей карьеры. Поэтому если вы не планируете искать работу, есть другие задачи — расти, строить личный бренд, укреплять рабочие отношения, повышать продуктивность, оберегать work-life balance. Все это можно делать в Карьерум.Клубе. И конечно, с нами вы сформируете устойчивость к внезапным кризисам и сокращениям. Если в какой-то момент вы потеряете работу или захотите сменить ее, то уже не будете в панике бегать по рынку.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Почему нельзя купить доступ ко всем материалам без сообщества?</h3>
                                <p>В сообществе работа пойдет быстрее. Вы будете проходить курсы в группах с другими участниками, делиться опытом. Там же вам напишут кураторы — с их поддержкой путь к цели будет не таким тернистым. А вы сами сможете написать Ольге, CV-специалисту и другим экспертам из разных сфер и стран. Сильное окружение поможет найти в себе ресурсы, о которых вы не знали.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я не хочу ни с кем общаться?</h3>
                                <p>Мы ценим выбор клубовцев, которые предпочитают работать самостоятельно. Поэтому давить не будем — вы даже можете отказаться от помощи кураторов, если вам некомфортно получать сообщения. Но если вам захочется общения и поддержки, мы всегда будем на связи.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>В клубе надо много и плотно заниматься, верно? У меня совсем нет времени.</h3>
                                <p>В клубе каждый работает в своем темпе. Все курсы разбиты на небольшие уроки с заданиями, чтобы вы могли уделять обучению 15-30 минут в день, если больше времени у вас нет. Постепенно проходить материалы — эффективнее, чем один трехчасовой тренинг за раз на скорости x2. К тому же, в клубе не обязательно изучать все — на старте вы с куратором выстроите свой личный образовательный трек.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня будет доступ только к будущим мероприятиям из расписания?</h3>
                                <p>Нет. В клубе есть обширная библиотека уже готовых материалов в записи. Курсы, вебинары, мастер-классы по разным темам — более 250 часов! Вы можете выбрать подходящий материал сразу после оформления подписки и начать путь к своей цели, не дожидаясь появления нового.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Если я захочу выйти из клуба, я могу вернуться в любой момент?</h3>
                                <p>Да. Но прежде чем принять решение об отписке, учтите важный момент. Мы постоянно работаем над новыми обучающими мероприятиями, запускаем новые сервисы, организуем групповые активности. Потому ценность клуба будет расти — справедливо, что цена тоже. Для действующих участников клуба стоимость всегда остается той, по которой они вошли. Лучшее — постоянным и лояльным. Потому если вы отмените подписку, то сможете вернуться в клуб по актуальной на момент входа цене.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Можно ли каким-то образом оформить подписку дешевле?</h3>
                                <p>Можно. Со второго месяца подписки вы сможете перейти на тариф Live — 4900 рублей в месяц. Он включает всё, кроме доступа к библиотеке материалов: нетворкинг в сообществе с профессионалами со всего мира, вебинары экспертов в прямом эфире, обратную связь кураторов, поддержку Ольги и команды клуба. Вы сможете легко отрабатывать все знания, полученные в библиотеке.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>И больше никаких распродаж и скидок?</h3>
                                <p>Мы очень ценим вас — тех, кто строит осознанную карьеру и выбирает наш клуб. Потому мы ввели программу лояльности: <br><br>
                                    - После оплаты третьего месяца вы получаете неделю бесплатно.<br>
                                    - После оплаты седьмого месяца — еще две недели.<br><br>
                                    А если вы примете участие в нашей реферальной программе и пригласите друга, то получите на свой бонусный счет 30% от стоимости его подписки. Приглашаете троих друзей — и вы в клубе почти даром! Этими бонусами вы сможете оплатить свое дальнейшее обучение в клубе.
                                    </p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-faq2-mobile', {
        label: 'FAQ-2 (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-faq2-mobile">
        <div>
            <h2>Остались вопросы?</h2>
            <div>
                <ul>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Там у вас, наверное, одни топ-менеджеры, а я линейный сотрудник. Мне нельзя?</h3>
                                <p>В клубе собираются люди с разными целями. Кто-то хочет вырасти до СЕО, кто-то — определить свою профессиональную миссию, а кто-то — вернуть себе жизненный баланс. Всех этих людей объединяет желание реализоваться, получать больше энергии от своей работы, ставить цели и уверенно достигать их. Если эти ценности близки вам — добро пожаловать в клуб. И неважно, где и кем вы работаете.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я хочу стать маркетологом, но ничего об этом не знаю, поможете?</h3>
                                <p>Клуб — не школа профессий, где вы получите новую специальность. Мы помогаем развивать карьерные навыки — строить отношения с коллегами и руководителем, адаптироваться на новом месте, доносить свою ценность через интервью. С нами вы разберетесь, подходит ли вам профессия маркетолога, составите карьерный план и научитесь позиционировать себя.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я предприниматель, мне к вам нельзя?</h3>
                                <p>Не думайте, будто карьерный клуб — только для сотрудников в найме и тех, кто хочет идти вверх по карьерной лестнице. К нам часто присоединяются владельцы своего бизнеса, так как для них тоже важно не выгорать, укреплять свою самооценку и грамотно ставить цели. Этому у нас и учатся предприниматели и фрилансеры из разных сфер — архитектуры, юриспруденции, моды, IT и многих других.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Я только из университета/выхожу из декрета/переезжаю в другую страну, мне нужно в клуб?</h3>
                                <p>Лучшее время начать — сейчас, в какой бы точке вы ни находились. Многие участники клуба присылают нам письма, в которых благодарят за материалы, делятся успехами и жалеют только об одном — что не пришли раньше. Если вы хотите по-новому строить карьеру, то клуб для вас — неважно, вы только начинаете или у вас уже 10+ лет опыта.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня уже есть работа, и она мне нравится. Нужен ли мне клуб?</h3>
                                <p>Смена работы — лишь эпизод на фоне всей карьеры. Поэтому если вы не планируете искать работу, есть другие задачи — расти, строить личный бренд, укреплять рабочие отношения, повышать продуктивность, оберегать work-life balance. Все это можно делать в Карьерум.Клубе. И конечно, с нами вы сформируете устойчивость к внезапным кризисам и сокращениям. Если в какой-то момент вы потеряете работу или захотите сменить ее, то уже не будете в панике бегать по рынку.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Почему нельзя купить доступ ко всем материалам без сообщества?</h3>
                                <p>В сообществе работа пойдет быстрее. Вы будете проходить курсы в группах с другими участниками, делиться опытом. Там же вам напишут кураторы — с их поддержкой путь к цели будет не таким тернистым. А вы сами сможете написать Ольге, CV-специалисту и другим экспертам из разных сфер и стран. Сильное окружение поможет найти в себе ресурсы, о которых вы не знали.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А если я не хочу ни с кем общаться?</h3>
                                <p>Мы ценим выбор клубовцев, которые предпочитают работать самостоятельно. Поэтому давить не будем — вы даже можете отказаться от помощи кураторов, если вам некомфортно получать сообщения. Но если вам захочется общения и поддержки, мы всегда будем на связи.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>В клубе надо много и плотно заниматься, верно? У меня совсем нет времени.</h3>
                                <p>В клубе каждый работает в своем темпе. Все курсы разбиты на небольшие уроки с заданиями, чтобы вы могли уделять обучению 15-30 минут в день, если больше времени у вас нет. Постепенно проходить материалы — эффективнее, чем один трехчасовой тренинг за раз на скорости x2. К тому же, в клубе не обязательно изучать все — на старте вы с куратором выстроите свой личный образовательный трек.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>А у меня будет доступ только к будущим мероприятиям из расписания?</h3>
                                <p>Нет. В клубе есть обширная библиотека уже готовых материалов в записи. Курсы, вебинары, мастер-классы по разным темам — более 250 часов! Вы можете выбрать подходящий материал сразу после оформления подписки и начать путь к своей цели, не дожидаясь появления нового.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Если я захочу выйти из клуба, я могу вернуться в любой момент?</h3>
                                <p>Да. Но прежде чем принять решение об отписке, учтите важный момент. Мы постоянно работаем над новыми обучающими мероприятиями, запускаем новые сервисы, организуем групповые активности. Потому ценность клуба будет расти — справедливо, что цена тоже. Для действующих участников клуба стоимость всегда остается той, по которой они вошли. Лучшее — постоянным и лояльным. Потому если вы отмените подписку, то сможете вернуться в клуб по актуальной на момент входа цене.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>Можно ли каким-то образом оформить подписку дешевле?</h3>
                                <p>Можно. Со второго месяца подписки вы сможете перейти на тариф Live — 4900 рублей в месяц. Он включает всё, кроме доступа к библиотеке материалов: нетворкинг в сообществе с профессионалами со всего мира, вебинары экспертов в прямом эфире, обратную связь кураторов, поддержку Ольги и команды клуба. Вы сможете легко отрабатывать все знания, полученные в библиотеке.</p>
                            </div>
                        </label>
                    </li>
                    <li>
                        <label>
                            <input type="checkbox">
                            <div>
                                <h3>И больше никаких распродаж и скидок?</h3>
                                <p>Мы очень ценим вас — тех, кто строит осознанную карьеру и выбирает наш клуб. Потому мы ввели программу лояльности: <br><br>
                                    - После оплаты третьего месяца вы получаете неделю бесплатно.<br>
                                    - После оплаты седьмого месяца — еще две недели.<br><br>
                                    А если вы примете участие в нашей реферальной программе и пригласите друга, то получите на свой бонусный счет 30% от стоимости его подписки. Приглашаете троих друзей — и вы в клубе почти даром! Этими бонусами вы сможете оплатить свое дальнейшее обучение в клубе.
                                    </p>
                            </div>
                        </label>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    `});


    /* TRY START */

    blockManager.add('carrerum-try-start', {
        label: 'Попробуй СТАРТ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-try-start">
        <div>
            <div>
                <h3>Если вы чувствуете, что пока не готовы вступать в клуб, но все-таки хотите сделать новый шаг в карьере — попробуйте <span>Карьерум.Старт</span></h3>
                <a href="#">Попробовать</a>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815049759.png" alt="">
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-try-start-tablet', {
        label: 'Попробуй СТАРТ (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-try-start-tablet">
        <div>
            <div>
                <h3>Если вы чувствуете, что пока не готовы вступать в клуб, но все-таки хотите сделать новый шаг в карьере — попробуйте <span>Карьерум.Старт</span></h3>
                <a href="#">Попробовать</a>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815049759.png" alt="">
            </div>
        </div>
    </div>
    `});

    blockManager.add('carrerum-try-start-mobile', {
        label: 'Попробуй СТАРТ (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-try-start-mobile">
        <div>
            <div>
                <h3>Если вы чувствуете, что пока не готовы вступать в клуб, но все-таки хотите сделать новый шаг в карьере — попробуйте <span>Карьерум.Старт</span></h3>
                <a href="#">Попробовать</a>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815049759.png" alt="">
            </div>
        </div>
    </div>
    `});


    /* POPUP TRACK */

    blockManager.add('carrerum-popup-track', {
        label: 'Попап для трека',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-track carrerum-popup">    
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815875011.png" alt="">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815903390.png" alt="">
            <h3>«Звездный кандидат»</h3>
            <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
            <ul>
                <li>Курс «Умная стратегия поиска работы»</li>
                <li>Курс «Продающее резюме»</li>
                <li>Курс «Эффективное интервью»</li>
                <li>Мастер-класс о переговорах по зарплате «Great Deal: как получить оффер мечты»</li>
                <li>Вебинар «Карьера в кризис: как найти и не потерять работу»</li>
            </ul>
            <a href="#">Начать прохождение</a>
        </div>
    </div>
    `});

    blockManager.add('carrerum-popup-track-tablet', {
        label: 'Попап для трека (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-track-tablet carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815875011.png" alt="">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815903390.png" alt="">
            <h3>«Звездный кандидат»</h3>
            <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
            <ul>
                <li>Курс «Умная стратегия поиска работы»</li>
                <li>Курс «Продающее резюме»</li>
                <li>Курс «Эффективное интервью»</li>
                <li>Мастер-класс о переговорах по зарплате «Great Deal: как получить оффер мечты»</li>
                <li>Вебинар «Карьера в кризис: как найти и не потерять работу»</li>
            </ul>
            <a href="#">Начать прохождение</a>
        </div>
    </div>
    `});

    blockManager.add('carrerum-popup-track-mobile', {
        label: 'Попап для трека (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-track-mobile carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815875011.png" alt="">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815903390.png" alt="">
            <h3>«Звездный кандидат»</h3>
            <p>Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис</p>
            <ul>
                <li>Курс «Умная стратегия поиска работы»</li>
                <li>Курс «Продающее резюме»</li>
                <li>Курс «Эффективное интервью»</li>
                <li>Мастер-класс о переговорах по зарплате «Great Deal: как получить оффер мечты»</li>
                <li>Вебинар «Карьера в кризис: как найти и не потерять работу»</li>
            </ul>
            <a href="#">Начать прохождение</a>
        </div>
    </div>
    `});

	
	blockManager.add('carrerum-course-for-you-image', {
        label: 'Что курс для вас',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-course-for-you-image">
        <div>
            <div>
                <div>
                    <h2>Этот курс <span>для вас</span>, если:</h2>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242718.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p><span>Чувствуете себя ежиком в тумане</span> и не понимаете, чего хотите от своей карьеры, в какой сфере развиваться, в какую сторону копать</p>
                </div>
                <div>
                    <p><span>Думаете, что «уже поздно»</span>, «еще рано» или «не хватает опыта и навыков» для достижения целей</p>
                </div>
                <div>
                    <p><span>Или наоборот — уже устали работать в одной компании</span>, но боитесь делать следующий шаг</p>
                </div>
                <div>
                    <p><span>Недовольны текущей работой</span>, но не знаете, как конкретно это изменить</p>
                </div>
                <div>
                    <p><span>Уверены, что в карьере вы ни на что не влияете</span>, а все зависит от вашего начальника и от обстоятельств</p>
                </div>
                <div>
                    <p><span>Постоянно меняете работу</span>, но находите удовлетворение лишь на короткий срок</p>
                </div>
                <div>
                    <p><span>Чувствуете, что выгорели на работе</span>, хотя раньше она вам нравилась, а теперь тяжело про нее даже думать</p>
                </div>
            </div>
        </div>
    </div>`
	});

	blockManager.add('carrerum-course-for-you-image-mob', {
		label: 'Что курс для вас (mobile)',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `
		<div class="carrerum-course-for-you-image-mob">
        <div>
            <div>
                <div>
                    <h2>Этот курс <span>для вас</span>, если:</h2>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242718.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p><span>Чувствуете себя ежиком в тумане</span> и не понимаете, чего хотите от своей карьеры, в какой сфере развиваться, в какую сторону копать</p>
                </div>
                <div>
                    <p><span>Думаете, что «уже поздно»</span>, «еще рано» или «не хватает опыта и навыков» для достижения целей</p>
                </div>
                <div>
                    <p><span>Или наоборот — уже устали работать в одной компании</span>, но боитесь делать следующий шаг</p>
                </div>
                <div>
                    <p><span>Недовольны текущей работой</span>, но не знаете, как конкретно это изменить</p>
                </div>
                <div>
                    <p><span>Уверены, что в карьере вы ни на что не влияете</span>, а все зависит от вашего начальника и от обстоятельств</p>
                </div>
                <div>
                    <p><span>Постоянно меняете работу</span>, но находите удовлетворение лишь на короткий срок</p>
                </div>
                <div>
                    <p><span>Чувствуете, что выгорели на работе</span>, хотя раньше она вам нравилась, а теперь тяжело про нее даже думать</p>
                </div>
            </div>
        </div>
		</div>`
	});


    blockManager.add('carrerum-at-course-you', {
        label: 'На курсе вы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-at-course-you">
        <div>
            <div>
                <h2>На курсе вы:</h2>
            </div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242780.png" alt="">
                    <p>Поймете, что нужно именно вам, чтобы построить карьеру мечты и ходить на работу с радостью</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242521.png" alt="">
                    <p>Поймете, в чем по-настоящему хороши и где на рынке ваши навыки будут востребованы</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242638.png" alt="">
                    <p>Научитесь определять свои личные источники мотивации и получать от работы энергию, а не только отдавать ее</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825624660.png" alt="">
                    <p>Увидите, что вас все это время тормозило и не давало развиваться</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242652.png" alt="">
                    <p>Четко сформулируете следующий шаг в своей карьере</p>
                </div>
            </div>
            <a href="#">Начать обучение</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-at-course-you-mob', {
        label: 'На курсе вы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-at-course-you-mob">
        <div>
                <div>
                        <h2>На курсе вы:</h2>
                </div>
                <div>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242780.png" alt="">
                                <p>Поймете, что нужно именно вам, чтобы построить карьеру мечты и ходить на работу с радостью</p>
                        </div>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242521.png" alt="">
                                <p>Поймете, в чем по-настоящему хороши и где на рынке ваши навыки будут востребованы</p>
                        </div>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242638.png" alt="">
                                <p>Научитесь определять свои личные источники мотивации и получать от работы энергию, а не только отдавать ее</p>
                        </div>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825624660.png" alt="">
                                <p>Увидите, что вас все это время тормозило и не давало развиваться</p>
                        </div>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242652.png" alt="">
                                <p>Четко сформулируете следующий шаг в своей карьере</p>
                        </div>
                </div>
                <a href="#">Начать обучение</a>
        </div>
        </div>`
    });


    blockManager.add('carrerum-title-with-columns', {
        label: 'Преимущества с цифрами',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="careerum-title-with-columns">
        <h2>Карьерум — ваша возможность покорить любую страну, индустрию, компанию. Уже 5000+ выпускников из</h2>
        <div>
            <div>
                <h3>1000+</h3>
                <p>компаний</p>
            </div>
            <div>
                <h3>28</h3>
                <p>стран</p>
            </div>
            <div>
                <h3>31</h3>
                <p>индустрии</p>
            </div>
        </div>                
    </div>`
    });


    blockManager.add('carrerum-with-us', {
        label: 'С нами вы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-with-us">
        <div>
            <h2>С нами вы научитесь</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016779429.png" alt="">
                    <p>Опираться на свои ценности и сильные стороны</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016802049.png" alt="">
                    <p>Достигать любых целей — от оффера до повышения</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016823967.png" alt="">
                    <p>Строить карьеру без выгорания</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016848651.png" alt="">
                    <p>Работать не 24/7, а меньше и эффективнее</p>
                </div>
            </div>
            <div class="careerum-columns-with-cards">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016870960.png" alt="">
                    <h4>20+ топовых экспертов</h4>
                    <p>Сотрудники топ-компаний (Google, McKinsey, Сколково, P&G и другие), международные рекрутеры, сертифицированные коучи и психологи</p>
                    <a href="#">Познакомиться с экспертами</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016889335.png" alt="">
                    <h4>4 образовательных продукта</h4>
                    <p>Экосистема из нескольких вариантов обучения — сможете выбрать подходящий именно вам</p>
                    <a href="#carrerum-join-section">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016906988.png" alt="">
                    <h4>1200+ единомышленников в сообществе</h4>
                    <p>Новое окружение, которое поддержит, поделится опытом и при необходимости порекомендует вас компаниям</p>
                    <a href="#carrerum-review-slider">Смотреть кейсы</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-with-us-mobile', {
        label: 'С нами вы (мобильный)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-with-us-mobile">
        <div>
            <h2>С нами вы научитесь</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016779429.png" alt="">
                    <p>Опираться на свои ценности и сильные стороны</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016802049.png" alt="">
                    <p>Достигать любых целей — от оффера до повышения</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016823967.png" alt="">
                    <p>Строить карьеру без выгорания</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016848651.png" alt="">
                    <p>Работать не 24/7, а меньше и эффективнее</p>
                </div>
            </div>
            <div class="slider3 slider-block careerum-columns-with-cards-mobile">
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016870960.png" alt="">
                        <h4>20+ топовых экспертов</h4>
                        <p>Сотрудники топ-компаний (Google, McKinsey, Сколково, P&G и другие), международные рекрутеры, сертифицированные коучи и психологи</p>
                        <a href="#">Познакомиться с экспертами</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016889335.png" alt="">
                        <h4>4 образовательных продукта</h4>
                        <p>Экосистема из нескольких вариантов обучения — сможете выбрать подходящий именно вам</p>
                        <a href="#carrerum-join-mobile">Узнать больше</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016906988.png" alt="">
                        <h4>1200+ единомышленников в сообществе</h4>
                        <p>Новое окружение, которое поддержит, поделится опытом и при необходимости порекомендует вас компаниям</p>
                        <a href="#carrerum-review-slider-mobile">Смотреть кейсы</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-with-us-tablet', {
        label: 'С нами вы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-with-us-tablet">
        <div>
            <h2>С нами вы научитесь</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016779429.png" alt="">
                    <p>Опираться на свои ценности и сильные стороны</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016802049.png" alt="">
                    <p>Достигать любых целей — от оффера до повышения</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016823967.png" alt="">
                    <p>Строить карьеру без выгорания</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016848651.png" alt="">
                    <p>Работать не 24/7, а меньше и эффективнее</p>
                </div>
            </div>
            <div class="careerum-columns-with-cards-tablet">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016870960.png" alt="">
                    <h4>20+ топовых экспертов</h4>
                    <p>Сотрудники топ-компаний (Google, McKinsey, Сколково, P&G и другие), международные рекрутеры, сертифицированные коучи и психологи</p>
                    <a href="#">Познакомиться с экспертами</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016889335.png" alt="">
                    <h4>4 образовательных продукта</h4>
                    <p>Экосистема из нескольких вариантов обучения — сможете выбрать подходящий именно вам</p>
                    <a href="#carrerum-join-tablet">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016906988.png" alt="">
                    <h4>1200+ единомышленников в сообществе</h4>
                    <p>Новое окружение, которое поддержит, поделится опытом и при необходимости порекомендует вас компаниям</p>
                    <a href="#carrerum-review-slider-tablet">Смотреть кейсы</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-new-side', {
        label: 'Новый подход к развитию',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-new-side">
        <div>
            <h2>Новый подход к развитию <br> карьеры</h2>
            <div>
                <div>
                    <h3>Как принято строить карьеру</h3>
                    <ul>
                        <li>Обращаться к карьерным консультантам за резюме и оценкой профиля</li>
                        <li>Искать работу хаотично и принимать офферы, опираясь на зарплату</li>
                        <li>Много работать, но не пиарить себя, а ждать, когда начальник сам повысит</li>
                    </ul>
                    <p><span>Результат:</span> вечный вопрос «А на своем ли я месте?», метание по рынку, частые карьерные кризисы</p>
                </div>
                <div>
                    <h3>Как строят карьеру с нами</h3>
                    <ul>
                        <li><span>Учатся</span> самостоятельно находить лучшие для себя решения</li>
                        <li><span>Действуют</span> стратегически и опираются на свои ценности в поиске работы</li>
                        <li><span>Укрепляют</span> «вечные» для карьеры навыки — самопиар, нетворкинг и другие</li>
                    </ul>
                    <p><span>Результат:</span> ощущение смысла в работе и почвы под ногами, крутые офферы с повышением</p>
                </div>
            </div>

        </div>
    </div>`
    });


    blockManager.add('carrerum-new-side-mobile', {
        label: 'Новый подход к развитию (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-new-side-mobile">
        <div>
            <h2>Новый подход к развитию карьеры</h2>
            <div>
                <div>
                    <h3>Как принято строить карьеру</h3>
                    <ul>
                        <li>Обращаться к карьерным консультантам за резюме и оценкой профиля</li>
                        <li>Искать работу хаотично и принимать офферы, опираясь на зарплату</li>
                        <li>Много работать, но не пиарить себя, а ждать, когда начальник сам повысит</li>
                    </ul>
                    <p><span>Результат:</span> вечный вопрос «А на своем ли я месте?», метание по рынку, частые карьерные кризисы</p>
                </div>
                <div>
                    <div>
                        <h3>Как строят карьеру с нами</h3>
                        <ul>
                            <li><span>Учатся</span> самостоятельно находить лучшие для себя решения</li>
                            <li><span>Действуют</span> стратегически и опираются на свои ценности в поиске работы</li>
                            <li><span>Укрепляют</span> «вечные» для карьеры навыки — самопиар, нетворкинг и другие</li>
                        </ul>
                        <p><span>Результат:</span> ощущение смысла в работе и почвы под ногами, крутые офферы с повышением</p>
                    </div>                    
                </div>
            </div>

        </div>
    </div>`
    });


    blockManager.add('carrerum-new-side-tablet', {
        label: 'Новый подход к развитию (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-new-side-tablet">
        <div>
            <h2>Новый подход к развитию карьеры</h2>
            <div>
                <div>
                    <h3>Как принято строить карьеру</h3>
                    <ul>
                        <li>Обращаться к карьерным консультантам за резюме и оценкой профиля</li>
                        <li>Искать работу хаотично и принимать офферы, опираясь на зарплату</li>
                        <li>Много работать, но не пиарить себя, а ждать, когда начальник сам повысит</li>
                    </ul>
                    <p><span>Результат:</span> вечный вопрос «А на своем ли я месте?», метание по рынку, частые карьерные кризисы</p>
                </div>
                <div>
                    <h3>Как строят карьеру с нами</h3>
                    <ul>
                        <li><span>Учатся</span> самостоятельно находить лучшие для себя решения</li>
                        <li><span>Действуют</span> стратегически и опираются на свои ценности в поиске работы</li>
                        <li><span>Укрепляют</span> «вечные» для карьеры навыки — самопиар, нетворкинг и другие</li>
                    </ul>
                    <p><span>Результат:</span> ощущение смысла в работе и почвы под ногами, крутые офферы с повышением</p>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-our-products', {
        label: 'Наши продукты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-products">
        <div>
            <h2>Наши продукты</h2>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016985586.png" alt="">
                <div>
                    <div>
                        <h4><a href="#">Карьерум.Класс</a></h4>
                        <p>5 мастер-классов в записи на самые популярные карьерные темы, для тех, кто хочет начать с одного конкретного запроса. Полтора часа — бесплатно</p>
                        <a href="#carrerum-join-section">Узнать больше</a>
                    </div>
                    <div>
                        <h4><a href="#">Карьерум.Клуб</a></h4>
                        <p>Карьерный MBA с 15 образовательными программами по разным темам — от резюме до релокации за рубеж. Сильное сообщество, сопровождение кураторов, эксперт по CV</p>
                        <a href="#carrerum-join-section">Узнать больше</a>
                    </div>
                    <div>
                        <h4><a href="#">Карьерум.Старт</a></h4>
                        <p>5-недельный курс с поддержкой для тех, кто хочет сделать первый шаг к осознанной карьере, наполненной смыслами и удовлетворением</p>
                        <a href="#carrerum-join-section">Узнать больше</a>
                    </div>
                    <div>
                        <h4><a href="#">Карьерум.Кофе</a></h4>
                        <p>70 писем Ольги Лермонтовой с карьерными рекомендациями на каждый день для тех, кто хочет протестировать Карьерум по цене пирожного в месяц</p>
                        <a href="#carrerum-join-section">Узнать больше</a>
                    </div>
                </div>                
            </div>            
        </div>
    </div>`
    });


    blockManager.add('carrerum-our-products-mobile', {
        label: 'Наши продукты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-products-mobile">
        <div>
            <h2>Наши продукты: для карьерного взлета</h2>
            <div>
                <div>                    
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435505578.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Клуб</a></h4>
                        <p>Карьерный MBA с 15 образовательными программами по разным темам — от резюме до релокации за рубеж. Сильное сообщество, сопровождение кураторов, эксперт по CV</p>
                        <a href="#carrerum-join-section-mobile">Узнать больше</a>
                    </div>  
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435560286.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Старт</a></h4>
                        <p>5-недельный курс с поддержкой для тех, кто хочет сделать первый шаг к осознанной карьере, наполненной смыслами и удовлетворением</p>
                        <a href="#carrerum-join-section-mobile">Узнать больше</a>
                    </div>                  
                </div>                
            </div> 
            <h2>Наши продукты: для поддержки результатов</h2>      
            <div>
                <div>                    
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435585258.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Класс</a></h4>
                        <p>5 мастер-классов в записи на самые популярные карьерные темы, для тех, кто хочет начать с одного конкретного запроса. Полтора часа — бесплатно</p>
                        <a href="#carrerum-join-section-mobile">Узнать больше</a>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435603194.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Кофе</a></h4>
                        <p>70 писем Ольги Лермонтовой с карьерными рекомендациями на каждый день для тех, кто хочет протестировать Карьерум по цене пирожного в месяц</p>
                        <a href="#carrerum-join-section-mobile">Узнать больше</a>
                    </div>
                </div>
            </div>     
        </div>
    </div> `
    });


    blockManager.add('carrerum-our-products-tablet', {
        label: 'Наши продукты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-products-tablet">
        <div>
            <h2>Наши продукты: для карьерного взлета</h2>
            <div>
                <div>                    
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435505578.png" alt="">
                        </div>
                    
                        <h4><a href="#">Карьерум.Клуб</a></h4>
                        <p>Карьерный MBA с 15 образовательными программами по разным темам — от резюме до релокации за рубеж. Сильное сообщество, сопровождение кураторов, эксперт по CV</p>
                        <a href="#">Узнать больше</a>
                    </div>  
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435560286.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Старт</a></h4>
                        <p>5-недельный курс с поддержкой для тех, кто хочет сделать первый шаг к осознанной карьере, наполненной смыслами и удовлетворением</p>
                        <a href="#carrerum-join-section-mobile">Узнать больше</a>
                    </div>                  
                </div>                
            </div> 
            <h2>Наши продукты: для поддержки результатов</h2>      
            <div>
                <div>                    
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435585258.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Класс</a></h4>
                        <p>5 мастер-классов в записи на самые популярные карьерные темы, для тех, кто хочет начать с одного конкретного запроса. Полтора часа — бесплатно</p>
                        <a href="#carrerum-join-section-tablet">Узнать больше</a>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619435603194.png" alt="">
                        </div>
                        
                        <h4><a href="#">Карьерум.Кофе</a></h4>
                        <p>70 писем Ольги Лермонтовой с карьерными рекомендациями на каждый день для тех, кто хочет протестировать Карьерум по цене пирожного в месяц</p>
                        <a href="#carrerum-join-section-tablet">Узнать больше</a>
                    </div>
                </div>
            </div>     
        </div>
    </div> `
    });


    blockManager.add('carrerum-study-slider', {
        label: 'Как учатся в Карьеруме',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
<div class="carrerum-study-slider">
    <div>
        <div>
            <h2>Смотрите, как учатся в Карьеруме</h2>
        </div>
        <div>
            <div class="slider2 slider-block">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017050655.png" alt="">
                    <p>Мастермаинд в Карьерум.Клубе</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017072339.png" alt="">
                    <p>Фрагмент урока Карьерум.Старта</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017104107.png" alt="">
                    <p>Фрагмент одного из курсов Карьерум.Клуба</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017127030.png" alt="">
                    <p>Встреча Карьерум.Клуба во Франкфурте</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017144838.png" alt="">
                    <p>Фрагмент записи лекции Number One</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017167705.png" alt="">
                    <p>Первое из 70 писем карьерной рассылки Карьерум.Кофе</p>
                </div>
            </div>
        </div>
        
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
        </div>
    </div>
</div>`
    });


    blockManager.add('carrerum-study-slider-mobile', {
        label: 'Как учатся в Карьеруме (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
<div class="carrerum-study-slider-mobile">
    <div>
        <div>
            <h2>Смотрите, как учатся в Карьеруме</h2>
        </div>
        <div>
            <div class="slider2 slider-block">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017050655.png" alt="">
                    <p>Мастермаинд в Карьерум.Клубе</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017072339.png" alt="">
                    <p>Фрагмент урока Карьерум.Старта</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017104107.png" alt="">
                    <p>Фрагмент одного из курсов Карьерум.Клуба</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017127030.png" alt="">
                    <p>Встреча Карьерум.Клуба во Франкфурте</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017144838.png" alt="">
                    <p>Фрагмент записи лекции Number One</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017167705.png" alt="">
                    <p>Первое из 70 писем карьерной рассылки Карьерум.Кофе</p>
                </div>
            </div>
        </div>
        
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
        </div>
    </div>
</div>`
    });


    blockManager.add('carrerum-study-slider-tablet', {
        label: 'Как учатся в Карьеруме (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
<div class="carrerum-study-slider-tablet">
    <div>
        <div>
            <h2>Смотрите, как учатся в Карьеруме</h2>
        </div>
        <div>
            <div class="slider2 slider-block">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017050655.png" alt="">
                    <p>Мастермаинд в Карьерум.Клубе</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017072339.png" alt="">
                    <p>Фрагмент урока Карьерум.Старта</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017104107.png" alt="">
                    <p>Фрагмент одного из курсов Карьерум.Клуба</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017127030.png" alt="">
                    <p>Встреча Карьерум.Клуба во Франкфурте</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017144838.png" alt="">
                    <p>Фрагмент записи лекции Number One</p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017167705.png" alt="">
                    <p>Первое из 70 писем карьерной рассылки Карьерум.Кофе</p>
                </div>
            </div>
        </div>
        
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
        </div>
    </div>
</div>`
    });


    blockManager.add('carrerum-course-author', {
        label: 'Автор курсов',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-author">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620859606610.png" alt="">
            </div>
            <div>
                <p>«Я помогаю людям понять, что можно не метаться хаотично по рынку в поиске хоть какой-нибудь работы, а шаг за шагом следовать собственной стратегии. Не упираться в стеклянный потолок, а планировать собственное повышение и расширять возможности. Не работать, потому что «нужно», а реализовывать себя на 100%». <br><br>
                    Все это ждет вас в Карьерум.Клубе.
                    </p>
                <h4>Ольга Лермонтова, CEO Карьерум</h4>
                <a href="#popup-about">Узнать об Ольге</a>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-course-author-mobile', {
        label: 'Автор курсов (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-author-mobile">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620859606610.png" alt="">
            </div>
            <div>
                <p>«Я помогаю людям понять, что можно не метаться хаотично по рынку в поиске хоть какой-нибудь работы, а шаг за шагом следовать собственной стратегии. Не упираться в стеклянный потолок, а планировать собственное повышение и расширять возможности. Не работать, потому что «нужно», а реализовывать себя на 100%». <br><br>
                    Все это ждет вас в Карьерум.Клубе.
                    </p>
                <h4>Ольга Лермонтова, CEO Карьерум</h4>
                <a href="#popup-about-mobile">Узнать об Ольге</a>
            </div>
        </div>
    </div>    `
    });


    blockManager.add('carrerum-course-author-tablet', {
        label: 'Автор курсов (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-author-tablet">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620859606610.png" alt="">
                </div>
                <div>
                    <p>«Я помогаю людям понять, что можно не метаться хаотично по рынку в поиске хоть какой-нибудь работы, а шаг за шагом следовать собственной стратегии. Не упираться в стеклянный потолок, а планировать собственное повышение и расширять возможности. Не работать, потому что «нужно», а реализовывать себя на 100%». <br><br>
                        Все это ждет вас в Карьерум.Клубе.
                        </p>
                    <h4>Ольга Лермонтова, CEO Карьерум</h4>
                </div>
            </div>
            <a href="#popup-about-tablet">Ольга Лермонтова</a>
        </div>
    </div>    `
    });


    blockManager.add('carrerum-review-slider', {
        label: 'Слайдер отзывов',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-slider" id="carrerum-review-slider">
        <div>
            <div>
                <h2>Результаты наших участников</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017258760.png" alt=""></div>
                            <div>
                                <h3>Екатерина Таркова</h3>
                                <p>Москва, Supply Chain Specialist</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Сменить профессию без потери в зарплате.</p>
                            <p><span>Результат:</span> Перешла из логистики в обучение и развитие персонала, нашла интересную работу в новой области с классной командой и важными для меня ценностями, а также получила +50% к заработной плате. Огромное спасибо Карьеруму и всем его участникам за мотивацию и знания!.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017302281.png" alt=""></div>
                            <div>
                                <h3>Наталья Калицева</h3>
                                <p>Москва, бизнес-тренер и бренд-менеджер</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Понять, как строить карьеру во время и после декрета.</p>
                            <p><span>Результат:</span> В Карьеруме я осознала, что нынешняя работа полностью мне откликается, а единственный минус — нет возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи руководителю, я предложила ему план моей удаленной работы. План согласовали — это первый случай в нашей компании.</p>
                        </div>
                        <div></div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017319141.png" alt=""></div>
                            <div>
                                <h3>Роман Малышев</h3>
                                <p>Черногория, Project/Product Manager</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определить долгосрочные цели, повысить зарплату.</p>
                            <p><span>Результат:</span> В результате разговора с руководителем получил увеличение оклада на 38%. Изменились глобальные цели — от «сменить работы с увеличением дохода» к «работать на позиции в компании, которая соответствует моим ценностям». Понял, что не хочу менять специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                        <div></div>
                    </div>                        
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017335080.png" alt=""></div>
                            <div>
                                <h3>Юлия Монич</h3>
                                <p>Украина, Delivery Director</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Преодолеть выгорание и неуверенность, определить карьерный путь.</p>
                            <p><span>Результат:</span> Я поменяла свой способ мышления, выстроила эффективную коммуникацию с командой, начала с удовольствием браться за сложные задачи, научилась подсвечивать свои достижения и получила повышение зарплаты на 38%. Через год я получила новый оффер с увеличением зарплаты уже на 80%, при этом компания нашла меня сама.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017351704.png" alt=""></div>
                            <div>
                                <h3>Маргарита Масленникова</h3>
                                <p>Москва, Digital Director</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться с вектором карьеры и найти работу.</p>
                            <p><span>Результат:</span> Мне удалось не только сменить сферу деятельности компании – оффер от IT-корпорации, использовать свой сильный профильный бэкграунд – выхожу руководителем подразделения, но и увеличить годовой доход – в 1,7 раз от первоначального запроса на первых этапах поисков.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017367647.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться, что делать дальше в карьере.</p>
                            <p><span>Результат:</span> Карьерум помог сориентироваться, что я на самом деле люблю делать, какого типа компанию я хочу найти и с каким руководителем работать. В итоге я определилась со сферой и получила оффер в желаемой компании с задействованием всех моих талантов, потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-review-slider-mobile', {
        label: 'Слайдер отзывов (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-slider-mobile" id="carrerum-review-slider-mobile">
        <div>
            <div>
                <h2>Результаты наших <br> участников</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017258760.png" alt=""></div>
                            <div>
                                <h3>Екатерина Таркова</h3>
                                <p>Москва, Supply Chain Specialist</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Сменить профессию без потери в зарплате.</p>
                            <p><span>Результат:</span> Перешла из логистики в обучение и развитие персонала, нашла интересную работу в новой области с классной командой и важными для меня ценностями, а также получила +50% к заработной плате. Огромное спасибо Карьеруму и всем его участникам за мотивацию и знания!.</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017302281.png" alt=""></div>
                            <div>
                                <h3>Наталья Калицева</h3>
                                <p>Москва, бизнес-тренер и бренд-менеджер</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Понять, как строить карьеру во время и после декрета.</p>
                            <p><span>Результат:</span> В Карьеруме я осознала, что нынешняя работа полностью мне откликается, а единственный минус — нет возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи руководителю, я предложила ему план моей удаленной работы. План согласовали — это первый случай в нашей компании.</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017319141.png" alt=""></div>
                            <div>
                                <h3>Роман Малышев</h3>
                                <p>Черногория, Project/Product Manager</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определить долгосрочные цели, повысить зарплату.</p>
                            <p><span>Результат:</span> В результате разговора с руководителем получил увеличение оклада на 38%. Изменились глобальные цели — от «сменить работы с увеличением дохода» к «работать на позиции в компании, которая соответствует моим ценностям». Понял, что не хочу менять специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>                        
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017335080.png" alt=""></div>
                            <div>
                                <h3>Юлия Монич</h3>
                                <p>Украина, Delivery Director</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Преодолеть выгорание и неуверенность, определить карьерный путь.</p>
                            <p><span>Результат:</span> Я поменяла свой способ мышления, выстроила эффективную коммуникацию с командой, начала с удовольствием браться за сложные задачи, научилась подсвечивать свои достижения и получила повышение зарплаты на 38%. Через год я получила новый оффер с увеличением зарплаты уже на 80%, при этом компания нашла меня сама.</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017351704.png" alt=""></div>
                            <div>
                                <h3>Маргарита Масленникова</h3>
                                <p>Москва, Digital Director</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться с вектором карьеры и найти работу.</p>
                            <p><span>Результат:</span> Мне удалось не только сменить сферу деятельности компании – оффер от IT-корпорации, использовать свой сильный профильный бэкграунд – выхожу руководителем подразделения, но и увеличить годовой доход – в 1,7 раз от первоначального запроса на первых этапах поисков.</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017367647.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться, что делать дальше в карьере.</p>
                            <p><span>Результат:</span> Карьерум помог сориентироваться, что я на самом деле люблю делать, какого типа компанию я хочу найти и с каким руководителем работать. В итоге я определилась со сферой и получила оффер в желаемой компании с задействованием всех моих талантов, потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                    </div>                    
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-review-slider-tablet', {
        label: 'Слайдер отзывов (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-slider-tablet" id="carrerum-review-slider-tablet">
        <div>
            <div>
                <h2>Результаты наших участников</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017258760.png" alt=""></div>
                            <div>
                                <h3>Екатерина Таркова</h3>
                                <p>Москва, Supply Chain Specialist</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Сменить профессию без потери в зарплате.</p>
                            <p><span>Результат:</span> Перешла из логистики в обучение и развитие персонала, нашла интересную работу в новой области с классной командой и важными для меня ценностями, а также получила +50% к заработной плате. Огромное спасибо Карьеруму и всем его участникам за мотивацию и знания!.</p>
                        </div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017302281.png" alt=""></div>
                            <div>
                                <h3>Наталья Калицева</h3>
                                <p>Москва, бизнес-тренер и бренд-менеджер</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Понять, как строить карьеру во время и после декрета.</p>
                            <p><span>Результат:</span> В Карьеруме я осознала, что нынешняя работа полностью мне откликается, а единственный минус — нет возможности работать удаленно. Проштудировав материалы о том, как преподносить идеи руководителю, я предложила ему план моей удаленной работы. План согласовали — это первый случай в нашей компании.</p>
                        </div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017319141.png" alt=""></div>
                            <div>
                                <h3>Роман Малышев</h3>
                                <p>Черногория, Project/Product Manager</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определить долгосрочные цели, повысить зарплату.</p>
                            <p><span>Результат:</span> В результате разговора с руководителем получил увеличение оклада на 38%. Изменились глобальные цели — от «сменить работы с увеличением дохода» к «работать на позиции в компании, которая соответствует моим ценностям». Понял, что не хочу менять специальность, а буду прокачиваться в ее рамках.</p>
                        </div>
                    </div>                        
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017335080.png" alt=""></div>
                            <div>
                                <h3>Юлия Монич</h3>
                                <p>Украина, Delivery Director</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Преодолеть выгорание и неуверенность, определить карьерный путь.</p>
                            <p><span>Результат:</span> Я поменяла свой способ мышления, выстроила эффективную коммуникацию с командой, начала с удовольствием браться за сложные задачи, научилась подсвечивать свои достижения и получила повышение зарплаты на 38%. Через год я получила новый оффер с увеличением зарплаты уже на 80%, при этом компания нашла меня сама.</p>
                        </div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017351704.png" alt=""></div>
                            <div>
                                <h3>Маргарита Масленникова</h3>
                                <p>Москва, Digital Director</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться с вектором карьеры и найти работу.</p>
                            <p><span>Результат:</span> Мне удалось не только сменить сферу деятельности компании – оффер от IT-корпорации, использовать свой сильный профильный бэкграунд – выхожу руководителем подразделения, но и увеличить годовой доход – в 1,7 раз от первоначального запроса на первых этапах поисков.</p>
                        </div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017367647.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Цель:</span> Определиться, что делать дальше в карьере.</p>
                            <p><span>Результат:</span> Карьерум помог сориентироваться, что я на самом деле люблю делать, какого типа компанию я хочу найти и с каким руководителем работать. В итоге я определилась со сферой и получила оффер в желаемой компании с задействованием всех моих талантов, потенциалом для развития и повышением зарплаты на 20%!</p>
                        </div>
                    </div>                    
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-join', {
        label: 'Блок офферов',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-join" id="carrerum-join-section">
        <div>
            <h2>Присоединиться к нам</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017465636.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Клуб</h3>
                        <p>Новый набор — в мае</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017484295.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Старт</h3>
                        <p>Новый набор — ХХ.ХХ</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017520053.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Класс</h3>
                        <p>5 отдельных мастер-классов в записи</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017540194.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Кофе</h3>
                        <p>Подписка на 70 писем с рекомендациями</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-join-mobile', {
        label: 'Блок офферов (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-join-mobile" id="carrerum-join-mobile">
        <div>
            <h2>Присоединиться к нам</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017465636.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Клуб</h3>
                        <p>Новый набор — в мае</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017484295.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Старт</h3>
                        <p>Новый набор — ХХ.ХХ</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017520053.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Класс</h3>
                        <p>5 отдельных мастер-классов в записи</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017540194.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Кофе</h3>
                        <p>Подписка на 70 писем с рекомендациями</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-join-tablet', {
        label: 'Блок офферов (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-join-tablet" id="carrerum-join-tablet">
        <div>
            <h2>Присоединиться к нам</h2>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017465636.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Клуб</h3>
                        <p>Новый набор — в мае</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017484295.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Старт</h3>
                        <p>Новый набор — ХХ.ХХ</p>
                        <a href="#">Записаться в лист ожидания</a>
                    </div>
                </div>
                
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017520053.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Класс</h3>
                        <p>5 отдельных мастер-классов в записи</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017540194.png" alt="">
                    </div>
                    <div>
                        <h3>Карьерум. Кофе</h3>
                        <p>Подписка на 70 писем с рекомендациями</p>
                        <a href="#">Посмотреть</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    
    blockManager.add('carrerum-free-materials', {
        label: 'Бесплатные материалы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-free-materials">
        <div>
            <h2>Бесплатные материалы</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017561571.png" alt="">
                    <h4>Блог</h4>
                    <p>Получайте полезные для вашей карьеры знания</p>
                    <a href="#">Читать</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017575132.png" alt="">
                    <h4>Мастер-классы</h4>
                    <p>Смотрите бесплатно по полчаса трех <br> бестселлеров</p>
                    <a href="#">Смотреть</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017592282.png" alt="">
                    <h4>Рассылка</h4>
                    <p>Получайте предложения проекта раньше всех</p>
                    <a href="#popup-subscribe-mobile">Подписаться</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017613610.png" alt="">
                    <h4>Райан</h4>
                    <p>Смотрите эфиры о карьере с очаровательным ботом</p>
                    <a href="#">Поговорить</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-free-materials-mobile', {
        label: 'Бесплатные материалы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-free-materials-mobile">
        <div>
            <h2>Бесплатные материалы</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017561571.png" alt="">
                    <h4>Блог</h4>
                    <p>Получайте полезные для вашей карьеры знания</p>
                    <a href="#">Читать</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017575132.png" alt="">
                    <h4>Мастер-классы</h4>
                    <p>Смотрите бесплатно по полчаса трех <br> бестселлеров</p>
                    <a href="#">Смотреть</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017592282.png" alt="">
                    <h4>Рассылка</h4>
                    <p>Получайте предложения проекта раньше всех</p>
                    <a href="#popup-subscribe">Подписаться</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017613610.png" alt="">
                    <h4>Райан</h4>
                    <p>Смотрите эфиры о карьере с очаровательным ботом</p>
                    <a href="#">Поговорить</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-free-materials-tablet', {
        label: 'Бесплатные материалы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-free-materials-tablet">
        <div>
            <h2>Бесплатные материалы</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017561571.png" alt="">
                    <h4>Блог</h4>
                    <p>Получайте полезные для вашей карьеры знания</p>
                    <a href="#">Читать</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017575132.png" alt="">
                    <h4>Мастер-классы</h4>
                    <p>Смотрите бесплатно по полчаса трех <br> бестселлеров</p>
                    <a href="#">Смотреть</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017592282.png" alt="">
                    <h4>Рассылка</h4>
                    <p>Получайте предложения проекта раньше всех</p>
                    <a href="#popup-subscribe-tablet">Подписаться</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017613610.png" alt="">
                    <h4>Райан</h4>
                    <p>Смотрите эфиры о карьере с очаровательным ботом</p>
                    <a href="#">Поговорить</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-site-footer', {
        label: 'Футер на сайт',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-site-footer">
        <div>
            <div>
                <div>
                    <ul>
                        <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017642334.png"></li>
                        <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                        <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                        <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                        <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                        <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="mailto:hello@careerum.ru">hello@careerum.ru</a></li>
                        <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                        <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                        <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                        <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="https://careerum.ru/blog">Блог</a></li>
                        <li><a href="https://careerum.ru/careerbot/">Телеграм-бот</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li>Ускоряем вашу карьеру в соцсетях</li>
                        <li>
                            <a target="_blank" href="https://www.facebook.com/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017691879.png" alt=""></a>
                            <a target="_blank" href="https://www.linkedin.com/company/careerum/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017716134.png" alt=""></a>
                            <a target="_blank" href="https://www.instagram.com/careerum.platform/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017733329.png" alt=""></a>
                            <a target="_blank" href="https://youtube.com/c/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017750433.png" alt=""></a>
                        </li>
                        <li>Связаться с нами</li>
                        <li>
                            <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625301241412.png" alt=""></a>
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                            <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197615446.png" alt=""></a>
                            <a target="_blank" href="https://m.me/careerum" id="ilnba1u"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
                        </li>
                        <li><span>Юридический адрес: Vesivarava 50-201, Tallinn 10152, Estonia</span></li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <p>© Careerum 2021 <br> Все права защищены</p>
                </div>
                <div>
                    <a href="https://school.careerum.ru/career-club/offer">Пользовательское соглашение</a>
                    <a href="https://careerum.ru/cms/system/legal">Политика использования сайта</a>
                    <a href="https://school.careerum.ru/career-club/refundpolicy">Политика возвратов</a>
                </div>
            </div>
        </div>
    </div>`
    });

    
    blockManager.add('carrerum-footer-tablet', {
        label: 'Футер на сайт (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-footer-tablet">
        <div>
            <div>
                <div>
                    <ul>
                        <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017642334.png"></li>
                        <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                        <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                        <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                        <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                        <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="mailto:hello@careerum.ru">hello@careerum.ru</a></li>
                        <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                        <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                        <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                        <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li>
                            <a target="_blank" href="https://www.facebook.com/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017691879.png" alt=""></a>
                            <a target="_blank" href="https://www.linkedin.com/company/careerum/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017716134.png" alt=""></a>
                            <a target="_blank" href="https://www.instagram.com/careerum.platform/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017733329.png" alt=""></a>
                            <a target="_blank" href="https://youtube.com/c/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017750433.png" alt=""></a>
                        </li>
                        <li><a href="https://careerum.ru/blog">Блог</a></li>
                        <li><a href="https://careerum.ru/careerbot/">Телеграм-бот</a></li>
                        <li><a href="javascript: void(0)">Связаться с нами</a></li>
                        <li>
                            <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625301241412.png" alt=""></a>
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                            <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197615446.png" alt=""></a>
                            <a target="_blank" href="https://m.me/careerum" id="ilnba1u"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <p>© Careerum 2021 <br> Все права защищены</p>
                </div>
                <div>
                    <a href="https://school.careerum.ru/career-club/offer">Пользовательское соглашение</a>
                    <a href="https://careerum.ru/cms/system/legal">Политика использования сайта</a>
                    <a href="https://school.careerum.ru/career-club/refundpolicy">Политика возвратов</a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-footer-mobile', {
        label: 'Футер на сайт (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-footer-mobile">
        <div>
            <div>
                <div>
                    <ul>
                        <li><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017642334.png"></li>
                        <li><a href="https://careerum.ru/">О Карьеруме</a></li>
                        <li><a href="https://careerum.ru/start">Карьерум.Старт</a></li>
                        <li><a href="https://careerum.ru/club">Карьерум.Клуб</a></li>
                        <li><a href="https://careerum.ru/class">Карьерум.Класс</a></li>
                        <li><a href="https://careerum.ru/coffee">Карьерум.Кофе</a></li>
                        <li><a href="https://careerum.ru/coaching">Индивидуальный коучинг</a></li>
                        <li><a href="https://careerum.ru/results">Результаты участников</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="mailto:hello@careerum.ru">hello@careerum.ru</a></li>

                        <li><a href="https://careerum.ru/experts">Эксперты</a></li>
                        <li><a href="https://careerum.ru/team">Команда Карьерума</a></li>
                        <li><a href="https://careerum.ru/blog">Блог</a></li>
                        <li><a href="https://careerum.ru/careerbot/">Телеграм-бот</a></li>
                        <li>
                            <a target="_blank" href="https://www.facebook.com/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017691879.png" alt=""></a>
                            <a target="_blank" href="https://www.linkedin.com/company/careerum/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017716134.png" alt=""></a>
                            <a target="_blank" href="https://www.instagram.com/careerum.platform/"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017733329.png" alt=""></a>
                            <a target="_blank" href="https://youtube.com/c/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017750433.png" alt=""></a>
                        </li>
                        <li>
                            <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625301241412.png" alt=""></a>
                            <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                            <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197615446.png" alt=""></a>
                            <a target="_blank" href="https://m.me/careerum" id="ilnba1u"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div>                
                <div>
                    <a href="https://school.careerum.ru/career-club/offer">Пользовательское соглашение</a>
                    <a href="https://careerum.ru/cms/system/legal">Политика использования сайта</a>
                    <a href="https://school.careerum.ru/career-club/refundpolicy">Политика возвратов</a>
                </div>
                <div>
                    <p>© Careerum 2021 Все права защищены</p>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-centralized-image', {
        label: 'Картинка по центру',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-centralized-image">
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242667.png" alt="">
            </div>
        </div>`
    });

    blockManager.add('carrerum-centralized-image-mob', {
        label: 'Картинка по центру (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-centralized-image-mob">
            <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242667.png" alt="">
            </div>
        </div>`
    });

    blockManager.add('carrerum-how-it-works', {
        label: 'Как это работает',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-how-it-works">
        <div>
            <div>
                <h2>Как устроен курс</h2>
            </div>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242296.png" alt="">
                    </div>
                    <div>
                        <p><span>10 видеоуроков</span> продолжительностью 10-20 минут каждый. Уроки составлены экспертом в карьере и коучинге и разработаны таким образом, чтобы вы могли учиться с интересом и получать результаты</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242413.png" alt="">
                    </div>
                    <div>
                        <p><span>Поддержка кураторов</span>, которые помогут вам с любыми трудностями в обучении и дадут обратную связь по домашним заданиям в соответствии с выбранным вами тарифом</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242481.png" alt="">
                    </div>
                    <div>
                        <p><span>Нетворкинг в Telegram</span>, благодаря которому вы сможете обрести новые, ценные знакомства в разных сферах. В чате вы сможете обсуждать домашние задания с другими участниками курса, делиться сложностями, которые возникли, и поддерживать друг друга</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242522.png" alt="">
                    </div>
                    <div>
                        <p><span>Домашние задания</span>, которые составлены так, чтобы вы действительно приближались к результату. А также рабочая тетрадь для их выполнения</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242562.png" alt="">
                    </div>
                    <div>
                        <p><span>Карта курса</span>, которая показывает, на каком этапе обучения вы сейчас находитесь, и помогает держать фокус своего внимания на цели</p>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242593.png" alt="">
                    </div>
                    <div>
                        <p><span>Розыгрыш месячной подписки на Карьерум.Клуб</span> среди участников, выполнивших все задания</p>
                    </div>
                </div>
            </div>
            <a href="#carrerum-join-section">Начать обучение</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-how-it-works-mob', {
        label: 'Как это работает (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-how-it-works-mob">
            <div>
                    <div>
                            <h2>Как устроен курс</h2>
                    </div>
                    <div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242296.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>10 видеоуроков</span> продолжительностью 10-20 минут каждый. Уроки составлены экспертом в карьере и коучинге и разработаны таким образом, чтобы вы могли учиться с интересом и получать результаты</p>
                                    </div>
                            </div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242413.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>Поддержка кураторов</span>, которые помогут вам с любыми трудностями в обучении и дадут обратную связь по домашним заданиям в соответствии с выбранным вами тарифом</p>
                                    </div>
                            </div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242481.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>Нетворкинг в Telegram</span>, благодаря которому вы сможете обрести новые, ценные знакомства в разных сферах. В чате вы сможете обсуждать домашние задания с другими участниками курса, делиться сложностями, которые возникли, и поддерживать друг друга</p>
                                    </div>
                            </div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242522.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>Домашние задания</span>, которые составлены так, чтобы вы действительно приближались к результату. А также рабочая тетрадь для их выполнения</p>
                                    </div>
                            </div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242562.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>Карта курса</span>, которая показывает, на каком этапе обучения вы сейчас находитесь, и помогает держать фокус своего внимания на цели</p>
                                    </div>
                            </div>
                            <div>
                                    <div>
                                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242593.png" alt="">
                                    </div>
                                    <div>
                                            <p><span>Розыгрыш месячной подписки на Карьерум.Клуб</span> среди участников, выполнивших все задания</p>
                                    </div>
                            </div>
                    </div>
                    <a href="#">Начать обучение</a>
            </div>
        </div>`
    });


    blockManager.add('carrerum-club', {
        label: 'Клуб',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
		<div class="carrerum-club">
            <div>
				<div>
                    <h2>Карьерум. <span>Клуб</span></h2>
                    <p>это карьерный клуб, который поможет вам продолжить свой карьерный путь.</p>
                    <p>С подпиской вам откроется доступ к огромной базе полезных курсов и вебинаров — 200 + часов материалов, на 360 градусов покрывающих карьерные темы от поиска работы до самоопределения и переезда за границу. </p>
                    <p>Также вы становитесь участником сильного сообщества единомышленников, что не менее важно в достижении карьерных результатов.</p>
                    <a href="#">Забронировать место</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615893884546.gif" alt="">
                </div>
            </div>
    	</div>`
    });

    blockManager.add('carrerum-club-mob', {
        label: 'Клуб (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-club-mob">
            <div>
                <div>
                        <h2>Карьерум. <span>Клуб</span></h2>
                        <p>это карьерный клуб, который поможет вам продолжить свой карьерный путь.</p>
                        <p>С подпиской вам откроется доступ к огромной базе полезных курсов и вебинаров — 200 + часов материалов, на 360 градусов покрывающих карьерные темы от поиска работы до самоопределения и переезда за границу. </p>
                        <p>Также вы становитесь участником сильного сообщества единомышленников, что не менее важно в достижении карьерных результатов.</p>
                        <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615893884546.gif" alt="">
                        </div>
                        <a href="#">Забронировать место</a>
                </div>
                    
            </div>
        </div>`
    });


    blockManager.add('carrerum-author-and-speaker', {
        label: 'Авторы \ спикеры',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-author-and-speaker">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242751.jpg" alt="">
                </div>
                <div>
                    <h2>Автор и спикер курса</h2>
                    <h3>Ольга Лермонтова</h3>
                    <ul>
                        <li>Сертифицированный карьерный коуч с аккредитацией ICF</li>
                        <li>Помогла <span>3000+ человек</span> открыть в себе таланты, полюбить свою работу и сделать ее источником энергии</li>
                        <li><span>Основательница Карьерума</span>, где участники ставят карьерные цели, опираясь на свои ценности и сильные стороны</li>
                        <li><span>14+ лет успешной карьеры</span> в компаниях Google, Microsoft, степень MBA от бизнес-школы INSEAD</li>
                        <li>Автор развивающих блогов о карьере с аудиторией в <span>150 000+ читателей</span></li>
                    </ul>
                </div>
            </div>
            <div>
                <div>
                    <p>Те, кто влюбился в свою первую работу, решил посвятить ей всю свою жизнь и уверен, что это его призвание — просто везунчики. Я не была из их числа. Мне тоже пришлось проделать долгий путь, прежде чем найти то, что приносит истинную самореализацию.    Для меня тоже когда-то стало открытием, что работу можно любить. </p>
                    <p>Если вы уже задумались над тем, что хотите что-то менять в своей карьере, значит вы на верном пути. Дальше — дело техники. Так что добро пожаловать на борт!</p>
                </div>                
            </div>
        </div>
    	</div>`
    });

    blockManager.add('carrerum-author-and-speaker-mob', {
        label: 'Авторы \ спикеры (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-author-and-speaker-mob">
            <div>
                    <div>
                            <div>
                                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242751.jpg" alt="">
                            </div>
                            <div>
                                    <h2>Автор и спикер курса</h2>
                                    <h3>Ольга Лермонтова</h3>
                                    <ul>
                                            <li>Сертифицированный карьерный коуч с аккредитацией ICF</li>
                                            <li>Помогла <span>3000+ человек</span> открыть в себе таланты, полюбить свою работу и сделать ее источником энергии</li>
                                            <li><span>Основательница Карьерума</span>, где участники ставят карьерные цели, опираясь на свои ценности и сильные стороны</li>
                                            <li><span>14+ лет успешной карьеры</span> в компаниях Google, Microsoft, степень MBA от бизнес-школы INSEAD</li>
                                            <li>Автор развивающих блогов о карьере с аудиторией в <span>150 000+ читателей</span></li>
                                    </ul>
                            </div>
                    </div>
                    <div>
                            <div>
                                    <p>Те, кто влюбился в свою первую работу, решил посвятить ей всю свою жизнь и уверен, что это его призвание — просто везунчики. Я не была из их числа. Мне тоже пришлось проделать долгий путь, прежде чем найти то, что приносит истинную самореализацию.    Для меня тоже когда-то стало открытием, что работу можно любить. </p>
                                    <p>Если вы уже задумались над тем, что хотите что-то менять в своей карьере, значит вы на верном пути. Дальше — дело техники. Так что добро пожаловать на борт!</p>
                            </div>                
                    </div>
            </div>
        </div>`
    });

    blockManager.add('carrerum-review-slider', {
        label: 'Слайдер с отзывами',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-review-slider">
        <div>
            <div>
                <h2>Посмотрите, что <span>говорят участники</span> других наших курсов</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                            <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242649.png" alt=""></div>
                            <div>
                                <h3>Елена Луценко</h3>
                                <p>Россия, Москва, Administrative and HR services manager</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> Я пришла, чтобы определить, в каком направлении двигаться в поисках работы после 4-х лет отпуска по уходу за ребенком. Хотелось проверить, не заблуждаюсь ли я в своем выборе новой роли и сферы для профессионального развития, и наметить план конкретных действий на ближайший год.</p>
                            <p><span>Результат:</span> Самой ценной для меня стала возможность узнать и понять себя лучше, благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддерживающая среда, созданная Ольгой, качество, структурированность и глубина. Самой ценной для меня стала возможность узнать и понять себя лучше, благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддерживающая среда, созданная Ольгой, качество, структурированность и глубина.</p>
                        </div>
                        <div></div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242643.png" alt=""></div>
                            <div>
                                <h3>Екатерина Асекритова</h3>
                                <p>Россия, Москва, Product launch manager</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> В какой-то момент моя работа перестала меня удовлетворять. В связи с кризисом внутри компании, на который наложился коронавирус, заморозилось мое повышение. И в связи с этой ситуацией стало принципиально важно начать зарабатывать больше и устроиться в структуру, в которой можно было бы рассчитывать на стабильность и развитие. В Карьерум я пришла с запросом получше разобраться в себе и выбрать на основании способностей и ценностей подходящую мне сферу деятельности, так как в своей отрасли мне больше не хочется работать.</p>
                            <p><span>Результат:</span> В итоге я обрела важную в турбулентное время.</p>
                        </div>
                        <div></div>
                    </div>                        
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                            <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                            <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                            <div>
                                <h3>Мария Михайлова</h3>
                                <p>Норвегия, Senior Consultant</p>
                            </div>
                            <div><a href="#" target="_blank"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                        </div>
                        <div>
                            <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                            <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                        </div>
                        <div></div>
                    </div>                    
                </div>
                <!-- <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div>
                <div class="item"></div> -->
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242639.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242641.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-review-slider-mob', {
        label: 'Слайдер с отзывами (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-review-slider-mob">
            <div>
                    <div>
                            <h2>Посмотрите, что <span>говорят участники</span> других наших курсов</h2>
                    </div>
                    <div class="slider slider-block">                
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                                                    <div>
                                                            <h3>Мария Михайлова</h3>
                                                            <p>Норвегия, Senior Consultant</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                                                    <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                                            </div>
                                            <div></div>
                                    </div>                    
                            </div>
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242649.png" alt=""></div>
                                                    <div>
                                                            <h3>Елена Луценко</h3>
                                                            <p>Россия, Москва, Administrative and HR services manager</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> Я пришла, чтобы определить, в каком направлении двигаться в поисках работы после 4-х лет отпуска по уходу за ребенком. Хотелось проверить, не заблуждаюсь ли я в своем выборе новой роли и сферы для профессионального развития, и наметить план конкретных действий на ближайший год.</p>
                                                    <p><span>Результат:</span> Самой ценной для меня стала возможность узнать и понять себя лучше, благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддерживающая среда, созданная Ольгой, качество, структурированность и глубина. Самой ценной для меня стала возможность узнать и понять себя лучше, благодаря последовательной проработке заданий в группе. А еще — мотивирующая и поддерживающая среда, созданная Ольгой, качество, структурированность и глубина.</p>
                                            </div>
                                            <div></div>
                                    </div>
                                    
                            </div>
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242643.png" alt=""></div>
                                                    <div>
                                                            <h3>Екатерина Асекритова</h3>
                                                            <p>Россия, Москва, Product launch manager</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> В какой-то момент моя работа перестала меня удовлетворять. В связи с кризисом внутри компании, на который наложился коронавирус, заморозилось мое повышение. И в связи с этой ситуацией стало принципиально важно начать зарабатывать больше и устроиться в структуру, в которой можно было бы рассчитывать на стабильность и развитие. В Карьерум я пришла с запросом получше разобраться в себе и выбрать на основании способностей и ценностей подходящую мне сферу деятельности, так как в своей отрасли мне больше не хочется работать.</p>
                                                    <p><span>Результат:</span> В итоге я обрела важную в турбулентное время.</p>
                                            </div>
                                            <div></div>
                                    </div>                        
                            </div>
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                                                    <div>
                                                            <h3>Мария Михайлова</h3>
                                                            <p>Норвегия, Senior Consultant</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                                                    <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                                            </div>
                                            <div></div>
                                    </div>                    
                            </div>
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                                                    <div>
                                                            <h3>Мария Михайлова</h3>
                                                            <p>Норвегия, Senior Consultant</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                                                    <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                                            </div>
                                            <div></div>
                                    </div>                    
                            </div>
                            <div class="item"> 
                                    <div>
                                            <div>
                                                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242715.png" alt=""></div>
                                                    <div>
                                                            <h3>Мария Михайлова</h3>
                                                            <p>Норвегия, Senior Consultant</p>
                                                    </div>
                                                    <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a></div>
                                            </div>
                                            <div>
                                                    <p><span>Изначальная цель:</span> Я пришла в Карьерум с запросом определиться, что делать дальше в карьере. Текущее место работы вдохновлять перестало, идеи, куда двигаться, были, но в них не было уверенности.</p>
                                                    <p><span>Результат:</span> Курс, который я прошла, очень классный и просто must have для всех! Очень помогает структурировать свои умения, таланты, определить важное в работе. Было много инсайтов и открытий о себе (“Вау, у меня такие таланты! А это, оказывается, мои ценности!”). Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать. Очень помогло сориентироваться, что я на самом деле люблю делать, что для меня важно, какого типа компанию я хочу найти и с каким руководителем работать.</p>
                                            </div>
                                            <div></div>
                                    </div>                    
                            </div>
                            <!-- <div class="item"></div>
                            <div class="item"></div>
                            <div class="item"></div>
                            <div class="item"></div> -->
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242639.png" alt="" class="prewarr">
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242641.png" alt="" class="nextarr">
                    </div>
            </div>
        </div>`
    });


    blockManager.add('carrerum-tarifs', {
        label: 'Тарифы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-tarifs">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <p class="active">
                        Доступ к учебным материалам
                    </p>
                    <p class="active">
                        “Только посмотреть”
                    </p>
                    <p class="unactive">
                        Доступ к чату
                    </p>
                    <p class="unactive">
                        Рабочая тетрадь
                    </p>
                    <p class="unactive">
                        Проверка домашних заданий
                    </p>
                    <p class="unactive">
                        Личный чат с кураторами
                    </p>
                    <div>
                        <p class="amount">2 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>
                    
                </div>
                <div>
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <p class="active">
                        Доступ к учебным материалам
                    </p>
                    <p class="active">
                        Доступ к чату
                    </p>
                    <p class="unactive">
                        Рабочая тетрадь
                    </p>
                    <p class="unactive">
                        Проверка домашних заданий
                    </p>
                    <p class="unactive">
                        Личный чат с кураторами
                    </p>
                    <div>
                        <p class="old-amount">4 900 ₽</p>
                        <p class="amount">3 900 ₽</p>
                        <p class="amount-notification">*Только для первого потока в течение первых суток</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Индивидуальный подход
                    </h3>
                    <p class="active">
                        Доступ к учебным материалам
                    </p>
                    <p class="active">
                        Доступ к чату
                    </p>
                    <p class="active">
                        Рабочая тетрадь
                    </p>
                    <p class="active">
                        Проверка домашних заданий
                    </p>
                    <p class="active">
                        Личный чат с кураторами
                    </p>
                    <div>
                        <p class="amount">11 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>`
    });

		blockManager.add('carrerum-tarifs-mob', {
			label: 'Тарифы (mobile)',  // can contain any HTML markup
			category: category, // name of component section
			attributes: {class:''}, // for toolbox icon
			content: `
			<div class="carrerum-tarifs-mob">
				<div>
						<div>
								<h2>Тарифы</h2>
						</div>
						<div>
								<div>
										<h3>
												Самостоятельный <br>  &nbsp;
										</h3>
										<p class="active">
												Доступ к учебным материалам
										</p>
										<p class="active">
												“Только посмотреть”
										</p>
										<p class="unactive">
												Доступ к чату
										</p>
										<p class="unactive">
												Рабочая тетрадь
										</p>
										<p class="unactive">
												Проверка домашних заданий
										</p>
										<p class="unactive">
												Личный чат с кураторами
										</p>
										<div>
												<p class="amount">2 900 ₽</p>
												<p class="places">количество мест ограничено</p>
												<a href="#">Забронировать место</a>
										</div>
										
								</div>
								<div>
										<h3>
												С поддержкой <br>  &nbsp;
										</h3>
										<p class="active">
												Доступ к учебным материалам
										</p>
										<p class="active">
												Доступ к чату
										</p>
										<p class="unactive">
												Рабочая тетрадь
										</p>
										<p class="unactive">
												Проверка домашних заданий
										</p>
										<p class="unactive">
												Личный чат с кураторами
										</p>
										<div>
												<p class="old-amount">4 900 ₽</p>
												<p class="amount">3 900 ₽</p>
												<p class="amount-notification">*Только для первого потока в течение первых суток</p>
												<p class="places">количество мест ограничено</p>
												<a href="#">Забронировать место</a>
										</div>                    
								</div>
								<div>
										<h3>
												Индивидуальный подход
										</h3>
										<p class="active">
												Доступ к учебным материалам
										</p>
										<p class="active">
												Доступ к чату
										</p>
										<p class="active">
												Рабочая тетрадь
										</p>
										<p class="active">
												Проверка домашних заданий
										</p>
										<p class="active">
												Личный чат с кураторами
										</p>
										<div>
												<p class="amount">11 900 ₽</p>
												<p class="places">количество мест ограничено</p>
												<a href="#">Забронировать место</a>
										</div> 
								</div>
						</div>
				</div>
			</div>`
    });

    blockManager.add('carrerum-faq', {
        label: 'FAQ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-faq">
        <div>
            <div>
                <h2>FAQ</h2>
            </div>
            <div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Мне кажется, что об успешной карьере могут задумываться только люди из международных корпораций, куда мне до них?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>          
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Как долго у меня будут в доступе материалы?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Можно ли на курс студенту или свежему выпускнику? Или вам тоже, как всем работодателям, нужен опыт?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Есть ли жизнь после курса? Что я получу взамен?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>А это не очередной мотивирующий тренинг, после которого непонятно, что делать дальше?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Мне уже 40, стоит начинать или уже все, пора завернуться в простынку и ползти к кладбищу?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
                <div>
                    <label>
                        <input type="checkbox">
                        <h3>Чем отличается курс от вашего карьерного клуба?</h3>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
                            Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
                    </label>
                </div>
            </div>
        </div>        
    </div>`
	});

	blockManager.add('carrerum-faq-mob', {
		label: 'FAQ (mobile)',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `
		<div class="carrerum-faq-mob">
			<div>
					<div>
							<h2>FAQ</h2>
					</div>
					<div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Мне кажется, что об успешной карьере могут задумываться только люди из международных корпораций, куда мне до них?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>          
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Как долго у меня будут в доступе материалы?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Можно ли на курс студенту или свежему выпускнику? Или вам тоже, как всем работодателям, нужен опыт?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Есть ли жизнь после курса? Что я получу взамен?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>А это не очередной мотивирующий тренинг, после которого непонятно, что делать дальше?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Мне уже 40, стоит начинать или уже все, пора завернуться в простынку и ползти к кладбищу?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
							<div>
									<label>
											<input type="checkbox">
											<h3>Чем отличается курс от вашего карьерного клуба?</h3>
											<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quos, dolore iure, amet exercitationem quis non mollitia tenetur eligendi quo beatae accusantium? Quod amet iusto consequuntur nemo id, dicta quae recusandae.
													Dicta quidem rerum voluptates vero distinctio est quos dignissimos, ipsa corporis atque, voluptatum iure aspernatur dolor. Commodi exercitationem accusantium adipisci inventore expedita aspernatur illum rerum, magnam fugit. Provident, placeat maxime!</p>
									</label>
							</div>
					</div>
			</div>
		</div>`
	});
	


	/* КНОПКА */
/*
	blockManager.add('button', {
		label: 'Кнопка',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `<div class="button">
		<div>
                <a href="">КУПИТЬ</a>
            </div>
	</div>`
	});

	blockManager.add('button-mobile', {
		label: 'Кнопка (mobile)',  // can contain any HTML markup
		category: category, // name of component section
		attributes: {class:''}, // for toolbox icon
		content: `<div class="button-mobile">
		<div>
                <a href="">КУПИТЬ</a>
            </div>
	</div>`
	});
	*/


    blockManager.add('carrerum-footer', {
        label: 'Футер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
			<div class="carrerum-footer">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615826066505.png" alt="">
                </div>
                <div>
                    <a href="mailto:school@dreamcatchme.ru">school@dreamcatchme.ru</a>
                </div>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242651.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615826119318.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242782.png" alt=""></a>
                </div>
            </div>
            <div>
                <div>
                    <ul>
                        <li><a href="#">О Карьеруме</a></li>
                        <li><a href="#">Карьерум.Старт</a></li>
                        <li><a href="#">Карьерум.Клуб</a></li>
                        <li><a href="#">Карьерум.Курс</a></li>
                        <li><a href="#">Карьерум.Лайфхаки</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Индивидуальный коучинг</a></li>
                        <li><a href="#">Кейсы участников</a></li>
                        <li><a href="#">Эксперты</a></li>
                        <li><a href="#">Вакансии</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Блог</a></li>
                        <li><a href="#">Пресса</a></li>
                        <li><a href="#">Телеграм-бот</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Пользовательсткое соглашение</a></li>
                        <li><a href="#">Политика конфиденциальности</a></li>
                    </ul>
                </div>
            </div>
            <div>
                <p>
                    Careerum 2021 - Все права защищены
                </p>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-footer-mob', {
        label: 'Футер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-footer-mob">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615826066505.png" alt="">
                </div>
                <div>
                    <a href="mailto:school@dreamcatchme.ru">school@dreamcatchme.ru</a>
                </div>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242651.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242713.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615826119318.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242782.png" alt=""></a>
                </div>
            </div>
            <div>
                <div>
                    <ul>
                        <li><a href="#">О Карьеруме</a></li>
                        <li><a href="#">Карьерум.Старт</a></li>
                        <li><a href="#">Карьерум.Клуб</a></li>
                        <li><a href="#">Карьерум.Курс</a></li>
                        <li><a href="#">Карьерум.Лайфхаки</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Индивидуальный коучинг</a></li>
                        <li><a href="#">Кейсы участников</a></li>
                        <li><a href="#">Эксперты</a></li>
                        <li><a href="#">Вакансии</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Блог</a></li>
                        <li><a href="#">Пресса</a></li>
                        <li><a href="#">Телеграм-бот</a></li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li><a href="#">Пользовательсткое соглашение</a></li>
                        <li><a href="#">Политика конфиденциальности</a></li>
                    </ul>
                </div>
            </div>
            <div>
                <p>
                    Careerum 2021 - Все права защищены
                </p>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup', {
        label: 'Попап',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-popup">
            <div>
                <div>
                    <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1615825242642.png" alt="">
                </div>
                <div>
                    <h2>Забронировать место на курсе</h2>
                    <input type="text" name="name" id="name" placeholder="Имя">
                    <input type="text" name="phone" id="phone" placeholder="Телефон">
                    <input type="text" name="email" id="email" placeholder="Электронная почта">
                    <a href="#">Забронировать место</a>
                    <div>
                        <p>Нажимая на кнопку, я соглашаюсь на обработку персональных данных</p>
                    </div>
                </div>
            </div>
        </div>`
    });

    blockManager.add('carrerum-popup-overlay', {
        label: 'Фон для попап (затеменение)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-popup-overlay">
        </div>`
    });

    
    blockManager.add('carrerum-popup-enter-gc', {
        label: 'Попап вход в GetCourse',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-gc" class="carrerum-popup-enter-gc carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    <span class="close">Вернуться на главную</span>
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа GetCourse</a></p>
                            <p><a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга Workplace</a></p>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-enter-gc-mobile', {
        label: 'Попап вход в GetCourse (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-gc-mobile" class="carrerum-popup-enter-gc-mobile carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа GetCourse</a></p>
                            <p><a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга Workplace</a></p>
                        </div>                        
                        <span class="close">Вернуться на главную</span>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-enter-gc-tablet', {
        label: 'Попап вход в GetCourse (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-gc-tablet" class="carrerum-popup-enter-gc-tablet carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    <span class="close">Вернуться на главную</span>
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа GetCourse</a></p>
                            <p><a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга Workplace</a></p>
                        </div>                        
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-enter-wp', {
        label: 'Попап вход в Workplace',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-wp" class="carrerum-popup-enter-wp carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    <span class="close">Вернуться на главную</span>
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a class="close-switch" href="#popup-enter-gc">Образовательная платформа GetCourse</a></p>
                            <p>Платформа для нетворкинга Workplace</p>
                        </div>                        
                        <input type="text" placeholder="Логин">
                        <input type="password" placeholder="Пароль">
                        <button>Войти</button>
                        <a href="#">Не помню пароль</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-enter-wp-mobile', {
        label: 'Попап вход в Workplace (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-wp-mobile" class="carrerum-popup-enter-wp-mobile carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a class="close-switch" href="#popup-enter-gc-mobile">Образовательная платформа GetCourse</a></p>
                            <p>Платформа для нетворкинга Workplace</p>
                        </div>                        
                        <input type="text" placeholder="Логин">
                        <input type="password" placeholder="Пароль">
                        <button>Войти</button>
                        <a href="#">Не помню пароль</a>
                        <span class="close">Вернуться на главную</span>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-enter-wp-tablet', {
        label: 'Попап вход в Workplace (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-wp-tablet" class="carrerum-popup-enter-wp-tablet carrerum-popup">
        <div>
            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017793388.png" alt=""></div>
            <div>
                <div>
                    <span class="close">Вернуться на главную</span>
                    <div>
                        <h2>Войти в личный кабинет</h2>
                        <div>
                            <p><a class="close-switch" href="#popup-enter-gc-tablet">Образовательная платформа GetCourse</a></p>
                            <p>Платформа для нетворкинга Workplace</p>
                        </div>                        
                        <input type="text" placeholder="Логин">
                        <input type="password" placeholder="Пароль">
                        <button>Войти</button>
                        <a href="#">Не помню пароль</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-subscribe', {
        label: 'Попап для подписки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-subscribe" class="carrerum-popup-subscribe carrerum-popup">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017867471.png" class="close" alt="">
        </div>
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017900954.png" alt="">
            <div>
                <h2>Подпишитесь, чтобы получать полезные материалы о развитии карьерых</h2>
                <div>
                    <input type="email" placeholder="E-mail">
                    <button>Подписаться</button>
                </div>                
            </div>            
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-subscribe-mobile', {
        label: 'Попап для подписки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-subscribe-mobile" class="carrerum-popup-subscribe-mobile carrerum-popup">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619446740088.png" class="close" alt="">
            <div>
                <h2>Подпишитесь, чтобы получать полезные материалы о развитии карьерых</h2>
                <div>
                    <input type="email" placeholder="E-mail">
                    <button>Подписаться</button>
                </div>                
            </div>            
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-subscribe-tablet', {
        label: 'Попап для подписки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-subscribe-tablet" class="carrerum-popup-subscribe-tablet carrerum-popup">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619446740088.png" class="close" alt="">
            <div>
                <h2>Подпишитесь, чтобы получать полезные материалы о развитии карьерых</h2>
                <div>
                    <input type="email" placeholder="E-mail">
                    <button>Подписаться</button>
                </div>                
            </div>            
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-about', {
        label: 'Попап об авторе',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-about carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        </div>
        <div>
            <div> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017923667.png" alt=""> </div>
            <div>
                <h2>Ольга Лермонтова</h2>
                <p>Основательница платформы Карьерум</p>
            </div>
        </div>
        <div>
            <ul>
                <li>14+ лет успешной международной карьеры в 5 странах в компаниях Google, Microsoft</li>
                <li>Степень MBA от бизнес-школы INSEAD</li>
                <li>Управляла бизнесом на более чем 20 рынках Западной и Восточной Европы и Африки</li>
                <li>Стратег и карьерный коуч с аккредитацией ICF</li>
                <li>Помогла 5000+ человек открыть в себе таланты, полюбить свою работу и сделать ее источником энергии</li>
                <li>Автор образовательных блогов о карьере с аудиторией более 200 тысяч человек</li>
            </ul>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-about-mobile', {
        label: 'Попап об авторе (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-about-mobile carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        </div>
        <div>
            <div> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017923667.png" alt=""> </div>
            <div>
                <h2>Ольга Лермонтова</h2>
                <p>Основательница платформы Карьерум</p>
            </div>
        </div>
        <div>
            <ul>
                <li>14+ лет успешной международной карьеры в 5 странах в компаниях Google, Microsoft</li>
                <li>Степень MBA от бизнес-школы INSEAD</li>
                <li>Управляла бизнесом на более чем 20 рынках Западной и Восточной Европы и Африки</li>
                <li>Стратег и карьерный коуч с аккредитацией ICF</li>
                <li>Помогла 5000+ человек открыть в себе таланты, полюбить свою работу и сделать ее источником энергии</li>
                <li>Автор образовательных блогов о карьере с аудиторией более 200 тысяч человек</li>
            </ul>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-about-tablet', {
        label: 'Попап об авторе (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-about-tablet carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        </div>
        <div>
            <div> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017923667.png" alt=""> </div>
            <div>
                <h2>Ольга Лермонтова</h2>
                <p>Основательница платформы Карьерум</p>
            </div>
        </div>
        <div>
            <ul>
                <li>14+ лет успешной международной карьеры в 5 странах в компаниях Google, Microsoft</li>
                <li>Степень MBA от бизнес-школы INSEAD</li>
                <li>Управляла бизнесом на более чем 20 рынках Западной и Восточной Европы и Африки</li>
                <li>Стратег и карьерный коуч с аккредитацией ICF</li>
                <li>Помогла 5000+ человек открыть в себе таланты, полюбить свою работу и сделать ее источником энергии</li>
                <li>Автор образовательных блогов о карьере с аудиторией более 200 тысяч человек</li>
            </ul>
        </div>
    </div>`
    });


    blockManager.add('carrerum-popup-form', {
        label: 'Попап для вступления в клуб',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-form carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        <div>
            <h2>Набор в клуб открыт! <br> Получите место уже сегодня</h2>
            <p>Мы принимаем новых участников всего раз в 3-4 месяца в течение нескольких дней. Сегодня — именно такой день. Заполните форму, чтобы успеть в это окно.</p>
            <form class="deva-form" name="devaRegistrationForm">
                <input type="text" name="name" placeholder="Имя">
                <input type="phone" name="phone" placeholder="Телефон">
                <input type="email" name="email" placeholder="Электронная почта">
                <button type="submit"></button>
            </form>
            <p>Сложности с покупкой? Напишите нам на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>. До встречи в клубе!</p>
        </div>        
    </div>`
    });

    blockManager.add('carrerum-popup-form-tablet', {
        label: 'Попап для вступления в клуб (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-form-tablet carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619446999263.png" alt="">
        <div>
            <h2>Забронируйте свое место в клубе</h2>
            <p>Сейчас клуб закрыт: оформить подписку можно раз в 3-4 месяца. Вы можете вступить в лист ожидания и раньше остальных узнать о новом наборе.</p>
            <input type="text" name="name" placeholder="Имя">
            <input type="tel" name="tel" placeholder="Телефон">
            <input type="email" name="email" placeholder="Электронная почта">
            <button type="submit">Записаться</button>
            <p>Если вы раньше уже покупали наши продукты, напишите нам на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>, и мы оформим вам подписку сразу, вне очереди. До встречи в клубе!</p>
        </div>        
    </div>`
    });
    
    blockManager.add('carrerum-popup-form-mobile', {
        label: 'Попап для вступления в клуб (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-form-mobile carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619446999263.png" alt="">
        <div>
            <h2>Забронируйте свое место в клубе</h2>
            <input type="text" name="name" placeholder="Имя">
            <input type="tel" name="tel" placeholder="Телефон">
            <input type="email" name="email" placeholder="Электронная почта">
            <button type="submit">Записаться</button>
            <p>Если вы раньше уже покупали наши продукты, напишите нам на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>, и мы оформим вам подписку сразу, вне очереди. До встречи в клубе!</p>
        </div>        
    </div>`
    });


    blockManager.add('carrerum-popup-enter-auth', {
        label: 'Попап войти в кабинет',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-auth" class="carrerum-popup-enter-auth carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        <div>
            <h2>Выберите платформу для входа</h2>
            <a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа</a>
            <a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга</a>
        </div>        
    </div>`
    });

    blockManager.add('carrerum-popup-enter-auth-tablet', {
        label: 'Попап войти в кабинет (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-auth-tablet" class="carrerum-popup-enter-auth-tablet carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        <div>
            <h2>Выберите платформу для входа</h2>
            <a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа</a>
            <a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга</a>
        </div>        
    </div>`
    });

    blockManager.add('carrerum-popup-enter-auth-mobile', {
        label: 'Попап войти в кабинет (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div id="popup-enter-auth-mobile" class="carrerum-popup-enter-auth-mobile carrerum-popup">
        <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
        <div>
            <h2>Выберите платформу для входа</h2>
            <a href="https://school.careerum.ru/cms/system/login?required=true" target="_blank">Образовательная платформа</a>
            <a href="https://network.careerum.ru/" target="_blank">Платформа для нетворкинга</a>
        </div>        
    </div>`
    });




    blockManager.add('carrerum-subscribe-text', {
        label: 'По всем вопросам - email',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-subscribe-text">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195293268.png" alt="">
            <p>
                По всем вопросам пишите на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-subscribe-text-tablet', {
        label: 'По всем вопросам - email (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-subscribe-text-tablet">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195293268.png" alt="">
            <p>
                По всем вопросам пишите на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-subscribe-text-mobile', {
        label: 'По всем вопросам - email (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-subscribe-text-mobile">
        <div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195293268.png" alt="">
            <p>
                По всем вопросам пишите на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });




    blockManager.add('carrerum-about-author-with-publications', {
        label: 'Автор с публикациями',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-author-with-publications">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195975874.png" alt="">
            </div>
            <div>
                <h3><span>Ольга Лермонтова </span> <br> международный карьерный коуч и стратег</h3>
                <ul>
                    <li>14+ лет карьеры в Google, Microsoft и других компаниях в 5 странах</li>
                    <li>Основательница самой крупной в России и СНГ платформы карьерного развития Карьерум</li>
                    <li>5000+ клиентов, которые открыли в себе таланты, нашли любимую работу и получили повышение</li>
                    <li>MBA от бизнес-школы INSEAD</li>
                    <li>Коучинговая сертификация ICF</li>
                    <li>Автор публикаций </li>
                </ul>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195999258.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196058769.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196077551.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196097887.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196113804.png" alt=""></a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-about-author-with-publications-tablet', {
        label: 'Автор с публикациями (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-author-with-publications-tablet">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195975874.png" alt="">
            </div>
            <div>
                <h3><span>Ольга Лермонтова </span> <br> международный карьерный коуч и <br> стратег</h3>
                <ul>
                    <li>14+ лет карьеры в Google, Microsoft и других компаниях в 5 странах</li>
                    <li>Основательница самой крупной в России и СНГ платформы карьерного развития Карьерум</li>
                    <li>5000+ клиентов, которые открыли в себе таланты, нашли любимую работу и получили повышение</li>
                    <li>MBA от бизнес-школы INSEAD</li>
                    <li>Коучинговая сертификация ICF</li>
                    <li>Автор публикаций </li>
                </ul>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195999258.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196058769.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196077551.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196097887.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196113804.png" alt=""></a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-about-author-with-publications-mobile', {
        label: 'Автор с публикациями (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-author-with-publications-mobile">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195975874.png" alt="">
            </div>
            <div>
                <h3><span>Ольга Лермонтова </span> <br> международный карьерный<br> коуч и стратег</h3>
                <ul>
                    <li>14+ лет карьеры в Google, Microsoft и других компаниях в 5 странах</li>
                    <li>Основательница самой крупной в России и СНГ платформы карьерного развития Карьерум</li>
                    <li>5000+ клиентов, которые открыли в себе таланты, нашли любимую работу и получили повышение</li>
                    <li>MBA от бизнес-школы INSEAD</li>
                    <li>Коучинговая сертификация ICF</li>
                    <li>Автор публикаций </li>
                </ul>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622195999258.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196058769.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196077551.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196097887.png" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622196113804.png" alt=""></a>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-button', {
        label: 'Кнопка',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <a class="carrerum-button" href="#">Зарегистрироваться</a>
    `
    });


    blockManager.add('carrerum-text-with-three-buttons', {
        label: '3 кнопки',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-with-three-buttons">
        <div>
            <h2>Бесплатные материалы о карьере</h2>
            <div>
                <a href="#">Чек-лист «Карьерный год»</a>
                <a href="#">«Тест на зоны роста»</a>
                <a href="#">Еще бесплатное</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-text-with-three-buttons-tablet', {
        label: '3 кнопки (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-with-three-buttons-tablet">
        <div>
            <h2>Бесплатные материалы о карьере</h2>
            <div>
                <a href="#">Чек-лист «Карьерный год»</a>
                <a href="#">«Тест на зоны роста»</a>
                <a href="#">Еще бесплатное</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-text-with-three-buttons-mobile', {
        label: '3 кнопки (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-with-three-buttons-mobile">
        <div>
            <h2>Бесплатные материалы<br> о карьере</h2>
            <div>
                <a href="#">Чек-лист «Карьерный год»</a>
                <a href="#">«Тест на зоны роста»</a>
                <a href="#">Еще бесплатное</a>
            </div>
        </div>
    </div>`
    });
    

    blockManager.add('carrerum-clients-top-companies', {
        label: 'Клиенты из топ компаний',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-clients-top-companies"> 
        <div>
            <h2>Мои клиенты — в топовых компаниях по всему миру</h2>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
            </div>
        </div>        
    </div>`
    });

    blockManager.add('carrerum-clients-top-companies-tablet', {
        label: 'Клиенты из топ компаний (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-clients-top-companies-tablet"> 
        <div>
            <h2>Мои клиенты — в топовых компаниях по <br> всему миру</h2>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
            </div>
        </div>        
    </div>`
    });

    blockManager.add('carrerum-clients-top-companies-mobile', {
        label: 'Клиенты из топ компаний (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-clients-top-companies-mobile"> 
        <div>
            <h2>Мои клиенты — в топовых компаниях по всему миру</h2>
            <div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748022168.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748047192.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748063360.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748081304.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748096899.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748115639.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748131788.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748149569.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748166412.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748183165.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748200576.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748217475.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748235275.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748254496.png" alt=""></div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619748271485.png" alt=""></div>
            </div>
        </div>        
    </div>`
    });


    
    blockManager.add('carrerum-how-to-learn', {
        label: 'Как можно учиться у меня',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-how-to-learn">
        <div>
            <h2>Как можно у меня учиться</h2>
            <div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214751835.png" alt=""></div>
                    <h3>Карьерум.Клуб</h3>
                    <p>Сообщество и образовательные программы для тех, кто уже готов к конкретным шагам и хочет прицельно прокачать конкретный аспект карьеры</p>
                    <h4>Формат: ежемесячная подписка</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214776846.png" alt=""></div>
                    <h3>Карьерум.Старт</h3>
                    <p>Первый шаг для тех, кто пока не знает, как строить карьеру осознанно и какую работу выбирать, но хочет разобраться и приблизиться к цели</p>
                    <h4>Формат: 5 - недельный курс</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214795660.png" alt=""></div>
                    <h3>Личный коучинг</h3>
                    <p>Индивидуальная форма работы, где вы сможете найти лучшее для себя решение с помощью моих вопросов и техник</p>
                    <h4>Формат: 50-минутные сессии</h4>
                    <a href="#">Узнать больше</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-how-to-learn-tablet', {
        label: 'Как можно учиться у меня (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-how-to-learn-tablet">
        <div>
            <h2>Как можно у меня учиться</h2>
            <div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214751835.png" alt=""></div>
                    <h3>Карьерум.Клуб</h3>
                    <p>Сообщество и образовательные программы для тех, кто уже готов к конкретным шагам и хочет прицельно прокачать конкретный аспект карьеры</p>
                    <h4>Формат: ежемесячная подписка</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214776846.png" alt=""></div>
                    <h3>Карьерум.Старт</h3>
                    <p>Первый шаг для тех, кто пока не знает, как строить карьеру осознанно и какую работу выбирать, но хочет разобраться и приблизиться к цели</p>
                    <h4>Формат: 5 - недельный курс <br>&nbsp;	</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214795660.png" alt=""></div>
                    <h3>Личный коучинг</h3>
                    <p>Индивидуальная форма работы, где вы сможете найти лучшее для себя решение с помощью моих вопросов и техник</p>
                    <h4>Формат: 50-минутные сессии</h4>
                    <a href="#">Узнать больше</a>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-how-to-learn-mobile', {
        label: 'Как можно учиться у меня (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-how-to-learn-mobile">
        <div>
            <h2>Как можно у меня учиться</h2>
            <div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214751835.png" alt=""></div>
                    <h3>Карьерум.Клуб</h3>
                    <p>Сообщество и образовательные программы для тех, кто уже готов к конкретным шагам и хочет прицельно прокачать конкретный аспект карьеры</p>
                    <h4>Формат: ежемесячная подписка</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214776846.png" alt=""></div>
                    <h3>Карьерум.Старт</h3>
                    <p>Первый шаг для тех, кто пока не знает, как строить карьеру осознанно и какую работу выбирать, но хочет разобраться и приблизиться к цели</p>
                    <h4>Формат: 5 - недельный курс</h4>
                    <a href="#">Узнать больше</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622214795660.png" alt=""></div>
                    <h3>Личный коучинг</h3>
                    <p>Индивидуальная форма работы, где вы сможете найти лучшее для себя решение с помощью моих вопросов и техник</p>
                    <h4>Формат: 50-минутные сессии</h4>
                    <a href="#">Узнать больше</a>
                </div>
            </div>
        </div>
    </div>`
    });



    blockManager.add('carrerum-text-in-frame', {
        label: 'Текст в рамке',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-in-frame">
        <div>
            <h2>«Как прийти к таким результатам, если пока я не знаю, с чего начать?»</h2>
            <div>
                <p>
                    Подпишитесь на Карьерум.Кофе — рассылку, где я делюсь карьерными лайфхаками. Приходит по <br> понедельникам, заряжает, как чашка кофе, и позволяет двигаться к цели небольшими шагами.
                </p>
            </div>
            <a href="#">Хочу кофе</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-text-in-frame-tablet', {
        label: 'Текст в рамке (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-in-frame-tablet">
        <div>
            <h2>«Как прийти к таким результатам, если пока я <br> не знаю, с чего начать?»</h2>
            <div>
                <p>
                    Подпишитесь на Карьерум.Кофе — рассылку, где я делюсь карьерными лайфхаками. <br> Приходит по понедельникам, заряжает, как чашка кофе, и позволяет двигаться к цели небольшими шагами.
                </p>
            </div>
            <a href="#">Хочу кофе</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-text-in-frame-mobile', {
        label: 'Текст в рамке (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-text-in-frame-mobile">
        <div>
            <h2>«Как прийти к таким результатам, если пока я не знаю, с чего начать?»</h2>
            <div>
                <p>
                    Подпишитесь на Карьерум.Кофе — рассылку, где я делюсь карьерными лайфхаками. Приходит по понедельникам, заряжает, как чашка кофе, и позволяет двигаться к цели небольшими шагами.
                </p>
            </div>
            <a href="#">Хочу кофе</a>
        </div>
    </div>`
    });

    
    blockManager.add('carrerum-about-rayan', {
        label: 'О Райане',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-rayan">
        <div>
            <div>
                <div>
                    <h2>Карьерный бот Райан</h2>
                    <p>Поможет определить зоны роста, пришлет полезные материалы и раньше остальных откроет доступ к продажам моих закрытых продуктов</p>
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217814642.png" alt=""></div>
            </div>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217841765.png" alt="">
                    </div>
                    <h3>«Хочу все знать»</h3>
                    <p>Узнайте все о ваших зонах роста, чтобы прокачать их для новой работы или повышения</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217862356.png" alt="">
                    </div>
                    <h3>«Смотреть бесплатно»</h3>
                    <p>Смотрите 1,5 часа лучших мастер-классов про резюме, интервью и путь к повышению</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217885325.png" alt="">
                    </div>
                    <h3>«Эфиры»</h3>
                    <p>Смотрите бесплатную подборка популярных эфиров на карьерные темы с экспертами и участниками Карьерума</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217906317.png" alt="">
                    </div>
                    <h3>«Вейтлист»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Клуба, чтобы раньше других получить весточку о его открытии</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217924307.png" alt="">
                    </div>
                    <h3>«На Старт»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Старта, чтобы забронировать место в следующем потоке</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217949953.png" alt="">
                    </div>
                    <h3>«Посоветуй фильм»</h3>
                    <p>Доверьте Райану выбор кино на вечер — он не подведет</p>
                </div>
            </div>
            <a href="#">Написать Райану</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-about-rayan-tablet', {
        label: 'О Райане (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-rayan-tablet">
        <div>
            <div>
                <div>
                    <h2>Карьерный бот Райан</h2>
                    <p>Поможет определить зоны роста, пришлет полезные материалы и раньше остальных откроет доступ к продажам моих закрытых продуктов</p>
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217814642.png" alt=""></div>
            </div>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217841765.png" alt="">
                    </div>
                    <h3>«Хочу все знать»</h3>
                    <p>Узнайте все о ваших зонах роста, чтобы прокачать их для новой работы или повышения</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217862356.png" alt="">
                    </div>
                    <h3>«Смотреть бесплатно»</h3>
                    <p>Смотрите 1,5 часа лучших мастер-классов про резюме, интервью и путь к повышению</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217885325.png" alt="">
                    </div>
                    <h3>«Эфиры»</h3>
                    <p>Смотрите бесплатную подборка популярных эфиров на карьерные темы с экспертами и участниками Карьерума</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217906317.png" alt="">
                    </div>
                    <h3>«Вейтлист»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Клуба, чтобы раньше других получить весточку о его открытии</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217924307.png" alt="">
                    </div>
                    <h3>«На Старт»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Старта, чтобы забронировать место в следующем потоке</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217949953.png" alt="">
                    </div>
                    <h3>«Посоветуй фильм»</h3>
                    <p>Доверьте Райану выбор кино на вечер — он не подведет</p>
                </div>
            </div>
            <a href="#">Написать Райану</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-about-rayan-mobile', {
        label: 'О Райане (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-about-rayan-mobile">
        <div>
            <div>
                <div>
                    <h2>Карьерный бот Райан</h2>
                    <p>Поможет определить зоны роста, пришлет полезные материалы и раньше остальных откроет доступ к продажам моих закрытых продуктов</p>
                </div>
                <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217814642.png" alt=""></div>
            </div>
            <div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217841765.png" alt="">
                    </div>
                    <h3>«Хочу все знать»</h3>
                    <p>Узнайте все о ваших зонах роста, чтобы прокачать их для новой работы или повышения</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217862356.png" alt="">
                    </div>
                    <h3>«Смотреть бесплатно»</h3>
                    <p>Смотрите 1,5 часа лучших мастер-классов про резюме, интервью и путь к повышению</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217885325.png" alt="">
                    </div>
                    <h3>«Эфиры»</h3>
                    <p>Смотрите бесплатную подборка популярных эфиров на карьерные темы с экспертами и участниками Карьерума</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217906317.png" alt="">
                    </div>
                    <h3>«Вейтлист»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Клуба, чтобы раньше других получить весточку о его открытии</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217924307.png" alt="">
                    </div>
                    <h3>«На Старт»</h3>
                    <p>Запишитесь в лист ожидания Карьерум.Старта, чтобы забронировать место в следующем потоке</p>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622217949953.png" alt="">
                    </div>
                    <h3>«Посоветуй фильм»</h3>
                    <p>Доверьте Райану выбор кино на вечер — он не подведет</p>
                </div>
            </div>
            <a href="#">Написать Райану</a>
        </div>
    </div>`
    });

    

    blockManager.add('carrerum-watch-read', {
        label: 'Посмотреть и почитать',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-watch-read">
        <div>
            <h2>Посмотреть и почитать</h2>
            <div>
                <div>
                    <p>Ролики, которые помогают менять карьеру</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218369196.png" alt=""><p>Смотреть видео</p> </a>
                </div>
                <div>
                    <p>Мой Telegram-канал</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218393395.png" alt=""><p>Подписаться</p></a>
                </div>
                <div>
                    <p>Статьи в СМИ</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218422377.png" alt=""><p>Читать</p></a>
                </div>
            </div>
            <p>
                По всем вопросам о Карьеруме и индивидуальном коучинге пишите <br> на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-watch-read-tablet', {
        label: 'Посмотреть и почитать (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-watch-read-tablet">
        <div>
            <h2>Посмотреть и почитать</h2>
            <div>
                <div>
                    <p>Ролики, которые помогают менять карьеру</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218369196.png" alt=""><p>Смотреть видео</p> </a>
                </div>
                <div>
                    <p>Мой Telegram-канал</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218393395.png" alt=""><p>Подписаться</p></a>
                </div>
                <div>
                    <p>Статьи в СМИ</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218422377.png" alt=""><p>Читать</p></a>
                </div>
            </div>
            <p>
                По всем вопросам о Карьеруме и индивидуальном коучинге пишите <br> на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-watch-read-mobile', {
        label: 'Посмотреть и почитать (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-watch-read-mobile">
        <div>
            <h2>Посмотреть и почитать</h2>
            <div>
                <div>
                    <p>Ролики, которые помогают менять карьеру</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218369196.png" alt=""><p>Смотреть видео</p> </a>
                </div>
                <div>
                    <p>Мой Telegram-канал</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218393395.png" alt=""><p>Подписаться</p></a>
                </div>
                <div>
                    <p>Статьи в СМИ</p>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622218422377.png" alt=""><p>Читать</p></a>
                </div>
            </div>
            <p>
                По всем вопросам о Карьеруме и индивидуальном коучинге пишите на <a href="mailto:hello@careerum.ru">hello@careerum.ru</a>
            </p>
        </div>
    </div>`
    });

    

    blockManager.add('carrerum-slider-with-links-buttons', {
        label: 'Слайдер с кнопками и ссылками',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-slider-with-links-buttons">
        <div>
            <div>
                <div class="slider slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683476600.png" alt="">
                        <p>Понятный алгоритм, который поможет без стресса проходить любые собеседования и получать офферы</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683483713.png" alt="">
                        <p>Надежный способ постоянно расти в должности и зарплате, работая не 24/7, а головой</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683490779.png" alt="">
                        <p>Пошаговый путь к любой карьерной цели — новой работе, повышению, релокации</p>
                        <div>
                            <a href="#"></a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683513965.png" alt="">
                        <p>Секретные навыки, которыми владеют те, кто научился строить успешную карьеру в удовольствие</p>
                        <div>
                            <a href="#"></a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683467275.png" alt="">
                        <p>Эффективная формула, которая даст вам <br> преимущество перед конкурентами в любой точке <br> мира</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                </div>
            </div>            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-slider-with-links-buttons-tablet', {
        label: 'Слайдер с кнопками и ссылками (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-slider-with-links-buttons-tablet">
        <div>
            <div>
                <div class="slider slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683476600.png" alt="">
                        <p>Понятный алгоритм, который поможет без стресса проходить любые собеседования и получать офферы</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683483713.png" alt="">
                        <p>Надежный способ постоянно расти в должности и зарплате, работая не 24/7, а головой</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683490779.png" alt="">
                        <p>Пошаговый путь к любой карьерной цели — новой работе, повышению, релокации</p>
                        <div>
                            <a href="#"></a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683513965.png" alt="">
                        <p>Секретные навыки, которыми владеют те, кто научился строить успешную карьеру в удовольствие</p>
                        <div>
                            <a href="#"></a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1621683467275.png" alt="">
                        <p>Эффективная формула, которая даст вам <br> преимущество перед конкурентами в любой точке <br> мира</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                </div>
            </div>            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-slider-with-links-buttons-mobile', {
        label: 'Слайдер с кнопками и ссылками (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-slider-with-links-buttons-mobile">
        <div>
            <div>
                <div class="slider slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622553682942.png" alt="">
                        <p>Эффективная формула, которая даст вам преимущество перед конкурентами в любой точке <br> мира</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622553719389.png" alt="">
                        <p>Понятный алгоритм, который поможет без стресса проходить любые собеседования и получать офферы</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622553738411.png" alt="">
                        <p>Надежный способ постоянно расти в должности и зарплате, работая не 24/7, а головой</p>
                        <div>
                            <a href="#">Смотреть 30 минут бесплатно</a>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622553757610.png" alt="">
                        <p>Пошаговый путь к любой карьерной цели — новой работе, повышению, релокации</p>
                        <div>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622553777575.png" alt="">
                        <p>Секретные навыки, которыми владеют те, кто научился строить успешную карьеру в удовольствие</p>
                        <div>
                            <a href="#">Купить</a>
                        </div>                        
                    </div>
                </div>
            </div>            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-letters-slider-mobile', {
        label: 'Слайдер с письмами (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-letters-slider-mobile">
        <div>
            <div>
                <h2>Письма, которые больше всего нравятся нашим читателям</h2>
            </div>
            <div>
                <div class="slider slider-block">
                    <div>
                        <h3>Как Шелдон Купер и Джоуи помогут вам в карьере</h3>
                        <p>Зимой так и хочется вечером закутаться в плед, обнять кота и включить интересный фильм или сериал. Давайте проведем это время с пользой и разберем на примере киношных героев, как надо и как не надо искать работу.
                        </p>
                    </div>
                    <div>
                        <h3>10 фатальных карьерных ошибок</h3>
                        <p>Бывало с вами такое — весь день крутитесь, как белка в колесе, а к повышению не приблизились ни на шаг? Возможно, вы крутитесь не в ту сторону. Или не в том колесе. Или крутиться — это просто не ваше.</p>
                    </div>
                    <div>
                        <h3>Несносные боссы и 4 лайфхака, как сделать работу с ними эффективной</h3>
                        <p>Иногда я думаю, что сообщения и комментарии от читателей моего блога могли бы стать основой для целого сериала под названием «Несносные боссы».</p>
                    </div>
                    <div>
                        <h3>Пройдите тест и узнайте, можете ли вы работать за границей</h3>
                        <p>Хотели бы вывести свою карьеру на международный уровень и жить то в одной стране, то в другой? Или вы просто мечтаете об эмиграции, но ваша мечта пока выглядит размыто?</p>
                    </div>
                    <div>
                        <h3>5 правил успешного собеседования</h3>
                        <p>Хотите, чтобы на интервью рекрутеры и потенциальные начальники не просто слушали вас с интересом, а уже представляли вас частью своей команды? Добиться этого вам помогут 5 правил успешного собеседования.</p>
                    </div>
                    <div>
                        <h3>Как стать кандидатом на повышение №1</h3>
                        <p>Как думаете, что нужно, чтобы продвигаться по службе? Играть в футбол с боссом? Быть душкой и со всеми иметь хорошие отношения? Быть рок-звездой в своей профессии?</p>
                    </div>
                    <div>
                        <h3>Странные советы, беседы ни о чем и неосознанное хамство</h3>
                        <p>Первый заграничный оффер получен. Радость, счастье, эйфория и ощущение, что весь мир упал к ногам! Однако уже в первые недели работы приходит осознание, что пройти собеседование на английском...</p>
                    </div>
                    <div>
                        <h3>5 лайфхаков: испытательный срок как трамплин для карьеры</h3>
                        <p>Ира не придавала особого значения испытательному сроку, считая, что главное просто его пройти. Она усердно выполняла свои обязанности финансового аналитика, ходила на обед с компанией из своего отдела...</p>
                    </div>
                    <div>
                        <h3>Работа в домашних тапочках</h3>
                        <p>Я руковожу сразу двумя удаленными командами: своим отделом в международной компании и карьерным клубом. И я точно знаю, что удаленная работа...</p>
                    </div>
                    <div>
                        <h3>Как связаны искушение и поиск работы</h3>
                        <p>Поиск работы чем-то похож на занятия спортом. Например, тем, что мы все время откладываем его на потом :) Между тем поиск работы требует времени и регулярных усилий. Отправлять одно резюме в месяц...</p>
                    </div>
                </div>
            </div>
            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-columns-text-highlight', {
        label: 'Колонки текста с выделением',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-columns-text-highlight">
        <div>
            <div>
                <h2>Этот курс для вас, если:</h2>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622630300453.png" alt="">
                </div>
            </div>
            <div class="flex-row">
                <div>
                    <p><span>Недовольны текущей работой</span>, <br>    но не знаете, как конкретно это изменить и какую новую искать</p>
                </div>
                <div>
                    <p><span>Думаете, что «уже поздно»</span>, «еще рано» или «не хватает опыта и навыков» для достижения целей</p>
                </div>
                <div>
                    <p><span>Постоянно меняете работу</span>, но находите удовлетворение лишь на короткий срок</p>
                </div>
            </div>
            <div class="flex-row">
                <div>
                    <p><span>Чувствуете, что выгорели на работе</span>, хотя раньше она вам нравилась, а теперь тяжело про нее даже думать</p>
                </div>
                <div>
                    <p><span>Чувствуете себя ежиком в тумане</span> и не понимаете, чего хотите от своей карьеры, в какой сфере развиваться, в какую сторону копать</p>
                </div>
                <div>
                    <p><span>Уверены, что в карьере вы ни <br> на что не влияете</span>, а все зависит от вашего начальника и от обстоятельств</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-columns-text-highlight-tablet', {
        label: 'Колонки текста с выделением (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-columns-text-highlight-tablet">
        <div>
            <div>
                <h2>Этот курс для вас, если</h2>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622630321822.png" alt="">
                </div>
            </div>
            <div class="flex-row">
                <div>
                    <p><span>Недовольны текущей работой</span>, <br>    но не знаете, как конкретно это изменить и какую новую искать</p>
                </div>
                <div>
                    <p><span>Думаете, что «уже поздно»</span>, «еще рано» или «не хватает опыта и навыков» для достижения целей</p>
                </div>
                <div>
                    <p><span>Постоянно меняете работу</span>, но находите удовлетворение лишь на короткий срок</p>
                </div>
            </div>
            <div class="flex-row">
                <div>
                    <p><span>Чувствуете, что выгорели на работе</span>, хотя раньше она вам нравилась, а теперь тяжело про нее даже думать</p>
                </div>
                <div>
                    <p><span>Чувствуете себя ежиком в тумане</span> и не понимаете, чего хотите от своей карьеры, в какой сфере развиваться, в какую сторону копать</p>
                </div>
                <div>
                    <p><span>Уверены, что в карьере вы ни <br> на что не влияете</span>, а все зависит от вашего начальника и от обстоятельств</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-columns-text-highlight-mobile', {
        label: 'Колонки текста с выделением (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-columns-text-highlight-mobile">
        <div>
            <div>
                <h2>Этот курс для вас, если</h2>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1622630351444.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <p><span>Недовольны текущей работой</span>, но не знаете, как конкретно это изменить и какую новую искать</p>
                </div>
                <div>
                    <p><span>Думаете, что «уже поздно»</span>, «еще рано» или «не хватает опыта и навыков» для достижения целей</p>
                </div>
                <div>
                    <p><span>Постоянно меняете работу</span>, но находите удовлетворение лишь на короткий срок</p>
                </div>
                <div>
                    <p><span>Чувствуете, что выгорели на работе</span>, хотя раньше она вам нравилась, а теперь тяжело про нее даже думать</p>
                </div>
                <div>
                    <p><span>Чувствуете себя ежиком в тумане</span> и не понимаете, чего хотите от своей карьеры, в какой сфере развиваться, в какую сторону копать</p>
                </div>
                <div>
                    <p><span>Уверены, что в карьере вы ни на что не влияете</span>, а все зависит от вашего начальника и от обстоятельств</p>
                </div>
            </div>
        </div>
    </div>`
    });


        
    blockManager.add('carrerum-tarifs-with-points', {
        label: 'Тарифы с пунктами',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarifs-with-points">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-unactive"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-unactive"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-unactive"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">2 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>
                    
                </div>
                <div class="best-choice">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="old-amount">4 900 ₽</p>
                        <p class="amount">3 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Индивидуальный подход
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-active"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-active"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">11 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-tarifs-with-points-tablet', {
        label: 'Тарифы с пунктами (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarifs-with-points-tablet">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-unactive"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-unactive"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-unactive"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">2 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>
                    
                </div>
                <div class="best-choice">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="old-amount">4 900 ₽</p>
                        <p class="amount">3 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Индивидуальный подход
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-active"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-active"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">11 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-tarifs-with-points-mobile', {
        label: 'Тарифы с пунктами (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarifs-with-points-mobile">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-unactive"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-unactive"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-unactive"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">2 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>
                    
                </div>
                <div class="best-choice">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-unactive"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-unactive"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="old-amount">4 900 ₽</p>
                        <p class="amount">3 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Индивидуальный подход<br>  &nbsp;
                    </h3>
                    <ul>
                        <li class="li-active"><p>Пройти мастер-класс</p><div></div></li> 
                        <li class="li-active"><p>Получить обратную связь CV-эксперта</p><div></div></li> 
                        <li class="li-active"><p>Обсудить в сообществе </p><div></div></li>
                        <li class="li-active"><p>Поработать с куратором</p><div></div></li>
                        <li class="li-active"><p>Задать вопрос Ольге Лермонтовой</p><div></div></li> 
                        <li class="li-active"><p>Посмотреть другие мастер-классы</p><div></div></li>
                    </ul>
                    <div>
                        <p class="amount">11 900 ₽</p>
                        <p class="places">количество мест ограничено</p>
                        <a href="#">Забронировать место</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>`
    });



    
    blockManager.add('carrerum-1st-banner-with-sections', {
        label: '1ый разворот с секциями',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-1st-banner-with-sections">
        <div>
            <div>
                <div>
                    <h1>Карьерум.Старт</h1>
                    <h2><span class="emerald-text-bg">10 шагов</span> до «Я люблю свою работу»</h2>
                    <p>На этом курсе вы начнете строить карьеру осознанно и выведете ее на новый уровень</p>
                    <a href="#">Записаться в лист ожидания</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623746373839.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <h3>Старт курса</h3>
                    <p>Июль 2021</p>
                </div>
                <div>
                    <h3>Длительность</h3>
                    <p>5 недель</p>
                </div>
                <div>
                    <h3>Формат обучения</h3>
                    <p>Онлайн</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-1st-banner-with-sections-tablet', {
        label: '1ый разворот с секциями (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-1st-banner-with-sections-tablet">
        <div>
            <div>
                <div>
                    <h2>Карьерум.Старт</h2>
                    <h2><span class="emerald-text-bg">10 шагов</span> до «Я люблю свою работу»</h2>
                    <p>На этом курсе вы начнете строить карьеру осознанно и выведете ее на новый уровень</p>
                    <a href="#">Записаться в лист ожидания</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623746373839.png" alt="">
                </div>
            </div>
            <div>
                <div>
                    <h3>Старт курса</h3>
                    <p>Июль 2021</p>
                </div>
                <div>
                    <h3>Длительность</h3>
                    <p>5 недель</p>
                </div>
                <div>
                    <h3>Формат обучения</h3>
                    <p>Онлайн</p>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-1st-banner-with-sections-mobile', {
        label: '1ый разворот с секциями (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-1st-banner-with-sections-mobile">
        <div>
            <div>
                <div>
                    <h2>Карьерум.Старт</h2>
                    <h2><span class="emerald-text-bg">10 шагов</span> до «Я люблю свою работу»</h2>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623746373839.png" alt="">
                    <p>На этом курсе вы начнете строить карьеру осознанно и выведете ее на новый уровень</p>
                    <a href="#">Записаться в лист ожидания</a>
                </div>
            </div>
            <div>
                <div>
                    <h3>Старт курса</h3>
                    <p>Июль 2021</p>
                </div>
                <div>
                    <h3>Длительность</h3>
                    <p>5 недель</p>
                </div>
                <div>
                    <h3>Формат обучения</h3>
                    <p>Онлайн</p>
                </div>
            </div>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-course-content', {
        label: 'Содержание курса',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-content">
        <div>
            <div>
                <div>
                    <div>
                        <h2>Содержание курса</h2>
                    </div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623747693195.png" alt="">
                            </div>
                            <div>
                                <p>Старт курса — июль 2021</p>
                                <p>Длительность — 5 недель</p>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
            <div>
                <h3>УРОК 1. Как взять от курса максимум</h3>
                    <p>Познакомитесь с экспертом и основательницей Карьерума Ольгой Лермонтовой и разберете самые распространенные убеждения и отговорки, которые мешают вашей карьере</p>
            </div>
            <div>
                <h3>УРОК 2. Что нужно, чтобы построить карьеру мечты</h3>
                    <p>Составите список того, на что вы на самом деле можете влиять в вашей карьере, а какие вещи вам <br> неподвластны. Спойлер: ваша зона влияния шире, чем вы думаете</p>
            </div>
            <div>
                <h3>УРОК 3. Как определить свои карьерные желания</h3>
                    <p>Поймёте, чего хотите от своей карьеры на самом деле и как к этому прийти</p>
            </div>
            <div>
                <h3>УРОК 4. Как повысить удовлетворенность работой уже сейчас</h3>
                    <p>Составите план, как большую часть рабочего времени заниматься приятными задачами и получать больше <br> радости</p>
            </div>
            <div>
                <h3>УРОК 5. Где искать свои таланты</h3>
                    <p>Проанализируете свои способности и поймете, как благодаря им можно реализовать себя</p>
            </div>
            <div>
                    <h3>УРОК 6. Как понять, какие люди нужны компаниям</h3>
                    <p>Разберетесь, какие специальности сегодня востребованы, за что работодатели готовы платить и куда вам стоит направлять свое внимание уже сейчас</p>
            </div>
            <div>
                <h3>УРОК 7. Как определить, какую цель поставить именно вам</h3>
                    <p>Систематизируете варианты своего карьерного развития, выберете лучший из них и составите план действий</p>
            </div>
            <div>
                <h3>УРОК 8. Как избавиться от барьеров и страхов на пути к цели</h3>
                    <p>Вычислите убеждения, которые мешают развитию вашей карьеры, и узнаете, как их проработать, чтобы нажать <br> на газ в пол</p>
            </div>
            <div>
                <h3>УРОК 9. Секретный урок</h3>
                    <p>Получите приятный бонус от нашей команды, если дойдете до конца</p>
            </div>
            <div>
                <h3>УРОК 10. Что сделать, чтобы пройденное не забылось, как школьная программа</h3>
                    <p>Проанализируете итоги курса лично для себя и пропишете ближайшие шаги к поставленной карьерной цели</p>
            </div>
            <a href="#">Записаться в лист ожидания</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-course-content-tablet', {
        label: 'Содержание курса (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-content-tablet">
        <div>
            <div>
                <div>
                    <div>
                        <h2>Содержание курса</h2>
                    </div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623747693195.png" alt="">
                            </div>
                            <div>
                                <p>Старт курса — июль 2021</p>
                                <p>Длительность — 5 недель</p>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
            <div>
                <h3>УРОК 1. Как взять от курса максимум</h3>
                    <p>Познакомитесь с экспертом и основательницей Карьерума Ольгой Лермонтовой и разберете самые распространенные убеждения и отговорки, которые мешают вашей карьере</p>
            </div>
            <div>
                <h3>УРОК 2. Что нужно, чтобы построить карьеру мечты</h3>
                    <p>Составите список того, на что вы на самом деле можете влиять в вашей карьере, а какие вещи вам неподвластны. Спойлер: ваша зона влияния шире, чем вы думаете</p>
            </div>
            <div>
                <h3>УРОК 3. Как определить свои карьерные желания</h3>
                    <p>Поймёте, чего хотите от своей карьеры на самом деле и как к этому прийти</p>
            </div>
            <div>
                <h3>УРОК 4. Как повысить удовлетворенность работой уже сейчас</h3>
                    <p>Составите план, как большую часть рабочего времени заниматься приятными задачами и получать больше радости</p>
            </div>
            <div>
                <h3>УРОК 5. Где искать свои таланты</h3>
                    <p>Проанализируете свои способности и поймете, как благодаря им можно реализовать себя</p>
            </div>
            <div>
                    <h3>УРОК 6. Как понять, какие люди нужны компаниям</h3>
                    <p>Разберетесь, какие специальности сегодня востребованы, за что работодатели готовы платить и куда вам стоит направлять свое внимание уже сейчас</p>
            </div>
            <div>
                <h3>УРОК 7. Как определить, какую цель поставить именно вам</h3>
                    <p>Систематизируете варианты своего карьерного развития, выберете лучший из них и составите план действий</p>
            </div>
            <div>
                <h3>УРОК 8. Как избавиться от барьеров и страхов на пути к цели</h3>
                    <p>Вычислите убеждения, которые мешают развитию вашей карьеры, и узнаете, как их проработать, чтобы нажать <br> на газ в пол</p>
            </div>
            <div>
                <h3>УРОК 9. Секретный урок</h3>
                    <p>Получите приятный бонус от нашей команды, если дойдете до конца</p>
            </div>
            <div>
                <h3>УРОК 10. Что сделать, чтобы пройденное не забылось, как школьная программа</h3>
                    <p>Проанализируете итоги курса лично для себя и пропишете ближайшие шаги к поставленной карьерной цели</p>
            </div>
            <a href="#">Записаться в лист ожидания</a>
        </div>
    </div>`
    });

    blockManager.add('carrerum-course-content-mobile', {
        label: 'Содержание курса (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-course-content-mobile">
        <div>
            <div>
                <div>
                    <div>
                        <h2>Содержание курса</h2>
                    </div>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623747693195.png" alt="">
                            </div>
                            <div>
                                <p>Старт курса — июль 2021</p>
                                <p>Длительность — 5 недель</p>
                            </div>
                        </div>
                    </div>
                </div>                
            </div>
            <div class="content-slider slider-block">
                <div>
                    <h3>УРОК 1. Как взять от курса максимум</h3>
                        <p>Познакомитесь с экспертом и основательницей Карьерума Ольгой Лермонтовой и разберете самые распространенные убеждения и отговорки, которые мешают вашей карьере</p>
                </div>
                <div>
                    <h3>УРОК 2. Что нужно, чтобы построить карьеру мечты</h3>
                        <p>Составите список того, на что вы на самом деле можете влиять в вашей карьере, а какие вещи вам неподвластны. Спойлер: ваша зона влияния шире, чем вы думаете</p>
                </div>
                <div>
                    <h3>УРОК 3. Как определить свои карьерные желания</h3>
                        <p>Поймёте, чего хотите от своей карьеры на самом деле и как к этому прийти</p>
                </div>
                <div>
                    <h3>УРОК 4. Как повысить удовлетворенность работой уже сейчас</h3>
                        <p>Составите план, как большую часть рабочего времени заниматься приятными задачами и получать больше радости</p>
                </div>
                <div>
                    <h3>УРОК 5. Где искать свои таланты</h3>
                        <p>Проанализируете свои способности и поймете, как благодаря им можно реализовать себя</p>
                </div>
                <div>
                        <h3>УРОК 6. Как понять, какие люди нужны компаниям</h3>
                        <p>Разберетесь, какие специальности сегодня востребованы, за что работодатели готовы платить и куда вам стоит направлять свое внимание уже сейчас</p>
                </div>
                <div>
                    <h3>УРОК 7. Как определить, какую цель поставить именно вам</h3>
                        <p>Систематизируете варианты своего карьерного развития, выберете лучший из них и составите план действий</p>
                </div>
                <div>
                    <h3>УРОК 8. Как избавиться от барьеров и страхов на пути к цели</h3>
                        <p>Вычислите убеждения, которые мешают развитию вашей карьеры, и узнаете, как их проработать, чтобы нажать <br> на газ в пол</p>
                </div>
                <div>
                    <h3>УРОК 9. Секретный урок</h3>
                        <p>Получите приятный бонус от нашей команды, если дойдете до конца</p>
                </div>
                <div>
                    <h3>УРОК 10. Что сделать, чтобы пройденное не забылось, как школьная программа</h3>
                        <p>Проанализируете итоги курса лично для себя и пропишете ближайшие шаги к поставленной карьерной цели</p>
                </div>
            </div>            
            <a href="#">Записаться в лист ожидания</a>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-case-header', {
        label: 'Заголовок кейса',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-header">
        <div>
            <h2>Как найти работу с повышением зарплаты на 40%</h2>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925279480.png" alt="">
                <div>
                    <h3>Дарья Шаповалова,</h3>
                    <h4>менеджер проектов, Россия</h4>
                </div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925331479.png" alt=""></a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-header-tablet', {
        label: 'Заголовок кейса (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-header-tablet">
        <div>
            <h2>Как найти работу с повышением зарплаты на 40%</h2>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925279480.png" alt="">
                <div>
                    <h3>Дарья Шаповалова,</h3>
                    <h4>менеджер проектов, Россия</h4>
                </div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925331479.png" alt=""></a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-header-mobile', {
        label: 'Заголовок кейса (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-header-mobile">
        <div>
            <h2>Как найти работу с повышением зарплаты на 40%</h2>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925279480.png" alt="">
                <div>
                    <h3>Дарья Шаповалова,</h3>
                    <h4>менеджер проектов, Россия</h4>
                </div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925331479.png" alt=""></a>
            </div>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-case-point-a', {
        label: 'Кейс - точка А',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-a">
        <div>  
            <div>
                <a href="#">#поискработы</a>
                <a href="#">#повышение</a>
                <a href="#">#самооценка</a>
            </div>            
            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt="">
                <h3>
                     До Карьерума
                </h3>
            </div>
            <p>
                Дарья искала новую работу и чувствовала себя «самым обычным специалистом», который сможет получить оффер с повышением, только если сильно повезет.
            </p>
            <h3>В Карьеруме</h3>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925756246.png" alt="">
                    <div>
                        <h5>Проработала установки о себе на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Изучила свои сильные стороны, присвоила свои достижения, создала резюме с опорой на них.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925772532.png" alt="">
                    <div>
                        <h5>Проработала установки о поиске работы</h5>
                        <p>
                            Избавилась от убеждений «Выбираю не я, а меня», «Нереально найти работу, если нет друзей, которые перетянут тебя к себе», «Поиск работы — это всегда стресс, неизвестность и риски»
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925788817.png" alt="">
                    <div>
                        <h5>Определила, чего хочет от карьеры на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Осознала, что хочет работать в digital-сфере, в молодой, драйвовой команде и удаленно — и убедилась, что это реально.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925805903.png" alt="">
                    <div>
                        <h5>Построила нетворк в сообществе клуба</h5>
                        <p>
                            Обзавелась ценными связями и активно использовала их для проверки своих гипотез по поводу работы мечты.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925821191.png" alt="">
                    <div>
                        <h5>Подготовилась к интервью на курсе «Эффективное интервью»</h5>
                        <p>
                            Начала проходить собеседования с уверенностью в своей ценности, с четким представлением, какую работу хочет получить, и без страха перед самим процессом поиска.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-point-a-tablet', {
        label: 'Кейс - точка А (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-a-tablet">
        <div>  
            <div>
                <a href="#">#поискработы</a>
                <a href="#">#повышение</a>
                <a href="#">#самооценка</a>
            </div>            
            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt="">
                <h3>
                     До Карьерума
                </h3>
            </div>
            <p>
                Дарья искала новую работу и чувствовала себя «самым обычным специалистом», который сможет получить оффер с повышением, только если сильно повезет.
            </p>
            <h3>В Карьеруме</h3>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925756246.png" alt="">
                    <div>
                        <h5>Проработала установки о себе на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Изучила свои сильные стороны, присвоила свои достижения, создала резюме с опорой на них.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925772532.png" alt="">
                    <div>
                        <h5>Проработала установки о поиске работы</h5>
                        <p>
                            Избавилась от убеждений «Выбираю не я, а меня», «Нереально найти работу, если нет друзей, которые перетянут тебя к себе», «Поиск работы — это всегда стресс, неизвестность и риски»
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925788817.png" alt="">
                    <div>
                        <h5>Определила, чего хочет от карьеры на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Осознала, что хочет работать в digital-сфере, в молодой, драйвовой команде и удаленно — и убедилась, что это реально.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925805903.png" alt="">
                    <div>
                        <h5>Построила нетворк в сообществе клуба</h5>
                        <p>
                            Обзавелась ценными связями и активно использовала их для проверки своих гипотез по поводу работы мечты.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925821191.png" alt="">
                    <div>
                        <h5>Подготовилась к интервью на курсе «Эффективное интервью»</h5>
                        <p>
                            Начала проходить собеседования с уверенностью в своей ценности, с четким представлением, какую работу хочет получить, и без страха перед самим процессом поиска.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-point-a-mobile', {
        label: 'Кейс - точка А (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-a-mobile">
        <div>  
            <div>
                <a href="#">#поискработы</a>
                <a href="#">#повышение</a>
                <a href="#">#самооценка</a>
            </div>            
            
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt="">
                <h3>
                     До Карьерума
                </h3>
            </div>
            <p>
                Дарья искала новую работу и чувствовала себя «самым обычным специалистом», который сможет получить оффер с повышением, только если сильно повезет.
            </p>
            <h3>В Карьеруме</h3>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925756246.png" alt="">
                    <div>
                        <h5>Проработала установки о себе на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Изучила свои сильные стороны, присвоила свои достижения, создала резюме с опорой на них.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925772532.png" alt="">
                    <div>
                        <h5>Проработала установки о поиске работы</h5>
                        <p>
                            Избавилась от убеждений «Выбираю не я, а меня», «Нереально найти работу, если нет друзей, которые перетянут тебя к себе», «Поиск работы — это всегда стресс, неизвестность и риски»
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925788817.png" alt="">
                    <div>
                        <h5>Определила, чего хочет от карьеры на курсе «Real Me: как найти себя в работе и жизни»</h5>
                        <p>
                            Осознала, что хочет работать в digital-сфере, в молодой, драйвовой команде и удаленно — и убедилась, что это реально.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925805903.png" alt="">
                    <div>
                        <h5>Построила нетворк в сообществе клуба</h5>
                        <p>
                            Обзавелась ценными связями и активно использовала их для проверки своих гипотез по поводу работы мечты.
                        </p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925821191.png" alt="">
                    <div>
                        <h5>Подготовилась к интервью на курсе «Эффективное интервью»</h5>
                        <p>
                            Начала проходить собеседования с уверенностью в своей ценности, с четким представлением, какую работу хочет получить, и без страха перед самим процессом поиска.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-case-point-b', {
        label: 'Кейс - точка Б',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-b">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt="">
                    <h2>После Карьерума</h2>
                </div>
                
                <ul>
                    <li>Оффер в новую компанию в новую компанию</li>
                    <li>Повышение зарплаты на 40%</li>
                    <li>Возможностью работать не по часам, а на результат</li>
                    <li>Близкая по духу команда</li>
                </ul>
            </div>
            <p>
                Смотрите эфир с Дарьей по фразе «Возможно все» или записывайтесь в лист ожидания Карьерум.Клуба, если хотите достичь таких же результатов.
            </p>
            <div>
                <a href="#">Смотреть эфир</a>
                <a href="#">Узнать о клубе</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-point-b-tablet', {
        label: 'Кейс - точка Б (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-b-tablet">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt="">
                    <h2>После Карьерума</h2>
                </div>
                <ul>
                    <li>Оффер в новую компанию в новую компанию</li>
                    <li>Повышение зарплаты на 40%</li>
                    <li>Возможностью работать не по часам, а на результат</li>
                    <li>Близкая по духу команда</li>
                </ul>
            </div>
            <p>
                Смотрите эфир с Дарьей по фразе «Возможно все» или записывайтесь в лист<br> ожидания Карьерум.Клуба, если хотите достичь таких же результатов.
            </p>
            <div>
                <a href="#">Смотреть эфир</a>
                <a href="#">Узнать о клубе</a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-case-point-b-mobile', {
        label: 'Кейс - точка Б (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-case-point-b-mobile">
        <div>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt="">
                    <h2>После Карьерума</h2>
                </div>
                <ul>
                    <li>Оффер в новую компанию в новую компанию</li>
                    <li>Повышение зарплаты на 40%</li>
                    <li>Возможностью работать не по часам, а на результат</li>
                    <li>Близкая по духу команда</li>
                </ul>
            </div>
            <p>
                Смотрите эфир с Дарьей по фразе «Возможно все» или записывайтесь в лист<br> ожидания Карьерум.Клуба, если хотите достичь таких же результатов.
            </p>
            <div>
                <a href="#">Смотреть эфир</a>
                <a href="#">Узнать о клубе</a>
            </div>
        </div>
    </div>`
    });


    blockManager.add('carrerum-member-results', {
        label: 'Результаты участников',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-member-results">
        <div>
            <div>
                <h2>
                    Результаты участников
                </h2>
            </div>            
            <div class="tag-selector">
                <p onclick="menuShower(this)"><span>Все результаты</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623938095010.png" alt=""></p>
                <div>
                    <ul>
                        <li data-tags="all">Все результаты</li>
                    </ul>
                </div>
            </div>
            <div class="member-result-items">
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623938123409.png" alt="">
                        <div>
                            <h4>Дарья Шаповалова</h4>
                            <h3>Как найти работу с повышением зарплаты на 40%</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#повышение</span>
                            <span>#самооценка</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>                        
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939358423.png" alt="">
                        <div>
                            <h4>Полина Берман</h4>
                            <h3>Как начать опираться на себя, а не на громкие бренды в резюме</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#карьерныйвыбор</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939401304.png" alt="">
                        <div>
                            <h4>Елизавета Зайнутдинова</h4>
                            <h3>От потери работы и неуверенности к офферу +60%</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#самооценка</span>
                            <span>#повышение</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939425558.png" alt="">
                        <div>
                            <h4>Анастасия Орлова</h4>
                            <h3>Как найти работу после увольнения в локдаун</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#повышение</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939446783.png" alt="">
                        <div>
                            <h4>Маргарита Масленникова</h4>
                            <h3>Как не соглашаться на любые офферы и найти идеальную работу</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#повышение</span>
                            <span>#сменасферы</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939467016.png" alt="">
                        <div>
                            <h4>Екатерина Таркова</h4>
                            <h3>Как сменить сферу с повышением за 2 месяца</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#поискработы</span>
                            <span>#самооценка</span>
                            <span>#повышение</span>
                            <span>#сменасферы</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939510572.png" alt="">
                        <div>
                            <h4>Екатерина Горяинова</h4>
                            <h3>Как получить работу мечты с двумя маленькими детьми</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#поискработы</span>
                            <span>#повышение</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939532223.png" alt="">
                        <div>
                            <h4>Ксения Вакушина</h4>
                            <h3>Как увеличить доход на 75%</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#повышение</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939551201.png" alt="">
                        <div>
                            <h4>Елена Луценко</h4>
                            <h3>Как обрести опору в карьере после декрета</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#самооценка</span>
                            <span>#декрет</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939576004.png" alt="">
                        <div>
                            <h4>Елена Сюгис</h4>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#поискработы</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939597707.png" alt="">
                        <div>
                            <h4>Юлия Маркелова</h4>
                            <h3>Как понять, куда двигаться дальше в карьере</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939617460.png" alt="">
                        <div>
                            <h4>Екатерина Хрулькова</h4>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#поискработы</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939642008.png" alt="">
                        <div>
                            <h4>Виктория Клещ</h4>
                            <h3>Как определить карьерный путь в науке</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#самооценка</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939662008.png" alt="">
                        <div>
                            <h4>Вера Кривцова</h4>
                            <h3>Куда расти преподавателю английского</h3>
                        </div>
                    </div>
                    <div>
                        <div class="tags">
                            <span>#карьерныйвыбор</span>
                            <span>#поискработы</span>
                            <span>#самооценка</span>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-member-results-tablet', {
        label: 'Результаты участников (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-member-results-tablet">
        <div>
            <div>
                <h2>
                    Результаты участников
                </h2>
            </div>            
            <div class="tag-selector">
                <p onclick="menuShower(this)"><span>Все результаты</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623938095010.png" alt=""></p>
                <div>
                    <ul>
                        <li data-tags="all">Все результаты</li>
                    </ul>
                </div>
            </div>
            <div class="member-result-items">
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939687030.png" alt=""></div>
                        <div>
                            <h4>Дарья Шаповалова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как найти работу с повышением зарплаты на 40%</h3>                            
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>                        
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939708963.png" alt=""></div>
                        <div>
                            <h4>Полина Берман</h4>
                            <div class="tags">
                                <span>#поискработы</span><br>
                                <span>#карьерныйвыбор</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как начать опираться на себя, а не на громкие бренды в резюме</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939730799.png" alt=""></div>
                        <div>
                            <h4>Елизавета Зайнутдинова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>От потери работы и неуверенности к офферу +60%</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939755072.png" alt=""></div>
                        <div>
                            <h4>Анастасия Орлова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как найти работу после увольнения в локдаун</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939773507.png" alt=""></div>
                        <div>
                            <h4>Маргарита Масленникова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                                <span>#сменасферы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как не соглашаться на любые офферы и найти идеальную работу</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939796642.png" alt=""></div>
                        <div>
                            <h4>Екатерина Таркова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span><br>
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                                <span>#повышение</span>
                                <span>#сменасферы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как сменить сферу с повышением за 2 месяца</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939815257.png" alt=""></div>
                        <div>
                            <h4>Екатерина Горяинова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как получить работу мечты с двумя маленькими детьми</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939836333.png" alt=""></div>
                        <div>
                            <h4>Ксения Вакушина</h4>
                            <div class="tags"><span>#повышение</span></div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как увеличить доход <br> на 75%</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939861010.png" alt=""></div>
                        <div>
                            <h4>Елена Луценко</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#самооценка</span>
                                <span>#декрет</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как обрести опору в карьере после декрета</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939881584.png" alt=""></div>
                        <div>
                            <h4>Елена Сюгис</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939903460.png" alt=""></div>
                        <div>
                            <h4>Юлия Маркелова</h4>
                            <div class="tags"><span>#карьерныйвыбор</span></div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как понять, куда двигаться дальше в карьере</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939922213.png" alt=""></div>
                        <div>
                            <h4>Екатерина Хрулькова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span><br>
                                <span>#поискработы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939945403.png" alt=""></div>
                        <div>
                            <h4>Виктория Клещ</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span><br>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как определить карьерный путь в науке</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939966611.png" alt=""></div>
                        <div>
                            <h4>Вера Кривцова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Куда расти преподавателю английского</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-member-results-mobile', {
        label: 'Результаты участников (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-member-results-mobile">
        <div>
            <div>
                <h2>
                    Результаты участников
                </h2>
            </div>            
            <div class="tag-selector">
                <p onclick="menuShower(this)"><span>Все результаты</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624005095815.png" alt=""></p>
                <div>
                    <ul>
                        <li data-tags="all">Все результаты</li>
                    </ul>
                </div>
            </div>
            <div class="member-result-items">
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623939988640.png" alt=""></div>
                        <div>
                            <h4>Дарья Шаповалова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span> <br>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как найти работу с повышением зарплаты на 40%</h3>                            
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>                        
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940009059.png" alt=""></div>
                        <div>
                            <h4>Полина Берман</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#карьерныйвыбор</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как начать опираться на себя, а не на громкие бренды в резюме</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940256898.png" alt=""></div>
                        <div>
                            <h4>Елизавета Зайнутдинова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>От потери работы и неуверенности к офферу +60%</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940056055.png" alt=""></div>
                        <div>
                            <h4>Анастасия Орлова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как найти работу после увольнения в локдаун</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940076584.png" alt=""></div>
                        <div>
                            <h4>Маргарита Масленникова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span><br>
                                <span>#сменасферы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как не соглашаться на любые офферы и найти идеальную работу</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940035407.png" alt=""></div>
                        <div>
                            <h4>Екатерина Таркова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                                <span>#повышение</span><br>
                                <span>#сменасферы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как сменить сферу с повышением за 2 месяца</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940283503.png" alt=""></div>
                        <div>
                            <h4>Екатерина Горяинова</h4>
                            <div class="tags">
                                <span>#поискработы</span>
                                <span>#повышение</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как получить работу мечты с двумя маленькими детьми</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940311324.png" alt=""></div>
                        <div>
                            <h4>Ксения Вакушина</h4>
                            <div class="tags"><span>#повышение</span></div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как увеличить доход <br> на 75%</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940338124.png" alt=""></div>
                        <div>
                            <h4>Елена Луценко</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#самооценка</span><br>
                                <span>#декрет</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как обрести опору в карьере после декрета</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940362580.png" alt=""></div>
                        <div>
                            <h4>Елена Сюгис</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940386106.png" alt=""></div>
                        <div>
                            <h4>Юлия Маркелова</h4>
                            <div class="tags"><span>#карьерныйвыбор</span></div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как понять, куда двигаться дальше в карьере</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940407948.png" alt=""></div>
                        <div>
                            <h4>Екатерина Хрулькова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как выбрать из трех вариантов карьерного развития</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940427918.png" alt=""></div>
                        <div>
                            <h4>Виктория Клещ</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Как определить карьерный путь в науке</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
                <div>
                    <div>
                        <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623940446127.png" alt=""></div>
                        <div>
                            <h4>Вера Кривцова</h4>
                            <div class="tags">
                                <span>#карьерныйвыбор</span>
                                <span>#поискработы</span>
                                <span>#самооценка</span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>
                            <h3>Куда расти преподавателю английского</h3>
                        </div>
                        <a href="#">Смотреть кейс</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-experts-list', {
        label: 'Список экспертов',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts-list">
        <div>
            <h2>Эксперты Карьерум.Клуба</h2>
            <p>
                Опыт сообщества профессионалов и <span>20+ топовых приглашенных спикеров</span> для вашей карьеры
            </p>
            <input type="checkbox" id="experts-accord">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265903683.png" alt="">
                    <h3>Ольга Лермонтова,</h3>
                    <h4>Италия</h4>
                    <p>Карьерный коуч и стратег, 8000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265982113.png" alt="">
                    <h3>Санжар Ибрагимов,</h3>
                    <h4>Финляндия</h4>
                    <p>Эксперт в сфере консалтинга, 16+ лет карьеры</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265999075.png" alt="">
                    <h3>Анна Бабич,</h3>
                    <h4>Россия</h4>
                    <p>Дипломированный психолог, 8+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266022666.png" alt="">
                    <h3>Sophie Vurpillot,</h3>
                    <h4>Испания</h4>
                    <p>Международный рекрутер и коуч, 10+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266042434.png" alt="">
                    <h3>Montse Lorente,</h3>
                    <h4>Перу</h4>
                    <p>Международный карьерный консультант, 1000+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266059670.png" alt="">
                    <h3>Денис Осин, </h3>
                    <h4>Россия</h4>
                    <p>Гештальт-терапевт, 6+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266079000.png" alt="">
                    <h3>Елена Резанова, </h3>
                    <h4>Монако</h4>
                    <p>Карьерный стратег, 9+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266096485.png" alt="">
                    <h3>Ольга Полякова, </h3>
                    <h4>США</h4>
                    <p>Эксперт по международной коммуникации, 12+ лет карьеры в США</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266112307.png" alt="">
                    <h3>Полина Артеменко, </h3>
                    <h4>Великобритания</h4>
                    <p>Эксперт по резюме и поступлению за рубеж, 70+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266141770.png" alt="">
                    <h3>Елена Дегтярь, </h3>
                    <h4>Германия</h4>
                    <p>Нарративный практик и терапевт принятия и ответственности (ACT), 5+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266159198.png" alt="">
                    <h3>Руслан Искяндяров, </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по финансам, 8+ лет карьеры на Московской бирже</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266174973.png" alt="">
                    <h3>Ольга Сильверман, </h3>
                    <h4>Великобритания</h4>
                    <p>LinkedIn-ментор, 18+ лет на управляющих позициях</p>
                    <a href="#">Больше об эксперте</a>
                </div> 
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266194390.png" alt="">
                    <h3>Анастасия Веселко,  </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по личным финансам, 2000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266209980.png" alt="">
                    <h3>Алина Вербенчук, </h3>
                    <h4>Великобритания</h4>
                    <p>Основатель собственного менторского проекта, продакт-менеджер, 7 лет в YouTube и Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266341514.png" alt="">
                    <h3>Мария Батти, </h3>
                    <h4>Россия</h4>
                    <p>Карьерный стратег, 5+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266373424.png" alt="">
                    <h3>Никита Сергеев, </h3>
                    <h4>Россия</h4>
                    <p>Коуч и бизнес-тренер, 12+ лет тренингов</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266391589.png" alt="">
                    <h3>Наталья Токарь, </h3>
                    <h4>США</h4>
                    <p>Эксперт по коммуникации, CEO проекта по межкультурному общению</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266407700.png" alt="">
                    <h3>Наталия Иванова,  </h3>
                    <h4>Россия</h4>
                    <p>Тренер по эмоциональному интеллекту (EQ), 3+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266422636.png" alt="">
                    <h3>Глеб Шулин, </h3>
                    <h4>Россия</h4>
                    <p>Режиссер презентаций, 1000+ презентаций и переговоров</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266225808.png" alt="">
                    <h3>Мария Сандлер, </h3>
                    <h4>Россия</h4>
                    <p>Преподаватель ораторского искусства, 12+ лет преподавания</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266452434.png" alt="">
                    <h3>Ольга Гладкая, </h3>
                    <h4>Россия</h4>
                    <p>Партнер BCG, 10+ лет в консалтинге, мама двоих детей</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266469060.png" alt="">
                    <h3>Татьяна Захарова, </h3>
                    <h4>Ирландия</h4>
                    <p>Эксперт по управлению стрессом, 11+ лет карьеры в Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266484350.png" alt="">
                    <h3>Валерия Голованевская, </h3>
                    <h4>Израиль</h4>
                    <p>Эксперт по тайм-менеджменту, 650+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266500250.png" alt="">
                    <h3>Карина Башарова, </h3>
                    <h4>Россия, Латвия</h4>
                    <p>Коуч и медиатор, 8000+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266514336.png" alt="">
                    <h3>Илья Пантелеймонов, </h3>
                    <h4>Россия</h4>
                    <p>Финансовый советник, 9+ лет консультирования</p>
                    <a href="#">Больше об эксперте</a>
                </div>                            
            </div>
            <label for="experts-accord">
                <span>
                    Ещё 13 экспертов
                </span>
                <span>
                    Свернуть
                </span>
            </label>                 
        </div>
    </div>`
    });

    blockManager.add('carrerum-experts-list-tablet', {
        label: 'Список экспертов (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts-list-tablet">
        <div>
            <h2>Эксперты Карьерум.Клуба</h2>
            <p>
                Опыт сообщества профессионалов и <span>20+ топовых приглашенных спикеров</span> для<br> вашей карьеры
            </p>
            <input type="checkbox" id="experts-accord-tablet">
            <div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265903683.png" alt=""></div>
                    <h3>Ольга Лермонтова,</h3>
                    <h4>Италия</h4>
                    <p>Карьерный коуч и стратег, 8000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265982113.png" alt=""></div>
                    <h3>Санжар Ибрагимов,</h3>
                    <h4>Финляндия</h4>
                    <p>Эксперт в сфере консалтинга, 16+ лет карьеры</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265999075.png" alt=""></div>
                    <h3>Анна Бабич,</h3>
                    <h4>Россия</h4>
                    <p>Дипломированный психолог, 8+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266022666.png" alt=""></div>
                    <h3>Sophie Vurpillot,</h3>
                    <h4>Испания</h4>
                    <p>Международный рекрутер и коуч, 10+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266042434.png" alt=""></div>
                    <h3>Montse Lorente,</h3>
                    <h4>Перу</h4>
                    <p>Международный карьерный консультант, 1000+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266059670.png" alt=""></div>
                    <h3>Денис Осин, </h3>
                    <h4>Россия</h4>
                    <p>Гештальт-терапевт, 6+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266079000.png" alt=""></div>
                    <h3>Елена Резанова, </h3>
                    <h4>Монако</h4>
                    <p>Карьерный стратег, 9+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266096485.png" alt=""></div>
                    <h3>Ольга Полякова, </h3>
                    <h4>США</h4>
                    <p>Эксперт по международной коммуникации, 12+ лет карьеры в США</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266112307.png" alt=""></div>
                    <h3>Полина Артеменко, </h3>
                    <h4>Великобритания</h4>
                    <p>Эксперт по резюме и поступлению за рубеж, 70+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266141770.png" alt=""></div>
                    <h3>Елена Дегтярь, </h3>
                    <h4>Германия</h4>
                    <p>Нарративный практик и терапевт принятия и ответственности (ACT), 5+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266159198.png" alt=""></div>
                    <h3>Руслан Искяндяров, </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по финансам, 8+ лет карьеры на Московской бирже</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266174973.png" alt=""></div>
                    <h3>Ольга Сильверман, </h3>
                    <h4>Великобритания</h4>
                    <p>LinkedIn-ментор, 18+ лет на управляющих позициях</p>
                    <a href="#">Больше об эксперте</a>
                </div> 
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266194390.png" alt=""></div>
                    <h3>Анастасия Веселко,  </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по личным финансам, 2000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266209980.png" alt=""></div>
                    <h3>Алина Вербенчук, </h3>
                    <h4>Великобритания</h4>
                    <p>Основатель собственного менторского проекта, продакт-менеджер, 7 лет в YouTube и Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266341514.png" alt=""></div>
                    <h3>Мария Батти, </h3>
                    <h4>Россия</h4>
                    <p>Карьерный стратег, 5+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266373424.png" alt=""></div>
                    <h3>Никита Сергеев, </h3>
                    <h4>Россия</h4>
                    <p>Коуч и бизнес-тренер, 12+ лет тренингов</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266391589.png" alt=""></div>
                    <h3>Наталья Токарь, </h3>
                    <h4>США</h4>
                    <p>Эксперт по коммуникации, CEO проекта по межкультурному общению</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266407700.png" alt=""></div>
                    <h3>Наталия Иванова,  </h3>
                    <h4>Россия</h4>
                    <p>Тренер по эмоциональному интеллекту (EQ), 3+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266422636.png" alt=""></div>
                    <h3>Глеб Шулин, </h3>
                    <h4>Россия</h4>
                    <p>Режиссер презентаций, 1000+ презентаций и переговоров</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266225808.png" alt=""></div>
                    <h3>Мария Сандлер, </h3>
                    <h4>Россия</h4>
                    <p>Преподаватель ораторского искусства, 12+ лет преподавания</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266452434.png" alt=""></div>
                    <h3>Ольга Гладкая, </h3>
                    <h4>Россия</h4>
                    <p>Партнер BCG, 10+ лет в консалтинге, мама двоих детей</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266469060.png" alt=""></div>
                    <h3>Татьяна Захарова, </h3>
                    <h4>Ирландия</h4>
                    <p>Эксперт по управлению стрессом, 11+ лет карьеры в Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266484350.png" alt=""></div>
                    <h3>Валерия Голованевская, </h3>
                    <h4>Израиль</h4>
                    <p>Эксперт по тайм-менеджменту, 650+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266500250.png" alt=""></div>
                    <h3>Карина Башарова, </h3>
                    <h4>Россия, Латвия</h4>
                    <p>Коуч и медиатор, 8000+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266514336.png" alt=""></div>
                    <h3>Илья Пантелеймонов, </h3>
                    <h4>Россия</h4>
                    <p>Финансовый советник, 9+ лет консультирования</p>
                    <a href="#">Больше об эксперте</a>
                </div>                            
            </div>
            <label for="experts-accord-tablet">
                <span>
                    ещё 14 экспертов
                </span>
                <span>
                    Свернуть
                </span>
            </label>                 
        </div>
    </div>`
    });

    blockManager.add('carrerum-experts-list-mobile', {
        label: 'Список экспертов (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-experts-list-mobile">
        <div>
            <h2>Эксперты Карьерум.Клуба</h2>
            <p>
                Опыт сообщества профессионалов и <span>20+ топовых приглашенных спикеров</span> для<br> вашей карьеры
            </p>
            <input type="checkbox" id="experts-accord-mobile">
            <div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265940583.png" alt=""></div>
                    <h3>Ольга Лермонтова,</h3>
                    <h4>Италия</h4>
                    <p>Карьерный коуч и стратег, 8000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624265959254.png" alt=""></div>
                    <h3>Санжар Ибрагимов,</h3>
                    <h4>Финляндия</h4>
                    <p>Эксперт в сфере консалтинга, 16+ лет карьеры</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266529597.png" alt=""></div>
                    <h3>Анна Бабич,</h3>
                    <h4>Россия</h4>
                    <p>Дипломированный психолог, 8+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266545245.png" alt=""></div>
                    <h3>Sophie Vurpillot,</h3>
                    <h4>Испания</h4>
                    <p>Международный рекрутер и коуч, 10+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266560656.png" alt=""></div>
                    <h3>Montse Lorente,</h3>
                    <h4>Перу</h4>
                    <p>Международный карьерный консультант, 1000+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266572089.png" alt=""></div>
                    <h3>Денис Осин, </h3>
                    <h4>Россия</h4>
                    <p>Гештальт-терапевт, 6+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266585329.png" alt=""></div>
                    <h3>Елена Резанова, </h3>
                    <h4>Монако</h4>
                    <p>Карьерный стратег, 9+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266602137.png" alt=""></div>
                    <h3>Ольга Полякова, </h3>
                    <h4>США</h4>
                    <p>Эксперт по международной коммуникации, 12+ лет карьеры в США</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266612016.png" alt=""></div>
                    <h3>Полина Артеменко, </h3>
                    <h4>Великобритания</h4>
                    <p>Эксперт по резюме и поступлению за рубеж, 70+ кейсов</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266623182.png" alt=""></div>
                    <h3>Елена Дегтярь, </h3>
                    <h4>Германия</h4>
                    <p>Нарративный практик и терапевт принятия и ответственности (ACT), 5+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266636736.png" alt=""></div>
                    <h3>Руслан Искяндяров, </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по финансам, 8+ лет карьеры на Московской бирже</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266651262.png" alt=""></div>
                    <h3>Ольга Сильверман, </h3>
                    <h4>Великобритания</h4>
                    <p>LinkedIn-ментор, 18+ лет на управляющих позициях</p>
                    <a href="#">Больше об эксперте</a>
                </div> 
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266661233.png" alt=""></div>
                    <h3>Анастасия Веселко,  </h3>
                    <h4>Россия</h4>
                    <p>Эксперт по личным финансам, 2000+ учеников</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266672930.png" alt=""></div>
                    <h3>Алина Вербенчук, </h3>
                    <h4>Великобритания</h4>
                    <p>Основатель собственного менторского проекта, продакт-менеджер, 7 лет в YouTube и Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266691284.png" alt=""></div>
                    <h3>Мария Батти, </h3>
                    <h4>Россия</h4>
                    <p>Карьерный стратег, 5+ лет опыта</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266705441.png" alt=""></div>
                    <h3>Никита Сергеев, </h3>
                    <h4>Россия</h4>
                    <p>Коуч и бизнес-тренер, 12+ лет тренингов</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266718097.png" alt=""></div>
                    <h3>Наталья Токарь, </h3>
                    <h4>США</h4>
                    <p>Эксперт по коммуникации, CEO проекта по межкультурному общению</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266730453.png" alt=""></div>
                    <h3>Наталия Иванова,  </h3>
                    <h4>Россия</h4>
                    <p>Тренер по эмоциональному интеллекту (EQ), 3+ лет практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266748105.png" alt=""></div>
                    <h3>Глеб Шулин, </h3>
                    <h4>Россия</h4>
                    <p>Режиссер презентаций, 1000+ презентаций и переговоров</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266762853.png" alt=""></div>
                    <h3>Мария Сандлер, </h3>
                    <h4>Россия</h4>
                    <p>Преподаватель ораторского искусства, 12+ лет преподавания</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266775364.png" alt=""></div>
                    <h3>Ольга Гладкая, </h3>
                    <h4>Россия</h4>
                    <p>Партнер BCG, 10+ лет в консалтинге, мама двоих детей</p>
                    <a href="#">Больше об эксперте</a>
                </div>                
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266789628.png" alt=""></div>
                    <h3>Татьяна Захарова, </h3>
                    <h4>Ирландия</h4>
                    <p>Эксперт по управлению стрессом, 11+ лет карьеры в Google</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266801962.png" alt=""></div>
                    <h3>Валерия Голованевская, </h3>
                    <h4>Израиль</h4>
                    <p>Эксперт по тайм-менеджменту, 650+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266814863.png" alt=""></div>
                    <h3>Карина Башарова, </h3>
                    <h4>Россия, Латвия</h4>
                    <p>Коуч и медиатор, 8000+ часов практики</p>
                    <a href="#">Больше об эксперте</a>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624266825882.png" alt=""></div>
                    <h3>Илья Пантелеймонов, </h3>
                    <h4>Россия</h4>
                    <p>Финансовый советник, 9+ лет консультирования</p>
                    <a href="#">Больше об эксперте</a>
                </div>                            
            </div>
            <label for="experts-accord-mobile">
                <span>
                    Ещё 15 экспертов
                </span>
                <span>
                    Свернуть
                </span>
            </label>                 
        </div>
    </div>`
    });



    
    
    blockManager.add('carrerum-coaches', {
        label: 'Список коучей',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-coaches">
        <div>
            <h2>Ваша поддержка в клубе</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700124949.png" alt="">
                    <h3>Светлана Баран</h3>
                    <h4>Коуч ICF, Италия</h4>
                    <p>Поддержит вас в поиске работы, релокации, поступлении за рубеж</p>
                    <a href="#coach-svetlana">Узнать больше</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700712188.jpg" alt="">
                    <h3>Елена Добринская</h3>
                    <h4>Коуч ICF, Дубай</h4>
                    <p>Поддержит вас в поиске своих желаний и укреплении самооценки</p>
                    <a href="#coach-elena">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700345647.jpg" alt="">
                    <h3>Марина Веденичева</h3>
                    <h4>Коуч ICF PCC, Украина</h4>
                    <p>Поддержит вас на пути к карьерному росту и развитию лидерству</p>
                    <a href="#coach-marina">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657973549.png" alt="">
                    <h3>Полина Артеменко</h3>
                    <h4>CV-эксперт, Россия</h4>
                    <p>Поможет усилить ваше резюме для поиска лучшей работы</p>
                    <a href="#coach-polina">Узнать больше</a>
                </div>                         
            </div>                
        </div>
    </div>`
    });

    blockManager.add('carrerum-coaches-tablet', {
        label: 'Список коучей (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-coaches-tablet">
        <div>
            <h2>Ваша поддержка в клубе</h2>
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700124949.png" alt="">
                    <h3>Светлана<br/>Баран</h3>
                    <h4>Коуч ICF,<br/>Италия</h4>
                    <p>Поддержит вас в поиске работы, релокации, поступлении за рубеж</p>
                    <a class="link" href="#coach-svetlana">Узнать больше</a>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700712188.jpg" alt="">
                    <h3>Елена<br/>Добринская</h3>
                    <h4>Коуч ICF,<br/>Дубай</h4>
                    <p>Поддержит вас в поиске своих желаний и укреплении самооценки</p>
                    <a class="link" href="#coach-elena">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700345647.jpg" alt="">
                    <h3>Марина<br/>Веденичева</h3>
                    <h4>Коуч ICF PCC,<br/>Украина</h4>
                    <p>Поддержит вас на пути к карьерному росту и развитию лидерству</p>
                    <a class="link" href="#coach-marina">Узнать больше</a>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657973549.png" alt="">
                    <h3>Полина<br/>Артеменко</h3>
                    <h4>CV-эксперт,<br/>Россия</h4>
                    <p>Поможет усилить ваше резюме для поиска лучшей работы</p>
                    <a class="link" href="#coach-polina">Узнать больше</a>
                </div>                         
            </div>                
        </div>
    </div>`
    });

    blockManager.add('carrerum-coaches-mobile', {
        label: 'Список коучей (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-coaches-mobile">
        <div>
            <h2>Ваша поддержка в клубе</h2>
            <div class="slider-block slider-carrerum-coaches">
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700124949.png" alt="">
                    <h3>Светлана<br/>Баран</h3>
                    <h4>Коуч ICF,<br/>Италия</h4>
                    <p>Поддержит вас в поиске работы, релокации, поступлении за рубеж</p>
                    <p>
                        <a class="link" href="#coach-svetlana">Узнать больше</a>
                    </p>
                </div>                
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700712188.jpg" alt="">
                    <h3>Елена<br/>Добринская</h3>
                    <h4>Коуч ICF,<br/>Дубай</h4>
                    <p>Поддержит вас в поиске своих желаний и укреплении самооценки</p>
                    <p>
                        <a class="link" href="#coach-elena">Узнать больше</a>
                    </p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1631700345647.jpg" alt="">
                    <h3>Марина<br/>Веденичева</h3>
                    <h4>Коуч ICF PCC,<br/>Украина</h4>
                    <p>Поддержит вас на пути к карьерному росту и развитию лидерству</p>
                    <p>
                        <a class="link" href="#coach-marina">Узнать больше</a>
                    </p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657973549.png" alt="">
                    <h3>Полина<br/>Артеменко</h3>
                    <h4>CV-эксперт,<br/>Россия</h4>
                    <p>Поможет усилить ваше резюме для поиска лучшей работы</p>
                    <p>
                        <a class="link" href="#coach-polina">Узнать больше</a>
                    </p>
                </div>                         
            </div>                
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-members-are-experts', {
        label: 'Участники сообщества - эксперты',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-members-are-experts">
        <div>
            <div>
                <h2>Участники Карьерум.Клуба — сообщество экспертов</h2>
                <p>
                    Каждый месяц мы приглашаем новых экспертов, но часто они приходят к нам сами — вступая в клуб. В сообществе 1000+ участников из разных стран и компаний — от McKinsey и Google до стремительно развивающихся стартапов. У каждого из них — своя экспертиза, которой мы приглашаем делиться. 
                </p>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624267164205.png" alt="">
        </div>
    </div>`
    });

    blockManager.add('carrerum-members-are-experts-tablet', {
        label: 'Участники сообщества - эксперты (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-members-are-experts-tablet">
        <div>
            <div>
                <h2>Каждый наш участник - тоже эксперт</h2>
                <p>
                    
                    Каждый месяц мы приглашаем для вас новых экспертов, но часто они приходят к нам сами — вступая в клуб. 
                    <br><br>
                    В сообществе уже больше тысячи участников из разных стран и компаний — от крупных корпораций, как Google, до небольших, но стремительно развивающихся международных стартапов. И у каждого из них — своя экспертиза, которой мы приглашаем делиться. 

 
                </p>
            </div>
            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624267145864.png" alt="">
        </div>
    </div>`
    });

    blockManager.add('carrerum-members-are-experts-mobile', {
        label: 'Участники сообщества - эксперты (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-members-are-experts-mobile">
        <div>
            <div>
                <h2>Каждый наш участник - тоже эксперт</h2>
                <p>
                    
                    Каждый месяц мы приглашаем для вас новых экспертов, но часто они приходят к нам сами — вступая в клуб. </p>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624267132726.png" alt="">
                <p>
                    В сообществе уже больше тысячи участников из разных стран и компаний — от крупных корпораций, как Google, до небольших, но стремительно развивающихся международных стартапов. И у каждого из них — своя экспертиза, которой мы приглашаем делиться. 

 
                </p>
            </div>
            
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-review-a-b-slider', {
        label: 'Слайдер результатов А->Б',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-a-b-slider">
        <div>
            <div>
                <h2>Результаты клиентов</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624605305893.png" alt=""></div>
                            <div>
                                <h3>Рахиля Манджиева</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Ощущала, что застряла в одной роли и на одном уровне, хотела большего от своей реализации</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне осознать свою профессиональную ценность, расширить картину мира, осознать свой синдром «хорошей девочки». Я поняла, что уже нахожусь на идеальной для себя роли и знаю, как сделать свою карьеру лучше. Коучинг помог увидеть то, что я обычно не замечала. Но при этом ответственность за свои результаты несу, прежде всего, я сама.</label></div>
                        </div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624606941760.png" alt=""></div>
                            <div>
                                <h3>Анна Крохалевская</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела разобраться в траекториях своего пути и научиться делать карьерные выборы</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Я научилась смотреть на рабочие ситуации не с позиции борьбы, а с позиции легкости и удовольствия. Обрела больше доверия к себе и миру, сменила фокус с ограничений на возможности.</label></div>
                            <div>
                            Каждая сессия определенно стоила своих денег. Если вы только присматриваетесь, рекомендую сначала побыть в Карьерум.Клубе и заочно ответить для себя на некоторые вопросы. А после — работать индивидуально. 
                                </div>
                        </div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624606963315.png" alt=""></div>
                            <div>
                                <h3>Анастасия Бобрышева</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела найти себя и определить направление развития своей карьеры, выбрать из множества вариантов</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне заглянуть вглубь себя, выявить причинно-следственные связи — что на самом деле стоит за моими желаниями и действиями — осознать ограничивающие установки и увидеть альтернативные варианты.</label></div>
                            <div>
                            В итоге я сама построила карьерный план, расширила нетворк, выбрала интересные для меня вакансии, переработала резюме и укрепила свою самооценку.
                            </div>


                        </div>
                    </div>                        
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-review-a-b-slider-tablet', {
        label: 'Слайдер результатов А->Б (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-a-b-slider-tablet">
        <div>
            <div>
                <h2>Результаты клиентов</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624606994350.png" alt=""></div>
                            <div>
                                <h3>Рахиля Манджиева</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Ощущала, что застряла в одной роли и на одном уровне, хотела большего от своей реализации</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне осознать свою профессиональную ценность, расширить картину мира, осознать свой синдром «хорошей девочки». Я поняла, что уже нахожусь на идеальной для себя роли и знаю, как сделать свою карьеру лучше. Коучинг помог увидеть то, что я обычно не замечала. Но при этом ответственность за свои результаты несу, прежде всего, я сама.</label></div>

                        </div>
                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607023059.png" alt=""></div>
                            <div>
                                <h3>Анна Крохалевская</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела разобраться в траекториях своего пути и научиться делать карьерные выборы</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Я научилась смотреть на рабочие ситуации не с позиции борьбы, а с позиции легкости и удовольствия. Обрела больше доверия к себе и миру, сменила фокус с ограничений на возможности.</label></div>
                            <div>
                            Каждая сессия определенно стоила своих денег. Если вы только присматриваетесь, рекомендую сначала побыть в Карьерум.Клубе и заочно ответить для себя на некоторые вопросы. А после — работать индивидуально. 
                                </div>
                        </div>
                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607039435.png" alt=""></div>
                            <div>
                                <h3>Анастасия Бобрышева</h3>
                            </div>
                            <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела найти себя и определить направление развития своей карьеры, выбрать из множества вариантов</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне заглянуть вглубь себя, выявить причинно-следственные связи — что на самом деле стоит за моими желаниями и действиями — осознать ограничивающие установки и увидеть альтернативные варианты.</label></div>
                            <div>
                            В итоге я сама построила карьерный план, расширила нетворк, выбрала интересные для меня вакансии, переработала резюме и укрепила свою самооценку.
                            </div>
                        </div>
                    </div>                        
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-review-a-b-slider-mobile', {
        label: 'Слайдер результатов А->Б (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-review-a-b-slider-mobile">
        <div>
            <div>
                <h2>Результаты клиентов</h2>
            </div>
            <div class="slider slider-block">                
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607062510.png" alt=""></div>
                            <div>
                                <h3>Рахиля Манджиева</h3>
                            </div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Ощущала, что застряла в одной роли и на одном уровне, хотела большего от своей реализации</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне осознать свою профессиональную ценность, расширить картину мира, осознать свой синдром «хорошей девочки». Я поняла, что уже нахожусь на идеальной для себя роли и знаю, как сделать свою карьеру лучше. Коучинг помог увидеть то, что я обычно не замечала. Но при этом ответственность за свои результаты несу, прежде всего, я сама.</label></div>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>

                    </div>                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607081007.png" alt=""></div>
                            <div>
                                <h3>Анна Крохалевская</h3>
                            </div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела разобраться в траекториях своего пути и научиться делать карьерные выборы</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Я научилась смотреть на рабочие ситуации не с позиции борьбы, а с позиции легкости и удовольствия. Обрела больше доверия к себе и миру, сменила фокус с ограничений на возможности.</label></div>
                            <div>
                            Каждая сессия определенно стоила своих денег. Если вы только присматриваетесь, рекомендую сначала побыть в Карьерум.Клубе и заочно ответить для себя на некоторые вопросы. А после — работать индивидуально. 
                                </div>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>

                    </div>
                    
                </div>
                <div class="item"> 
                    <div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607101587.png" alt=""></div>
                            <div>
                                <h3>Анастасия Бобрышева</h3>
                            </div>
                        </div>
                        <div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623925732820.png" alt=""> <span>До:</span> <label>Хотела найти себя и определить направление развития своей карьеры, выбрать из множества вариантов</label></div>
                            <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1623926013749.png" alt=""> <span>После:</span> <label>Ольга помогла мне заглянуть вглубь себя, выявить причинно-следственные связи — что на самом деле стоит за моими желаниями и действиями — осознать ограничивающие установки и увидеть альтернативные варианты.</label></div>
                            <div>
                            В итоге я сама построила карьерный план, расширила нетворк, выбрала интересные для меня вакансии, переработала резюме и укрепила свою самооценку.
                            </div>
                        </div>
                        <div><a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017276297.png" alt=""></a></div>

                    </div>                        
                </div>
            </div>
        </div>
    </div>`
    });
    
    
    blockManager.add('carrerum-programs-slider', {
        label: 'Слайдер программ',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-programs-slider">
        <div>
            <div><h2>Индивидуальные программы</h2></div>            
            <div class="slider-block slider-pr">
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607932051.png" alt=""></div>
                    <div><h3>Пакет из 5 коуч-сессий раз в неделю</h3></div>
                    <div><p>Популярные запросы — создать стратегии поиска работы, изменить взгляд на рабочую ситуацию, прокачать осознанность</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607948997.png" alt=""></div>
                    <div><h3>Пакет из 10<br> коуч-сессий раз в <br>неделю</h3></div>
                    <div><p>Популярные запросы — определить свои ценности, мотиваторы, желания, получить поддержку в сложном карьерном этапе</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607971203.png" alt=""></div>
                    <div><h3>Консультация по резюме</h3></div>
                    <div><p>Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607987131.png" alt=""></div>
                    <div><h3>Подготовка к интервью</h3></div>
                    <div><p>Создание стратегии для вашей сферы и региона или репетиция интервью на конкретную вакансию с вопросами, которые с 80% вероятностью задаст вам компания</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608002539.png" alt=""></div>
                    <div><h3>MBA: первый шаг</h3></div>
                    <div><p>Помощь на самом старте: какую школу выбрать, как оценить свои шансы, на что обратить внимание</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608121266.png" alt=""></div>
                    <div><h3>MBA: все включено, 1 школа</h3></div>
                    <div><p>Полное сопровождение — создадите сильный личный бренд в глазах приемной комиссии, получите помощь с документами, интервью и профилями в соцсетях</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608135975.png" alt=""></div>
                    <div><h3>MBA: все включено, 2-3 школы</h3></div>
                    <div><p>Расширенное сопровождение — подайтесь сразу в 2-3 школы, выберите лучшую и сэкономьте на стоимости услуг коуча</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608154426.png" alt=""></div>
                    <div><h3>Корпоративный тариф</h3></div>
                    <div><p>Закажите индивидуальный коучинг для ваших сотрудников, который поможет им лучше понять цели компании, научиться мотивировать себя и расставлять приоритеты</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608600130.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608635343.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-programs-slider-tablet', {
        label: 'Слайдер программ (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-programs-slider-tablet">
        <div>
            <div><h2>Индивидуальные программы</h2></div>            
            <div class="slider-block slider-pr">
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608173281.png" alt=""></div>
                    <div><h3>Пакет из 5<br> коуч-сессий раз <br>в неделю</h3></div>
                    <div><p>Популярные запросы — создать стратегии поиска работы, изменить взгляд на рабочую ситуацию, прокачать осознанность</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608189527.png" alt=""></div>
                    <div><h3>Пакет из 10<br> коуч-сессий раз<br> в неделю</h3></div>
                    <div><p>Популярные запросы — определить свои ценности, мотиваторы, желания, получить поддержку в сложном карьерном этапе</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608204151.png" alt=""></div>
                    <div><h3>Консультация<br> по резюме</h3></div>
                    <div><p>Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608217083.png" alt=""></div>
                    <div><h3>Подготовка<br> к интервью</h3></div>
                    <div><p>Создание стратегии для вашей сферы и региона или репетиция интервью на конкретную вакансию с вопросами, которые с 80% вероятностью задаст вам компания</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608231693.png" alt=""></div>
                    <div><h3>MBA: первый шаг</h3></div>
                    <div><p>Помощь на самом старте: какую школу выбрать, как оценить свои шансы, на что обратить внимание</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608247344.png" alt=""></div>
                    <div><h3>MBA: все включено, 1 школа</h3></div>
                    <div><p>Полное сопровождение — создадите сильный личный бренд в глазах приемной комиссии, получите помощь с документами, интервью и профилями в соцсетях</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608261123.png" alt=""></div>
                    <div><h3>MBA: все включено, 2-3 школы</h3></div>
                    <div><p>Расширенное сопровождение — подайтесь сразу в 2-3 школы, выберите лучшую и сэкономьте на стоимости услуг коуча</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608273932.png" alt=""></div>
                    <div><h3>Корпоративный тариф</h3></div>
                    <div><p>Закажите индивидуальный коучинг для ваших сотрудников, который поможет им лучше понять цели компании, научиться мотивировать себя и расставлять приоритеты</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608600130.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608635343.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-programs-slider-mobile', {
        label: 'Слайдер программ (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-programs-slider-mobile">
        <div>
            <div><h2>Индивидуальные<br> программы</h2></div>            
            <div class="slider-block slider-pr">
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608296369.png" alt=""></div>
                    <div><h3>Пакет из 5 коуч-сессий<br> раз в неделю</h3></div>
                    <div><p>Популярные запросы — создать стратегии поиска работы, изменить взгляд на рабочую ситуацию, прокачать осознанность</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608311134.png" alt=""></div>
                    <div><h3>Пакет из 10 коуч-сессий<br> раз в неделю</h3></div>
                    <div><p>Популярные запросы — определить свои ценности, мотиваторы, желания, получить поддержку в сложном карьерном этапе</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608326010.png" alt=""></div>
                    <div><h3>Консультация по резюме</h3></div>
                    <div><p>Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608340743.png" alt=""></div>
                    <div><h3>Подготовка к интервью</h3></div>
                    <div><p>Создание стратегии для вашей сферы и региона или репетиция интервью на конкретную вакансию с вопросами, которые с 80% вероятностью задаст вам компания</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608353700.png" alt=""></div>
                    <div><h3>MBA: первый шаг</h3></div>
                    <div><p>Помощь на самом старте: какую школу выбрать, как оценить свои шансы, на что обратить внимание</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608366780.png" alt=""></div>
                    <div><h3>MBA: все включено,<br> 1 школа</h3></div>
                    <div><p>Полное сопровождение — создадите сильный личный бренд в глазах приемной комиссии, получите помощь с документами, интервью и профилями в соцсетях</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608379589.png" alt=""></div>
                    <div><h3>MBA: все включено,<br> 2-3 школы</h3></div>
                    <div><p>Расширенное сопровождение — подайтесь сразу в 2-3 школы, выберите лучшую и сэкономьте на стоимости услуг коуча</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
                <div>
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608393422.png" alt=""></div>
                    <div><h3>Корпоративный тариф</h3></div>
                    <div><p>Закажите индивидуальный коучинг для ваших сотрудников, который поможет им лучше понять цели компании, научиться мотивировать себя и расставлять приоритеты</p></div>
                    <div><a href="#">Подробнее</a></div>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608690652.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608705447.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-popup-program', {
        label: 'Попап программы',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-program carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815875011.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607971203.png" alt="">
                </div>
                <div>
                    <h2>
                        Консультация по резюме
                    </h2>
                    <p>
                        Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере
                    </p>
                    <div>  
                        <p>⏱️ <span> Длительность</span> — 60 минут</p>
                        <p>💵 <span> Стоимость</span> — 25 900 ₽</p>
                        <p>🌟 <span> Программа доступна только участникам Карьерум.Клуба после<br> курсов «Умная стратегия поиска работы»<br> и «Продающее резюме». Там уже 90% нужных вам знаний</span></p>                        
                    </div>
                    <div>
                        <a href="#">Пройти курсы</a>                        
                    </div>
                    <div>
                        <a href="#">Записаться</a>
                        <a href="#">Что такое коучинг</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-popup-program-tablet', {
        label: 'Попап программы (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-program-tablet carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1620815875011.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624607971203.png" alt="">
                </div>
                <div>
                    <h2>
                        Консультация по резюме
                    </h2>
                    <p>
                        Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере
                    </p>
                    <div>  
                        <p>⏱️ <span> Длительность</span> — 60 минут</p>
                        <p>💵 <span> Стоимость</span> — 25 900 ₽</p>
                        <p>🌟 <span> Программа доступна только участникам Карьерум.Клуба после<br> курсов «Умная стратегия поиска работы»<br> и «Продающее резюме». Там уже 90% нужных вам знаний</span></p>                        
                    </div>
                    <div>
                        <a href="#">Пройти курсы</a>                        
                    </div>
                    <div>
                        <a href="#">Записаться</a>
                        <a href="#">Что такое коучинг</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-popup-program-mobile', {
        label: 'Попап программы (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-popup-program-mobile carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624608204151.png" alt="">
                </div>
                <div>
                    <h2>
                        Консультация по резюме
                    </h2>
                    <p>
                        Усиление вашего резюме, чтобы увеличить отклики, претендовать на должность выше уровнем, спозиционировать себя в новой стране и сфере
                    </p>
                    <div>  
                        <p>⏱️ <span> Длительность</span> — 60 минут</p>
                        <p>💵 <span> Стоимость</span> — 25 900 ₽</p>
                        <p>🌟 <span> Программа доступна только участникам Карьерум.Клуба после<br> курсов «Умная стратегия поиска работы»<br> и «Продающее резюме». Там уже 90% нужных вам знаний</span></p>                        
                    </div>
                    <div>
                        <a href="#">Пройти курсы</a>                        
                    </div>
                    <div>
                        <a href="#">Записаться</a>
                        <a href="#">Что такое коучинг</a>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    
    
    blockManager.add('carrerum-img-slider', {
        label: 'Попап-слайдер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-img-slider carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                </div>
                <div class="slider-pop slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610114729.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610127970.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610144330.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610161092.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610180968.png" alt="">
                    </div>                
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>                
    </div>`
    });

    blockManager.add('carrerum-img-slider-tablet', {
        label: 'Попап-слайдер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-img-slider-tablet carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                </div>
                <div class="slider-pop slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610198874.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610212742.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610225674.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610240594.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610257729.png" alt="">
                    </div>                
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>                
    </div>`
    });

    blockManager.add('carrerum-img-slider-mobile', {
        label: 'Попап-слайдер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-img-slider-mobile carrerum-popup">
        <div>
            <img class="close" src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619016711744.png" alt="">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                </div>
                <div class="slider-pop slider-block">
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610273014.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610284362.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610297491.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610309190.png" alt="">
                    </div>
                    <div>
                        <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1624610321317.png" alt="">
                    </div>                
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>                
    </div>`
    });
    
    
    
    blockManager.add('core-values-slider', {
        label: 'Ценности - слайдер',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="core-values-slider">
        <div>
            <div class="slider-team slider-block">
                <div>
                    <h3>Следуй за талантами и ценностями</h3>
                    <hr>
                    <p>Делай то, в чем ты силен и что тебе нравится — получишь и удовольствие, и результат.</p>
                </div>
                <div>
                    <h3>Работай не по часам, а головой</h3>
                    <hr>
                    <p>Ставь цели, следуй принципу Парето — так ты дашь компании максимальную ценность.</p>
                </div>
                <div>
                    <h3>Строй отношения в команде</h3>
                    <hr>
                    <p>Отстаивай границы, обсуждай трудности, совместно находи решения и помни об экологичном общении.</p>
                </div>
                <div>
                    <h3>Выходи за рамки карьерных стандартов</h3>
                    <hr>
                    <p>Помни про job crafting — наполняй работу тем, чем действительно хочешь заниматься.</p>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('core-values-slider-tablet', {
        label: 'Ценности - слайдер (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="core-values-slider-tablet">
        <div>
            <div class="slider-team slider-block">
                <div>
                    <h3>Следуй за талантами и ценностями</h3>
                    <hr>
                    <p>Делай то, в чем ты силен и что тебе нравится — получишь и удовольствие, и результат.</p>
                </div>
                <div>
                    <h3>Работай не по часам, а головой</h3>
                    <hr>
                    <p>Ставь цели, следуй принципу Парето — так ты дашь компании максимальную ценность.</p>
                </div>
                <div>
                    <h3>Строй отношения в команде</h3>
                    <hr>
                    <p>Отстаивай границы, обсуждай трудности, совместно находи решения и помни об экологичном общении.</p>
                </div>
                <div>
                    <h3>Выходи за рамки карьерных стандартов</h3>
                    <hr>
                    <p>Помни про job crafting — наполняй работу тем, чем действительно хочешь заниматься.</p>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('core-values-slider-mobile', {
        label: 'Ценности - слайдер (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="core-values-slider-mobile">
        <div>
            <div class="slider-team slider-block">
                <div>
                    <h3>Следуй за талантами и ценностями</h3>
                    <hr>
                    <p>Делай то, в чем ты силен и что тебе нравится — получишь и удовольствие, и результат.</p>
                </div>
                <div>
                    <h3>Работай не по часам, а головой</h3>
                    <hr>
                    <p>Ставь цели, следуй принципу Парето — так ты дашь компании максимальную ценность.</p>
                </div>
                <div>
                    <h3>Строй отношения в команде</h3>
                    <hr>
                    <p>Отстаивай границы, обсуждай трудности, совместно находи решения и помни об экологичном общении.</p>
                </div>
                <div>
                    <h3>Выходи за рамки карьерных стандартов</h3>
                    <hr>
                    <p>Помни про job crafting — наполняй работу тем, чем действительно хочешь заниматься.</p>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });
    

    
    blockManager.add('carrerum-our-team-all', {
        label: 'Команда проекта',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-team-all">
        <div>
            <div>
                <h2>Наша команда</h2>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657448088.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="product">Продуктовая команда</li> 
                            <li data-sort="experts">Команда экспертов</li> 
                            <li data-sort="marketing">Команда маркетинга</li> 
                            <li data-sort="technical">Техническая команда</li>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Основательница Карьерума</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657521195.png" alt="">
                            <h4>Ольга Лермонтова, CEO и топ-эксперт, Италия</h4>
                            <p>Управляет процессами в компании и создает курсы-бестселлеры. Коуч ICF, степень MBA от топовой бизнес-школы INSEAD.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="product">
                    <div>
                        <h3>Продуктово-проектная команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657536294.png" alt="">
                            <h4>Юлиана Керт, директор по продукту, Россия</h4>
                            <p>Управляет экосистемой наших продуктов, которые помогают строить карьеру с удовольствием. Руководит продуктовой командой. Коуч ICF.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657550117.png" alt="">
                            <h4>Анастасия Бесова, продакт-менеджер, Бельгия</h4>
                            <p>Руководит созданием обучающих материалов клуба. Ведет ключевые проекты: аналитика, UX-дизайн сайта и нетворкинговой платформы.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657569633.png" alt="">
                            <h4>Виктория Фадеева, проджект-менеджер, Россия</h4>
                            <p>Руководит разработкой и поддержкой образовательной и нетворкинговой платформ и сайта проекта. Решает организационные вопросы клиентов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657592620.jpg" alt="">
                            <h4>Дарья Цында, контент-менеджер, Украина</h4>
                            <p>Структурирует контент проекта, делает обучение понятным и эффективным. Курирует менторскую программу и работу амбассадоров Карьерум.Клуба.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657612143.png" alt="">
                            <h4>Дарина Байжанова, проектный <br>ассистент,<br> Казахстан</h4>
                            <p>Поддерживает порядок в хранилищах команды, помогает актуализировать материалы, модерирует вебинары Карьерум.Клуба, курирует планерки.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="experts">
                    <div>
                        <h3>Команда экспертов</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657624673.png" alt="">
                            <h4>Астра Висаева, коуч, Россия</h4>
                            <p>Коуч ICF, специализируется на теме внутренних ресурсов. Коучинговый стаж в Карьерум.Клубе — 2000+ участников</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657639290.png" alt="">
                            <h4>Светлана Баран, коуч, Казахстан</h4>
                            <p>Консультант по поиску работы и карьере за рубежом. Коучинговый стаж в Карьерум.Клубе — 2000+ участников.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657651149.png" alt="">
                            <h4>Полина Артеменко, CV-эксперт, Великобритания</h4>
                            <p>Специалист по резюме и зарубежному образованию. 70+ кейсов успешного поступления в топовые бизнес-школы, помогла с CV 600+ клубовцев.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="marketing">
                    <div>
                        <h3>Команда маркетинга</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657665606.png" alt="">
                            <h4>Юлиана Логинова, директор по маркетингу, Россия</h4>
                            <p>Помогает профессионалам по всему миру узнавать о проекте, развивает все площадки и каналы продвижения.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657680686.png" alt="">
                            <h4>Юлия Орлова, проджект-менеджер, Россия</h4>
                            <p>Управляет созданием подкастов и роликов, организует прямые эфиры с участниками проекта. Фея рассылок и бота Райана</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657697106.png" alt="">
                            <h4>Дарья Московкина, контент-менеджер, Россия</h4>
                            <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657712044.png" alt="">
                            <h4>Юлия Вьюшина, копирайтер, Россия</h4>
                            <p>Создает посты, письма и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и интересным.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="technical">
                    <div>
                        <h3>Техническая команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657725551.png" alt="">
                            <h4>Иннокентий Солнцев, технический директор, разработчик, Италия</h4>
                            <p>Отвечает за создание всех технических сервисов Карьерума. Создает нашу собственную платформу — соцсеть русскоязычных профессионалов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657737322.png" alt="">
                            <h4>Артем Покатилов, разработчик и аналитик, Россия <br>&nbsp;</h4>
                            <p>Формирует отчеты для аналитики маркетинга. Разрабатывает конструктор сайтов Карьерума, собственные CRM- и LMS-системы.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-our-team-all-tablet', {
        label: 'Команда проекта (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-team-all-tablet">
        <div>
            <div>
                <h2>Наша команда</h2>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657471536.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="product">Продуктовая команда</li> 
                            <li data-sort="experts">Команда экспертов</li> 
                            <li data-sort="marketing">Команда маркетинга</li> 
                            <li data-sort="technical">Техническая команда</li>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Основательница Карьерума</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657833961.png" alt="">
                            <h4>Ольга Лермонтова,<br> CEO и топ-эксперт,<br> Италия</h4>
                            <p>Управляет процессами в компании и создает курсы-бестселлеры. Коуч ICF, степень MBA от топовой бизнес-школы INSEAD.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="product">
                    <div>
                        <h3>Продуктово-проектная команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657850761.png" alt="">
                            <h4>Юлиана Керт, директор по продукту, Россия</h4>
                            <p>Управляет экосистемой наших продуктов, которые помогают строить карьеру с удовольствием. Руководит продуктовой командой. Коуч ICF.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657866311.png" alt="">
                            <h4>Анастасия Бесова, продакт-менеджер, Бельгия</h4>
                            <p>Руководит созданием обучающих материалов клуба. Ведет ключевые проекты: аналитика, UX-дизайн сайта и нетворкинговой платформы.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657885081.png" alt="">
                            <h4>Виктория Фадеева, проджект-менеджер, Россия</h4>
                            <p>Руководит разработкой и поддержкой образовательной и нетворкинговой платформ и сайта проекта. Решает организационные вопросы клиентов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657904166.jpg" alt="">
                            <h4>Дарья Цында,<br> контент-менеджер,<br> Украина</h4>
                            <p>Структурирует контент проекта, делает обучение понятным и эффективным. Курирует менторскую программу и работу амбассадоров Карьерум.Клуба.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657931116.png" alt="">
                            <h4>Дарина Байжанова, проектный ассистент,<br> Казахстан</h4>
                            <p>Поддерживает порядок в хранилищах команды, помогает актуализировать материалы, модерирует вебинары Карьерум.Клуба, курирует планерки.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="experts">
                    <div>
                        <h3>Команда экспертов</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657944808.png" alt="">
                            <h4>Астра Висаева,<br> коуч, Россия</h4>
                            <p>Коуч ICF, специализируется на теме внутренних ресурсов. Коучинговый стаж в Карьерум.Клубе — 2000+ участников</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657960680.png" alt="">
                            <h4>Светлана Баран,<br> коуч, Казахстан</h4>
                            <p>Консультант по поиску работы и карьере за рубежом. Коучинговый стаж в Карьерум.Клубе — 2000+ участников.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657973549.png" alt="">
                            <h4>Полина Артеменко,<br> CV-эксперт, <br>Великобритания</h4>
                            <p>Специалист по резюме и зарубежному образованию. 70+ кейсов успешного поступления в топовые бизнес-школы, помогла с CV 600+ клубовцев.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="marketing">
                    <div>
                        <h3>Команда маркетинга</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657991686.png" alt="">
                            <h4>Юлиана Логинова, директор по маркетингу, Россия</h4>
                            <p>Помогает профессионалам по всему миру узнавать о проекте, развивает все площадки и каналы продвижения.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625658005761.png" alt="">
                            <h4>Юлия Орлова,<br> проджект-менеджер, Россия</h4>
                            <p>Управляет созданием подкастов и роликов, организует прямые эфиры с участниками проекта. Фея рассылок и бота Райана</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625658020254.png" alt="">
                            <h4>Дарья Московкина, контент-менеджер, Россия</h4>
                            <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625658033620.png" alt="">
                            <h4>Юлия Вьюшина, копирайтер, Россия</h4>
                            <p>Создает посты, письма и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и интересным.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="technical">
                    <div>
                        <h3>Техническая команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625658048056.png" alt="">
                            <h4>Иннокентий Солнцев, технический директор, разработчик, Италия</h4>
                            <p>Отвечает за создание всех технических сервисов Карьерума. Создает нашу собственную платформу — соцсеть русскоязычных профессионалов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625658061104.png" alt="">
                            <h4>Артем Покатилов, разработчик и<br> аналитик, Россия </h4>
                            <p>Формирует отчеты для аналитики маркетинга. Разрабатывает конструктор сайтов Карьерума, собственные CRM- и LMS-системы.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-our-team-all-mobile', {
        label: 'Команда проекта (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-our-team-all-mobile">
        <div>
            <div>
                <h2>Наша команда</h2>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657487064.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="product">Продуктовая команда</li> 
                            <li data-sort="experts">Команда экспертов</li> 
                            <li data-sort="marketing">Команда маркетинга</li> 
                            <li data-sort="technical">Техническая команда</li>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <div>
                        <h3>Основательница Карьерума</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666897596.png" alt="">
                            <h4>Ольга Лермонтова, CEO <br>и топ-эксперт, Италия</h4>
                            <p>Управляет процессами в компании и создает курсы-бестселлеры. Коуч ICF, степень MBA от топовой бизнес-школы INSEAD.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="product">
                    <div>
                        <h3>Продуктово-проектная команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666919670.png" alt="">
                            <h4>Юлиана Керт, директор<br> по продукту, Россия</h4>
                            <p>Управляет экосистемой наших продуктов, которые помогают строить карьеру с удовольствием. Руководит продуктовой командой. Коуч ICF.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666936555.png" alt="">
                            <h4>Анастасия Бесова,<br> продакт-менеджер,<br> Бельгия</h4>
                            <p>Руководит созданием обучающих материалов клуба. Ведет ключевые проекты: аналитика, UX-дизайн сайта и нетворкинговой платформы.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666954662.png" alt="">
                            <h4>Виктория Фадеева,<br> проджект-менеджер,<br> Россия</h4>
                            <p>Руководит разработкой и поддержкой образовательной и нетворкинговой платформ и сайта проекта. Решает организационные вопросы клиентов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666972294.png" alt="">
                            <h4>Дарья Цында,<br> контент-менеджер,<br> Украина</h4>
                            <p>Структурирует контент проекта, делает обучение понятным и эффективным. Курирует менторскую программу и работу амбассадоров Карьерум.Клуба.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625666996029.png" alt="">
                            <h4>Дарина Байжанова,<br> проектный ассистент,<br> Казахстан</h4>
                            <p>Поддерживает порядок в хранилищах команды, помогает актуализировать материалы, модерирует вебинары Карьерум.Клуба, курирует планерки.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="experts">
                    <div>
                        <h3>Команда экспертов</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667013168.png" alt="">
                            <h4>Астра Висаева, коуч,<br> Россия</h4>
                            <p>Коуч ICF, специализируется на теме внутренних ресурсов. Коучинговый стаж в Карьерум.Клубе — 2000+ участников</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667035748.png" alt="">
                            <h4>Светлана Баран, коуч,<br> Казахстан</h4>
                            <p>Консультант по поиску работы и карьере за рубежом. Коучинговый стаж в Карьерум.Клубе — 2000+ участников.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667052825.png" alt="">
                            <h4>Полина Артеменко,<br> CV-эксперт, <br>Великобритания</h4>
                            <p>Специалист по резюме и зарубежному образованию. 70+ кейсов успешного поступления в топовые бизнес-школы, помогла с CV 600+ клубовцев.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="marketing">
                    <div>
                        <h3>Команда маркетинга</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667070564.png" alt="">
                            <h4>Юлиана Логинова,<br> директор по маркетингу,<br> Россия</h4>
                            <p>Помогает профессионалам по всему миру узнавать о проекте, развивает все площадки и каналы продвижения.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667087646.png" alt="">
                            <h4>Юлия Орлова,<br> проджект-менеджер,<br> Россия</h4>
                            <p>Управляет созданием подкастов и роликов, организует прямые эфиры с участниками проекта. Фея рассылок и бота Райана</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667113558.png" alt="">
                            <h4>Дарья Московкина,<br> контент-менеджер,<br> Россия</h4>
                            <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667131442.png" alt="">
                            <h4>Юлия Вьюшина,<br> копирайтер, Россия</h4>
                            <p>Создает посты, письма и сценарии для наших читателей в соцсетях, делает контент информативным, понятным и интересным.</p>
                        </div>
                    </div>
                </div>
                <div data-sort="technical">
                    <div>
                        <h3>Техническая команда</h3>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667159973.png" alt="">
                            <h4>Иннокентий Солнцев,<br> технический директор,<br> разработчик, Италия</h4>
                            <p>Отвечает за создание всех технических сервисов Карьерума. Создает нашу собственную платформу — соцсеть русскоязычных профессионалов.</p>
                        </div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667176176.png" alt="">
                            <h4>Артем Покатилов,<br> разработчик и аналитик,<br> Россия </h4>
                            <p>Формирует отчеты для аналитики маркетинга. Разрабатывает конструктор сайтов Карьерума, собственные CRM- и LMS-системы.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>`
    });

    

    blockManager.add('carrerum-vacancy', {
        label: 'Вакансии',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-vacancy">
        <div>
            <div>
                <h2>Хотите присоединиться? У нас открыты<br> вакансии</h2>
                <p>Получите опыт в крупнейшем карьерном EdTech-проекте России и СНГ,<br> колоссальный рост и компенсацию выше рынка</p>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657448088.png" alt=""></p>
                    <div>
                        <ul> 
                            <li data-vac="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="slider-vacancy slider-block">
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667749853.png" alt=""></div>
                    <h3>Карьерный эксперт</h3>
                    <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667767586.png" alt=""></div>
                    <h3>Коуч</h3>
                    <p>Помогать участникам проекта эффективно учиться и приходить к результатам.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667790195.png" alt=""></div>
                    <h3>Аналитик</h3>
                    <p>Собирать данные, автоматизировать отчетность, тестировать data-driven гипотезы</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667810409.png" alt=""></div>
                    <h3>Разработчик</h3>
                    <p>Участвовать в разработке экосистемы платформ Карьерума</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667842515.png" alt=""></div>
                    <h3>UX-дизайнер</h3>
                    <p>Разрабатывать интерфейсы для наших новых платформ, усиливать текущие</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667860887.png" alt=""></div>
                    <h3>Копирайтер</h3>
                    <p>Писать посты, лендинги и сценарии, усиливать их с точки зрения маркетинга</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667879246.png" alt=""></div>
                    <h3>Product Marketing Specialist (eng)</h3>
                    <p>Разрабатывать стратегию выхода Карьерума на англоязычный рынок</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667897207.png" alt=""></div>
                    <h3>Marketing Copywriter (eng)</h3>
                    <p>Создавать сильные маркетинговые материалы для англоязычного рынка</p>
                    <a href="#">Откликнуться</a>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-vacancy-tablet', {
        label: 'Вакансии (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-vacancy-tablet">
        <div>
            <div>
                <h2>Хотите присоединиться? У нас открыты вакансии</h2>
                <p>Получите опыт в крупнейшем карьерном EdTech-проекте России и <br>СНГ, колоссальный рост и компенсацию выше рынка</p>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657471536.png" alt=""></p>
                    <div>
                        <ul class="slick-dots"> 
                            <li data-vac="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="slider-vacancy slider-block">
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667749853.png" alt=""></div>
                    <h3>Карьерный эксперт</h3>
                    <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667767586.png" alt=""></div>
                    <h3>Коуч</h3>
                    <p>Помогать участникам проекта эффективно учиться и приходить к результатам.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667790195.png" alt=""></div>
                    <h3>Аналитик</h3>
                    <p>Собирать данные, автоматизировать отчетность, тестировать data-driven гипотезы</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667810409.png" alt=""></div>
                    <h3>Разработчик</h3>
                    <p>Участвовать в разработке экосистемы платформ Карьерума</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667842515.png" alt=""></div>
                    <h3>UX-дизайнер</h3>
                    <p>Разрабатывать интерфейсы для наших новых платформ, усиливать текущие</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667860887.png" alt=""></div>
                    <h3>Копирайтер</h3>
                    <p>Писать посты, лендинги и сценарии, усиливать их с точки зрения маркетинга</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667879246.png" alt=""></div>
                    <h3>Product Marketing Specialist (eng)</h3>
                    <p>Разрабатывать стратегию выхода Карьерума на англоязычный рынок</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667897207.png" alt=""></div>
                    <h3>Marketing Copywriter (eng)</h3>
                    <p>Создавать сильные маркетинговые материалы для англоязычного рынка</p>
                    <a href="#">Откликнуться</a>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-vacancy-mobile', {
        label: 'Вакансии (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-vacancy-mobile">
        <div>
            <div>
                <h2>Хотите присоединиться? У нас открыты вакансии</h2>
                <p>Получите опыт в крупнейшем карьерном EdTech-проекте России и СНГ,<br> колоссальный рост и компенсацию выше рынка</p>
            </div>
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657487064.png" alt=""></p>
                    <div>
                        <ul class="slick-dots"> 
                            <li data-vac="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="slider-vacancy slider-block">
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667749853.png" alt=""></div>
                    <h3>Карьерный эксперт</h3>
                    <p>Создает контент-стратегию для всех соцсетей, запускает новые каналы и рубрики, контролирует и доводит до результата работу копирайтеров.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667767586.png" alt=""></div>
                    <h3>Коуч</h3>
                    <p>Помогать участникам проекта эффективно учиться и приходить к результатам.</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667790195.png" alt=""></div>
                    <h3>Аналитик</h3>
                    <p>Собирать данные, автоматизировать отчетность, тестировать data-driven гипотезы</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667810409.png" alt=""></div>
                    <h3>Разработчик</h3>
                    <p>Участвовать в разработке экосистемы платформ Карьерума</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667842515.png" alt=""></div>
                    <h3>UX-дизайнер</h3>
                    <p>Разрабатывать интерфейсы для наших новых платформ, усиливать текущие</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667860887.png" alt=""></div>
                    <h3>Копирайтер</h3>
                    <p>Писать посты, лендинги и сценарии, усиливать их с точки зрения маркетинга</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667879246.png" alt=""></div>
                    <h3>Product Marketing Specialist (eng)</h3>
                    <p>Разрабатывать стратегию выхода Карьерума на англоязычный рынок</p>
                    <a href="#">Откликнуться</a>
                </div>
                <div class="vac-item">
                    <div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667897207.png" alt=""></div>
                    <h3>Marketing Copywriter (eng)</h3>
                    <p>Создавать сильные маркетинговые материалы для англоязычного рынка</p>
                    <a href="#">Откликнуться</a>
                </div>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
            </div>
        </div>
    </div>`
    });

    
    blockManager.add('carrerum-choose-social-btns', {
        label: 'Выбор удобной соц сети',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns">
        <div>
            <h2>Где ты хочешь со мной общаться?</h2>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841273313.png" alt="">
                    <p>Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841295461.png" alt="">
                    <p>Vkontakte</p>
                </a>
            </div>
            <p>Напиши мне кодовое слово или фразу, а я пришлю тебе полезный материал, <br>который поможет сделать следующий шаг в карьере</p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-choose-social-btns-tablet', {
        label: 'Выбор удобной соц сети (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns-tablet">
        <div>
            <h2>Где ты хочешь со мной общаться?</h2>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841311458.png" alt="">
                    <p>Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841322795.png" alt="">
                    <p>Vkontakte</p>
                </a>
            </div>
            <p>Напиши мне кодовое слово или фразу, а я пришлю тебе полезный материал,<br> который поможет сделать следующий шаг в карьере</p>
        </div>
    </div>`
    });

    blockManager.add('carrerum-choose-social-btns-mobile', {
        label: 'Выбор удобной соц сети (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns-mobile">
        <div>
            <h2>Где ты хочешь со мной общаться?</h2>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841335357.png" alt="">
                    <p>Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841348041.png" alt="">
                    <p>Vkontakte</p>
                </a>
            </div>
            <p>Напиши мне кодовое слово или фразу, а я пришлю тебе полезный материал, который поможет сделать следующий шаг в карьере</p>
        </div>
    </div>`
    });


    
    blockManager.add('carrerum-filter-for-sliders', {
        label: 'Фильтр для слайдеров',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-filter-for-sliders">
        <div class="filter-for-sliders">
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657448088.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-item item1">
            <div>
                <div>
                    <h2>Самое важное</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Привет»</h3>
                        <hr>
                        <p>Мечтаешь узнать, чего именно тебе не хватает для повышения? Протестирую уровень твоих карьерных навыков и подскажу, какие прокачать для взлета карьеры</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вернуться»</h3>
                        <hr>
                        <p>Хочешь вернуться в наше закрытое сообщество и начать путь к новым целям? Впущу тебя в Карьерум.Клуб вне очереди, если раньше у тебя уже была подписка</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Смотреть бесплатно»</h3>
                        <hr>
                        <p>Мечтаешь подглядеть, как проходит обучение в клубе, и принять решение, вступать ли в него? Бесплатно покажу 30-минутные фрагменты наших курсов-бестселлеров</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Жду Старт»</h3>
                        <hr>
                        <p>Хочешь попасть в следующий поток нашего курса для начинающих карьеристов? Запишу тебя в секретный лист ожидания и пришлю весточку, когда начнется новый набор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вейтлист»</h3>
                        <hr>
                        <p>Планируешь плотно заняться своей карьерой в сообществе единомышленников? Мест пока нет, но я внесу тебя в список желающих и оповещу, когда можно будет зайти в клуб</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эфиры»</h3>
                        <hr>
                        <p>Не терпится начать прокачивать новые навыки? Пришлю подборку полезных и вдохновляющих эфиров нашей основательницы и топ-эксперта Ольги Лермонтовой</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item2">
            <div>
                <div>
                    <h2>Призвание и уверенность</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Самооценка»</h3>
                        <hr>
                        <p>Чувствуешь, что пора поработать над профессиональной самооценкой? Пришлю эфир о том, как бороться со своими страхами и перестать быть перфекционистом</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Неуверенность»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Психология неуверенности»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Баланс»</h3>
                        <hr>
                        <p>Хочешь избавиться от стресса и оставаться в балансе даже с высоким уровнем ответственности? Поделюсь лайфхаками, которые помогут даже в плотном графике</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Ванда»</h3>
                        <hr>
                        <p>Чувствуешь, что ложные установки мешают твоей успешной и счастливой карьере? Расскажу, как самостоятельно разобраться с ними и развить новые привычки мышления</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item3">
            <div>
                <div>
                    <h2>Работа мечты</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item4">
            <div>
                <div>
                    <h2>Смена сферы</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Успешный переход»</h3>
                        <hr>
                        <p>Планируешь перейти в новую сферу с повышением? Поделюсь, как сделать это, опираясь на свои приоритеты и ценности, а не только на зарплату</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Карьерный взлет»</h3>
                        <hr>
                        <p>Хочешь найти работу в новой сфере за 2 месяца и с повышением? Это реально! Поделюсь лайфхаками на примере участницы Карьерума</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Волонтерство»</h3>
                        <hr>
                        <p>Привлекает волонтерство, но ты не знаешь, как реализоваться в этой сфере? Расскажу об опыте участницы, которая построила карьеру в некоммерческом секторе</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Консалтинг»</h3>
                        <hr>
                        <p>Мечтаешь о работе в большой тройке или четверке? Пришлю эфир о том, как попасть в самую высокооплачиваемую сферу и влиять на стратегии топовых компаний мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Долина»</h3>
                        <hr>
                        <p>Хочешь построить карьеру в Кремниевой долине? Расскажу, как сменить сферу с химической на программирование и попасть на стажировку в IT-столицу мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Путь в IT»</h3>
                        <hr>
                        <p>Думаешь, что после трехлетнего перерыва в работе невозможно реализоваться в новой отрасли? Пришлю эфир о переходе из лингвистики в IT-сферу</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item5">
            <div>
                <div>
                    <h2>Повышение</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Второе дыхание»</h3>
                        <hr>
                        <p>Хочешь найти в себе новые силы для работы, получив повышению? Расскажу, как повысить мотивацию и удовлетворенность, благодаря новой роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Повышение»</h3>
                        <hr>
                        <p>Надоело плыть по течению и ждать инициативы от начальника? Расскажу тебе, как получить повышение в должности и деньгах</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Возможно все»</h3>
                        <hr>
                        <p>Думаешь, что нельзя совместить высокую зарплату и удовольствие от работы? Поделюсь, как получить оффер мечты и повышение зарплаты на 40%</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Рост в компании»</h3>
                        <hr>
                        <p>Хочешь уволиться, но сомневаешься? Расскажу, как поставить значимую для тебя карьерную цель в текущей компании, стать более ценным сотрудником и получить повышение</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item6">
            <div>
                <div>
                    <h2>Студентам и выпускникам</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Молодой специалист»</h3>
                        <hr>
                        <p>Только начинаешь свой карьерный путь? Расскажу о карьерных шагах для молодого специалиста, которые сразу зададут нужный вектор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Мощный старт»</h3>
                        <hr>
                        <p>Хочешь найти работу, но у тебя мало опыта? Поделюсь, как это сделать, не приукрашивая факты в резюме и не соглашаясь на самые низкие роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вдохновись»</h3>
                        <hr>
                        <p>Учишься в вузе, но хочешь заложить фундамент для карьеры уже сейчас? Пришлю пошаговую стратегию, как осознанно строить свой путь начиная с первого курса</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Первый шаг»</h3>
                        <hr>
                        <p>Хочешь грамотно начать карьеру, не совершая типичных ошибок? Расскажу, как позиционировать себя, чтобы найти работу за 3 недели</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item7">
            <div>
                <div>
                    <h2>Soft skills</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Команда мечты»</h3>
                        <hr>
                        <p>Мечтаешь выстроить правильную коммуникацию в команде и увеличить продуктивность групповой работы? Расскажу о фишках, которые используют руководители</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Управляй руководителем»</h3>
                        <hr>
                        <p>Мечтаешь научиться выстраивать взаимовыгодные отношения с начальником? Покажу, как управлять боссом, чтобы все были довольны</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Презентация»</h3>
                        <hr>
                        <p>Хочешь уверенно и без стресса проводить встречи, переговоры или презентации? Поделюсь полезными лайфхаками, которые помогут всегда быть на высоте</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Биг Босс»</h3>
                        <hr>
                        <p>Все еще считаешь, что лидерство — это врожденный талант? Готов доказать тебе обратное — поделюсь, как развить в себе мышление руководителя</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нетворкинг»</h3>
                        <hr>
                        <p>Думаешь, как выстроить круг деловых контактов и создать вокруг себя поддерживающее окружение? Расскажу о 5 шагах к крепкой сети полезных знакомств</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эмоции»</h3>
                        <hr>
                        <p>Хочешь узнать, как эмоции влияют на карьеру? Расскажу, как прокачать эмоциональный интеллект и достичь успехов с его помощью</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item8">
            <div>
                <div>
                    <h2>За рубежом</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«К знаниям»</h3>
                        <hr>
                        <p>Мечтаешь учиться за границей? Расскажу тебе все об эффективной подготовке к поступлению в зарубежную магистратуру или топовую бизнес-школу</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Лондон»</h3>
                        <hr>
                        <p>Вдохновляешься лондонскими пейзажами и фильмами о Шерлоке Холмсе? Поделюсь, как живется и работается в столице Великобритании</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Германии»</h3>
                        <hr>
                        <p>Присматриваешься к Германии в качестве нового места для жизни и работы? Расскажу обо всех подводных камнях, которые полезно знать перед релокацией</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в США»</h3>
                        <hr>
                        <p>Готовишься покорить Америку? Пришлю эфир о жизни и работе в США — посмотри, прежде чем планировать переезд</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Италии»</h3>
                        <hr>
                        <p>Интересуешься карьерой в Италии? Поделюсь всеми плюсами и минусами, которые важно учитывать при планировании карьерного пути</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Учеба без границ»</h3>
                        <hr>
                        <p>Хочешь узнать, влияет ли зарубежное образование на карьеру и что выбрать — корпорацию или свой бизнес? Пришлю полезный эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item9">
            <div>
                <div>
                    <h2>Кризис</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Лимонад»</h3>
                        <hr>
                        <p>Переживаешь из-за бесконечных экономических кризисов? Расскажу, как выжать максимум возможностей для своей карьеры из любого «черного лебедя»</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Химик»</h3>
                        <hr>
                        <p>Работаешь в узкой сфере и боишься сокращений? Поделюсь, как одна из наших участниц получила оффер в кризис с повышением зарплаты на 25%, будучи химиком</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нефть»</h3>
                        <hr>
                        <p>Хочешь узнать, как не откладывать карьерный план до лучших времен и быстро сменить работу даже в кризис? Пришлю вдохновляющий эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item item10">
            <div>
                <div>
                    <h2>Отдохни</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Посоветуй книгу»</h3>
                        <hr>
                        <p>Никогда не проходишь мимо книжных магазинов? Помогу тебе выбрать увлекательную и полезную книгу о карьере и саморазвитии</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Посоветуй фильм»</h3>
                        <hr>
                        <p>Тоже обожаешь провести вечер за хорошим кино? С радостью поделюсь с тобой лучшими фильмами из тех, которые посмотрел</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Заставка»</h3>
                        <hr>
                        <p>Хочешь мотивирующую заставку на телефон, которая вдохновит тебя делать шаги к цели каждый день? Ни слова больше — я уже готов прислать</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«На стиле»</h3>
                        <hr>
                        <p>Мечтаешь чувствовать себя комфортно и нравиться себе в одежде (в офисе и вне его)? Поделюсь эфиром опытного стилиста на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-filter-for-sliders-tablet', {
        label: 'Фильтр для слайдеров (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-filter-for-sliders-tablet">
        <div class="filter-for-sliders-tablet">
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657471536.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item1">
            <div>
                <div>
                    <h2>Самое важное</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Привет»</h3>
                        <hr>
                        <p>Мечтаешь узнать, чего именно тебе не хватает для повышения? Протестирую уровень твоих карьерных навыков и подскажу, какие прокачать для взлета карьеры</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вернуться»</h3>
                        <hr>
                        <p>Хочешь вернуться в наше закрытое сообщество и начать путь к новым целям? Впущу тебя в Карьерум.Клуб вне очереди, если раньше у тебя уже была подписка</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Смотреть бесплатно»</h3>
                        <hr>
                        <p>Мечтаешь подглядеть, как проходит обучение в клубе, и принять решение, вступать ли в него? Бесплатно покажу 30-минутные фрагменты наших курсов-бестселлеров</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Жду Старт»</h3>
                        <hr>
                        <p>Хочешь попасть в следующий поток нашего курса для начинающих карьеристов? Запишу тебя в секретный лист ожидания и пришлю весточку, когда начнется новый набор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вейтлист»</h3>
                        <hr>
                        <p>Планируешь плотно заняться своей карьерой в сообществе единомышленников? Мест пока нет, но я внесу тебя в список желающих и оповещу, когда можно будет зайти в клуб</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эфиры»</h3>
                        <hr>
                        <p>Не терпится начать прокачивать новые навыки? Пришлю подборку полезных и вдохновляющих эфиров нашей основательницы и топ-эксперта Ольги Лермонтовой</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item2">
            <div>
                <div>
                    <h2>Призвание и уверенность</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Самооценка»</h3>
                        <hr>
                        <p>Чувствуешь, что пора поработать над профессиональной самооценкой? Пришлю эфир о том, как бороться со своими страхами и перестать быть перфекционистом</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Неуверенность»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Психология неуверенности»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Баланс»</h3>
                        <hr>
                        <p>Хочешь избавиться от стресса и оставаться в балансе даже с высоким уровнем ответственности? Поделюсь лайфхаками, которые помогут даже в плотном графике</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Ванда»</h3>
                        <hr>
                        <p>Чувствуешь, что ложные установки мешают твоей успешной и счастливой карьере? Расскажу, как самостоятельно разобраться с ними и развить новые привычки мышления</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item3">
            <div>
                <div>
                    <h2>Работа мечты</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item4">
            <div>
                <div>
                    <h2>Смена сферы</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Успешный переход»</h3>
                        <hr>
                        <p>Планируешь перейти в новую сферу с повышением? Поделюсь, как сделать это, опираясь на свои приоритеты и ценности, а не только на зарплату</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Карьерный взлет»</h3>
                        <hr>
                        <p>Хочешь найти работу в новой сфере за 2 месяца и с повышением? Это реально! Поделюсь лайфхаками на примере участницы Карьерума</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Волонтерство»</h3>
                        <hr>
                        <p>Привлекает волонтерство, но ты не знаешь, как реализоваться в этой сфере? Расскажу об опыте участницы, которая построила карьеру в некоммерческом секторе</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Консалтинг»</h3>
                        <hr>
                        <p>Мечтаешь о работе в большой тройке или четверке? Пришлю эфир о том, как попасть в самую высокооплачиваемую сферу и влиять на стратегии топовых компаний мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Долина»</h3>
                        <hr>
                        <p>Хочешь построить карьеру в Кремниевой долине? Расскажу, как сменить сферу с химической на программирование и попасть на стажировку в IT-столицу мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Путь в IT»</h3>
                        <hr>
                        <p>Думаешь, что после трехлетнего перерыва в работе невозможно реализоваться в новой отрасли? Пришлю эфир о переходе из лингвистики в IT-сферу</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item5">
            <div>
                <div>
                    <h2>Повышение</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Второе дыхание»</h3>
                        <hr>
                        <p>Хочешь найти в себе новые силы для работы, получив повышению? Расскажу, как повысить мотивацию и удовлетворенность, благодаря новой роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Повышение»</h3>
                        <hr>
                        <p>Надоело плыть по течению и ждать инициативы от начальника? Расскажу тебе, как получить повышение в должности и деньгах</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Возможно все»</h3>
                        <hr>
                        <p>Думаешь, что нельзя совместить высокую зарплату и удовольствие от работы? Поделюсь, как получить оффер мечты и повышение зарплаты на 40%</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Рост в компании»</h3>
                        <hr>
                        <p>Хочешь уволиться, но сомневаешься? Расскажу, как поставить значимую для тебя карьерную цель в текущей компании, стать более ценным сотрудником и получить повышение</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item6">
            <div>
                <div>
                    <h2>Студентам и выпускникам</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Молодой специалист»</h3>
                        <hr>
                        <p>Только начинаешь свой карьерный путь? Расскажу о карьерных шагах для молодого специалиста, которые сразу зададут нужный вектор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Мощный старт»</h3>
                        <hr>
                        <p>Хочешь найти работу, но у тебя мало опыта? Поделюсь, как это сделать, не приукрашивая факты в резюме и не соглашаясь на самые низкие роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вдохновись»</h3>
                        <hr>
                        <p>Учишься в вузе, но хочешь заложить фундамент для карьеры уже сейчас? Пришлю пошаговую стратегию, как осознанно строить свой путь начиная с первого курса</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Первый шаг»</h3>
                        <hr>
                        <p>Хочешь грамотно начать карьеру, не совершая типичных ошибок? Расскажу, как позиционировать себя, чтобы найти работу за 3 недели</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item7">
            <div>
                <div>
                    <h2>Soft skills</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Команда мечты»</h3>
                        <hr>
                        <p>Мечтаешь выстроить правильную коммуникацию в команде и увеличить продуктивность групповой работы? Расскажу о фишках, которые используют руководители</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Управляй руководителем»</h3>
                        <hr>
                        <p>Мечтаешь научиться выстраивать взаимовыгодные отношения с начальником? Покажу, как управлять боссом, чтобы все были довольны</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Презентация»</h3>
                        <hr>
                        <p>Хочешь уверенно и без стресса проводить встречи, переговоры или презентации? Поделюсь полезными лайфхаками, которые помогут всегда быть на высоте</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Биг Босс»</h3>
                        <hr>
                        <p>Все еще считаешь, что лидерство — это врожденный талант? Готов доказать тебе обратное — поделюсь, как развить в себе мышление руководителя</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нетворкинг»</h3>
                        <hr>
                        <p>Думаешь, как выстроить круг деловых контактов и создать вокруг себя поддерживающее окружение? Расскажу о 5 шагах к крепкой сети полезных знакомств</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эмоции»</h3>
                        <hr>
                        <p>Хочешь узнать, как эмоции влияют на карьеру? Расскажу, как прокачать эмоциональный интеллект и достичь успехов с его помощью</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item8">
            <div>
                <div>
                    <h2>За рубежом</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«К знаниям»</h3>
                        <hr>
                        <p>Мечтаешь учиться за границей? Расскажу тебе все об эффективной подготовке к поступлению в зарубежную магистратуру или топовую бизнес-школу</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Лондон»</h3>
                        <hr>
                        <p>Вдохновляешься лондонскими пейзажами и фильмами о Шерлоке Холмсе? Поделюсь, как живется и работается в столице Великобритании</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Германии»</h3>
                        <hr>
                        <p>Присматриваешься к Германии в качестве нового места для жизни и работы? Расскажу обо всех подводных камнях, которые полезно знать перед релокацией</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в США»</h3>
                        <hr>
                        <p>Готовишься покорить Америку? Пришлю эфир о жизни и работе в США — посмотри, прежде чем планировать переезд</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Италии»</h3>
                        <hr>
                        <p>Интересуешься карьерой в Италии? Поделюсь всеми плюсами и минусами, которые важно учитывать при планировании карьерного пути</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Учеба без границ»</h3>
                        <hr>
                        <p>Хочешь узнать, влияет ли зарубежное образование на карьеру и что выбрать — корпорацию или свой бизнес? Пришлю полезный эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item9">
            <div>
                <div>
                    <h2>Кризис</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Лимонад»</h3>
                        <hr>
                        <p>Переживаешь из-за бесконечных экономических кризисов? Расскажу, как выжать максимум возможностей для своей карьеры из любого «черного лебедя»</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Химик»</h3>
                        <hr>
                        <p>Работаешь в узкой сфере и боишься сокращений? Поделюсь, как одна из наших участниц получила оффер в кризис с повышением зарплаты на 25%, будучи химиком</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нефть»</h3>
                        <hr>
                        <p>Хочешь узнать, как не откладывать карьерный план до лучших времен и быстро сменить работу даже в кризис? Пришлю вдохновляющий эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-tablet item10">
            <div>
                <div>
                    <h2>Отдохни</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Посоветуй книгу»</h3>
                        <hr>
                        <p>Никогда не проходишь мимо книжных магазинов? Помогу тебе выбрать увлекательную и полезную книгу о карьере и саморазвитии</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Посоветуй фильм»</h3>
                        <hr>
                        <p>Тоже обожаешь провести вечер за хорошим кино? С радостью поделюсь с тобой лучшими фильмами из тех, которые посмотрел</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Заставка»</h3>
                        <hr>
                        <p>Хочешь мотивирующую заставку на телефон, которая вдохновит тебя делать шаги к цели каждый день? Ни слова больше — я уже готов прислать</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«На стиле»</h3>
                        <hr>
                        <p>Мечтаешь чувствовать себя комфортно и нравиться себе в одежде (в офисе и вне его)? Поделюсь эфиром опытного стилиста на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017186936.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1619017204453.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-filter-for-sliders-mobile', {
        label: 'Фильтр для слайдеров (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-filter-for-sliders-mobile">
        <div class="filter-for-sliders-mobile">
            <div>
                <div>
                    <p onclick="menuShower(this)"><span>Все</span> <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625657487064.png" alt=""></p>
                    <div>
                        <ul>
                            <li data-sort="all">Все</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item1">
            <div>
                <div>
                    <h2>Самое важное</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Привет»</h3>
                        <hr>
                        <p>Мечтаешь узнать, чего именно тебе не хватает для повышения? Протестирую уровень твоих карьерных навыков и подскажу, какие прокачать для взлета карьеры</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вернуться»</h3>
                        <hr>
                        <p>Хочешь вернуться в наше закрытое сообщество и начать путь к новым целям? Впущу тебя в Карьерум.Клуб вне очереди, если раньше у тебя уже была подписка</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Смотреть бесплатно»</h3>
                        <hr>
                        <p>Мечтаешь подглядеть, как проходит обучение в клубе, и принять решение, вступать ли в него? Бесплатно покажу 30-минутные фрагменты наших курсов-бестселлеров</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Жду Старт»</h3>
                        <hr>
                        <p>Хочешь попасть в следующий поток нашего курса для начинающих карьеристов? Запишу тебя в секретный лист ожидания и пришлю весточку, когда начнется новый набор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вейтлист»</h3>
                        <hr>
                        <p>Планируешь плотно заняться своей карьерой в сообществе единомышленников? Мест пока нет, но я внесу тебя в список желающих и оповещу, когда можно будет зайти в клуб</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эфиры»</h3>
                        <hr>
                        <p>Не терпится начать прокачивать новые навыки? Пришлю подборку полезных и вдохновляющих эфиров нашей основательницы и топ-эксперта Ольги Лермонтовой</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item2">
            <div>
                <div>
                    <h2>Призвание и уверенность</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Самооценка»</h3>
                        <hr>
                        <p>Чувствуешь, что пора поработать над профессиональной самооценкой? Пришлю эфир о том, как бороться со своими страхами и перестать быть перфекционистом</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Неуверенность»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Психология неуверенности»</h3>
                        <hr>
                        <p>Планируешь поработать над самооценкой с пользой для карьеры? Пришлю эфир с психологом Анной Бабич о том, как укрепиться в осознании собственной ценности</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Баланс»</h3>
                        <hr>
                        <p>Хочешь избавиться от стресса и оставаться в балансе даже с высоким уровнем ответственности? Поделюсь лайфхаками, которые помогут даже в плотном графике</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Ванда»</h3>
                        <hr>
                        <p>Чувствуешь, что ложные установки мешают твоей успешной и счастливой карьере? Расскажу, как самостоятельно разобраться с ними и развить новые привычки мышления</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item3">
            <div>
                <div>
                    <h2>Работа мечты</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Найди себя»</h3>
                        <hr>
                        <p>Все еще ищешь дело своей жизни? Расскажу, как найти работу, которая будет давать энергию, и использовать в ней все свои таланты</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item4">
            <div>
                <div>
                    <h2>Смена сферы</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Успешный переход»</h3>
                        <hr>
                        <p>Планируешь перейти в новую сферу с повышением? Поделюсь, как сделать это, опираясь на свои приоритеты и ценности, а не только на зарплату</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Карьерный взлет»</h3>
                        <hr>
                        <p>Хочешь найти работу в новой сфере за 2 месяца и с повышением? Это реально! Поделюсь лайфхаками на примере участницы Карьерума</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Волонтерство»</h3>
                        <hr>
                        <p>Привлекает волонтерство, но ты не знаешь, как реализоваться в этой сфере? Расскажу об опыте участницы, которая построила карьеру в некоммерческом секторе</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Консалтинг»</h3>
                        <hr>
                        <p>Мечтаешь о работе в большой тройке или четверке? Пришлю эфир о том, как попасть в самую высокооплачиваемую сферу и влиять на стратегии топовых компаний мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Долина»</h3>
                        <hr>
                        <p>Хочешь построить карьеру в Кремниевой долине? Расскажу, как сменить сферу с химической на программирование и попасть на стажировку в IT-столицу мира</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Путь в IT»</h3>
                        <hr>
                        <p>Думаешь, что после трехлетнего перерыва в работе невозможно реализоваться в новой отрасли? Пришлю эфир о переходе из лингвистики в IT-сферу</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item5">
            <div>
                <div>
                    <h2>Повышение</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Второе дыхание»</h3>
                        <hr>
                        <p>Хочешь найти в себе новые силы для работы, получив повышению? Расскажу, как повысить мотивацию и удовлетворенность, благодаря новой роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Повышение»</h3>
                        <hr>
                        <p>Надоело плыть по течению и ждать инициативы от начальника? Расскажу тебе, как получить повышение в должности и деньгах</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Возможно все»</h3>
                        <hr>
                        <p>Думаешь, что нельзя совместить высокую зарплату и удовольствие от работы? Поделюсь, как получить оффер мечты и повышение зарплаты на 40%</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Рост в компании»</h3>
                        <hr>
                        <p>Хочешь уволиться, но сомневаешься? Расскажу, как поставить значимую для тебя карьерную цель в текущей компании, стать более ценным сотрудником и получить повышение</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item6">
            <div>
                <div>
                    <h2>Студентам и выпускникам</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Молодой специалист»</h3>
                        <hr>
                        <p>Только начинаешь свой карьерный путь? Расскажу о карьерных шагах для молодого специалиста, которые сразу зададут нужный вектор</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Мощный старт»</h3>
                        <hr>
                        <p>Хочешь найти работу, но у тебя мало опыта? Поделюсь, как это сделать, не приукрашивая факты в резюме и не соглашаясь на самые низкие роли</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Вдохновись»</h3>
                        <hr>
                        <p>Учишься в вузе, но хочешь заложить фундамент для карьеры уже сейчас? Пришлю пошаговую стратегию, как осознанно строить свой путь начиная с первого курса</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Первый шаг»</h3>
                        <hr>
                        <p>Хочешь грамотно начать карьеру, не совершая типичных ошибок? Расскажу, как позиционировать себя, чтобы найти работу за 3 недели</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item7">
            <div>
                <div>
                    <h2>Soft skills</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Команда мечты»</h3>
                        <hr>
                        <p>Мечтаешь выстроить правильную коммуникацию в команде и увеличить продуктивность групповой работы? Расскажу о фишках, которые используют руководители</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Управляй руководителем»</h3>
                        <hr>
                        <p>Мечтаешь научиться выстраивать взаимовыгодные отношения с начальником? Покажу, как управлять боссом, чтобы все были довольны</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Презентация»</h3>
                        <hr>
                        <p>Хочешь уверенно и без стресса проводить встречи, переговоры или презентации? Поделюсь полезными лайфхаками, которые помогут всегда быть на высоте</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Биг Босс»</h3>
                        <hr>
                        <p>Все еще считаешь, что лидерство — это врожденный талант? Готов доказать тебе обратное — поделюсь, как развить в себе мышление руководителя</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нетворкинг»</h3>
                        <hr>
                        <p>Думаешь, как выстроить круг деловых контактов и создать вокруг себя поддерживающее окружение? Расскажу о 5 шагах к крепкой сети полезных знакомств</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Эмоции»</h3>
                        <hr>
                        <p>Хочешь узнать, как эмоции влияют на карьеру? Расскажу, как прокачать эмоциональный интеллект и достичь успехов с его помощью</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item8">
            <div>
                <div>
                    <h2>За рубежом</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«К знаниям»</h3>
                        <hr>
                        <p>Мечтаешь учиться за границей? Расскажу тебе все об эффективной подготовке к поступлению в зарубежную магистратуру или топовую бизнес-школу</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Лондон»</h3>
                        <hr>
                        <p>Вдохновляешься лондонскими пейзажами и фильмами о Шерлоке Холмсе? Поделюсь, как живется и работается в столице Великобритании</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Германии»</h3>
                        <hr>
                        <p>Присматриваешься к Германии в качестве нового места для жизни и работы? Расскажу обо всех подводных камнях, которые полезно знать перед релокацией</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в США»</h3>
                        <hr>
                        <p>Готовишься покорить Америку? Пришлю эфир о жизни и работе в США — посмотри, прежде чем планировать переезд</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Работа в Италии»</h3>
                        <hr>
                        <p>Интересуешься карьерой в Италии? Поделюсь всеми плюсами и минусами, которые важно учитывать при планировании карьерного пути</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Учеба без границ»</h3>
                        <hr>
                        <p>Хочешь узнать, влияет ли зарубежное образование на карьеру и что выбрать — корпорацию или свой бизнес? Пришлю полезный эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item9">
            <div>
                <div>
                    <h2>Кризис</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Лимонад»</h3>
                        <hr>
                        <p>Переживаешь из-за бесконечных экономических кризисов? Расскажу, как выжать максимум возможностей для своей карьеры из любого «черного лебедя»</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Химик»</h3>
                        <hr>
                        <p>Работаешь в узкой сфере и боишься сокращений? Поделюсь, как одна из наших участниц получила оффер в кризис с повышением зарплаты на 25%, будучи химиком</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Нефть»</h3>
                        <hr>
                        <p>Хочешь узнать, как не откладывать карьерный план до лучших времен и быстро сменить работу даже в кризис? Пришлю вдохновляющий эфир на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
        <div class="filter-item-mobile item10">
            <div>
                <div>
                    <h2>Отдохни</h2>
                </div>
                <div class="slider-filter slider-block">
                    <div class="filter-slide">
                        <h3>«Посоветуй книгу»</h3>
                        <hr>
                        <p>Никогда не проходишь мимо книжных магазинов? Помогу тебе выбрать увлекательную и полезную книгу о карьере и саморазвитии</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Посоветуй фильм»</h3>
                        <hr>
                        <p>Тоже обожаешь провести вечер за хорошим кино? С радостью поделюсь с тобой лучшими фильмами из тех, которые посмотрел</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«Заставка»</h3>
                        <hr>
                        <p>Хочешь мотивирующую заставку на телефон, которая вдохновит тебя делать шаги к цели каждый день? Ни слова больше — я уже готов прислать</p>
                    </div>
                    <div class="filter-slide">
                        <h3>«На стиле»</h3>
                        <hr>
                        <p>Мечтаешь чувствовать себя комфортно и нравиться себе в одежде (в офисе и вне его)? Поделюсь эфиром опытного стилиста на эту тему</p>
                    </div>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625667986815.png" alt="" class="prewarr">
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625668002650.png" alt="" class="nextarr">
                </div>
            </div>
        </div>
    </div>`
    });
    
    
    blockManager.add('carrerum-choose-social-btns2', {
        label: 'Выбор удобной соц сети внизу',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns2">
        <div>
            <p>Выбирай, чем хочешь заняться прямо сейчас, и пиши мне — <br>с радостью с тобой поболтаю</p>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841273313.png" alt="">
                    <p>Написать в Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841295461.png" alt="">
                    <p>Написать в Vkontakte</p>
                </a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-choose-social-btns2-tablet', {
        label: 'Выбор удобной соц сети внизу (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns2-tablet">
        <div>
            <p>Выбирай, чем хочешь заняться прямо сейчас, и пиши мне — <br>с радостью с тобой поболтаю</p>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841311458.png" alt="">
                    <p>Написать в Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841322795.png" alt="">
                    <p>Написать в Vkontakte</p>
                </a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-choose-social-btns2-mobile', {
        label: 'Выбор удобной соц сети внизу (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-choose-social-btns2-mobile">
        <div>
            <p>Выбирай, чем хочешь заняться прямо сейчас, и пиши мне — <br>с радостью с тобой поболтаю</p>
            <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841335357.png" alt="">
                    <p>Написать в Telegram</p>
                </a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625841348041.png" alt="">
                    <p>Написать в Vkontakte</p>
                </a>
            </div>
        </div>
    </div>`
    });



    blockManager.add('carrerum-question-with-social', {
        label: 'Остались вопросы?',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-question-with-social">
        <div>
            <h2>Остались вопросы? Напишите нам</h2>
            <div>
                <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243810031.png" alt=""></a>
                <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243801461.png" alt=""></a>
                <a target="_blank" href="https://m.me/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-question-with-social-tablet', {
        label: 'Остались вопросы? (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-question-with-social-tablet">
        <div>
            <h2>Остались вопросы? Напишите нам</h2>
            <div>
                <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243810031.png" alt=""></a>
                <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243801461.png" alt=""></a>
                <a target="_blank" href="https://m.me/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
            </div>
        </div>
    </div>`
    });

    blockManager.add('carrerum-question-with-social-mobile', {
        label: 'Остались вопросы? (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-question-with-social-mobile">
        <div>
            <h2>Остались вопросы? Напишите нам</h2>
            <div>
                <a target="_blank" href="mailto:hello@careerum.ru"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243810031.png" alt=""></a>
                <a target="_blank" href="https://api.whatsapp.com/send?phone=+79958807862"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1625300953302.png" alt=""></a>
                <a target="_blank" href="https://school.careerum.ru/tlgrm"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626243801461.png" alt=""></a>
                <a target="_blank" href="https://m.me/careerum"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1626197770666.png" alt=""></a>
            </div>
        </div>
    </div>`
    });


    blockManager.add('block-careerum-redirect-timer', {
		label: 'Блок таймера с редиректом',
		category: category, 
		attributes: {class:''},
		content: `
<div class="block-careerum-redirect-timer">
	<div>
		<div class="careerum-redirect-timer">
			<div>
				<div class="timer__items">
					<div class="timer__item timer__days" data-title="дней">
						00
					</div>
					<div class="timer__item timer__hours" data-title="часов">
						00
					</div>
					<div class="timer__item timer__minutes" data-title="минут">
						00
					</div>
					<div class="timer__item timer__seconds" data-title="секунд">
						00
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
	`});

	blockManager.add(`block-careerum-redirect-timer-tablet`, {
		label: 'Блок таймера с редиректом (tablet)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="block-careerum-redirect-timer-tablet">
	<div>
		<div class="careerum-redirect-timer">
			<div>
				<div class="timer__items">
					<div class="timer__item timer__days" data-title="дней">
						00
					</div>
					<div class="timer__item timer__hours" data-title="часов">
						00
					</div>
					<div class="timer__item timer__minutes" data-title="минут">
						00
					</div>
					<div class="timer__item timer__seconds" data-title="секунд">
						00
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
	`});

	blockManager.add(`block-careerum-redirect-timer-mobile`, {
		label: 'Блок таймера с редиректом (mobile)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="block-careerum-redirect-timer-mobile">
	<div>
		<div class="careerum-redirect-timer">
			<div>
				<div class="timer__items">
					<div class="timer__item timer__days" data-title="дней">
						00
					</div>
					<div class="timer__item timer__hours" data-title="часов">
						00
					</div>
					<div class="timer__item timer__minutes" data-title="минут">
						00
					</div>
					<div class="timer__item timer__seconds" data-title="секунд">
						00
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
	`});



    blockManager.add('carrerum-contact-with-button', {
		label: 'Контактный email с кнопкой',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-contact-with-button">
    <div>
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634460030843.svg" alt="">
            </div>
            <div>
                <ul>
                    <li>Что-то не работает?</li>
                    <li>Есть вопросы по клубу?</li>
                </ul>
            </div>
            <div>
                <ul>
                    <li>Нужна запись на коучинг?</li>
                    <li>Хотите сотрудничать с Ольгой?</li>
                </ul>
            </div>
        </div>
        <a href="mailto:hello@careerum.ru">Пишите на&nbsp;hello@careerum.ru</a>
        <div>
            <p>Адрес для СМИ:</p><a href="mailto:juliana@careerum.ru">juliana@careerum.ru</a>
        </div>                
    </div>
</div>
	`});

	blockManager.add(`carrerum-contact-with-button-tablet`, {
		label: 'Контактный email с кнопкой (tablet)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-contact-with-button-tablet">
    <div>
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634460030843.svg" alt="">
            </div>
            <div>
                <ul>
                    <li>Есть вопросы по клубу?</li>
                    <li>Что-то не работает?</li>
                    <li>Нужна запись на коучинг?</li>
                    <li>Хотите сотрудничать с Ольгой?</li>
                </ul>
            </div>
        </div>
        <a href="mailto:hello@careerum.ru">Пишите на&nbsp;hello@careerum.ru</a>
        <div>
            <p>Адрес для СМИ:</p><a href="mailto:juliana@careerum.ru">juliana@careerum.ru</a>
        </div>                
    </div>
</div>
	`});

	blockManager.add(`carrerum-contact-with-button-mobile`, {
		label: 'Контактный email с кнопкой (mobile)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-contact-with-button-mobile">
    <div>
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634460030843.svg" alt="">
            </div>
            <div>
                <ul>
                    <li>Есть вопросы по клубу?</li>
                    <li>Что-то не работает?</li>
                    <li>Нужна запись на коучинг?</li>
                    <li>Хотите сотрудничать с Ольгой?</li>
                </ul>
            </div>
        </div>
        <a href="mailto:hello@careerum.ru">Пишите на&nbsp;hello@careerum.ru</a>
        <div>
            <p>Адрес для СМИ:</p><a href="mailto:juliana@careerum.ru">juliana@careerum.ru</a>
        </div>                
    </div>
</div>
	`});



    
    blockManager.add('careerum-tiles-filter', {
		label: 'Фильтр программ Клуба',
		category: category, 
		attributes: {class:''},
		content: `
        <div class="careerum-tiles-filter">
        <div><div><h2>300+ часов курсов и вебинаров о карьере — вот некоторые из них</h2></div><div></div><div><div data-waytarget="Все программы" class="tyles-popular-items"><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Звездный кандидат</h3><p>
                                Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>12 часов 25 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>40 уроков</p></div></div><a href="#program-1">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
                                Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>10 часов 51 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>24 урока</p></div></div><a href="#program-2">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера</h3><p>
                                Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>10 часов 27 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>23 урока</p></div></div><a href="#program-3">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Самооценка 2.0</h3><p>
                                Прокачаете уверенность в себе и избавитесь от синдрома самозванца, чтобы покорять новые карьерные вершины
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>5 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>16 уроков</p></div></div><a href="#program-4">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
                                Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса</h3><p>
                                Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием
                            </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>15 часов 31 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>27 уроков</p></div></div><a href="#program-6">Что входит в программу</a></div></div><div data-waytarget="Молодым специалистам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div></div><div><h4></h4><h4></h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера<br><br></h3><p>
                                Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>10 часов 27 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>23 урока</p></div></div><a href="#program-3">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Карьерный план: создать и воплотить<br><br></h3><p>
                                    Составите собственный&nbsp; карьерный план и начнете с его помощью осознанно и с удовольствием достигать своих профессиональных целей.
                                </p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Mentor Me: как найти ментора и выстроить с ним работу</h3><p>
                                    Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
                                </p></div></div></div><div data-waytarget="Определиться с профессией" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Таланты и ценности</h3><p>
                                        Научитесь опираться в карьере на то, что вы любите и умеете — и выбрать путь, в котором это будет хорошо оплачиваться.
                                    </p></div><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Карьерное планирование и управление рисками</h3><p>
                                        Составите карьерный план, научитесь минимизировать риски и освоите навык «быть автором своей жизни».
                                    </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Самоопределение: профессионал в точке выбора</h3><p>
                                    Проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.
                                </p></div></div></div><div data-waytarget="Найти работу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Звездный кандидат</h3><p>
                                Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>12 часов 25 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>40 уроков</p></div></div><a href="#program-1">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Продающее резюме</h3><p>
                                        На этом курсе вы научитесь анализировать рынок и свой опыт, искать достижения, грамотно описывать свое образование, кастомизировать и оформлять резюме.
                                    </p><a href="https://careerum.ru/class/resume/" target="_blank">Узнать больше</a></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Эффективное интервью</h3><p>
                                        Выясните, как нужно вести себя на различных формах собеседования, разберете алгоритм подготовки и ответы на самые популярные вопросы.
                                    </p><a href="https://careerum.ru/class/interview/" target="_blank">Узнать больше</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Как попасть в Google — секреты и подводные камни</h3><p>
                                    Узнаете, как устроиться на работу в Google и какие сложности могут встретиться на вашем пути.
                                </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                                        Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
                                    <br><br></p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Получить повышение" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
                                Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>10 часов 51 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>24 урока</p></div></div><a href="#program-2">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.<br><br></p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Пробей зарплатный потолок</h3><p>
                                        Большинство людей плывут в рабочей рутине, не программируя свой успех. Этот курс — ваш шанс взять свое карьерное будущее в руки и начать им управлять осознанно с помощью работающих методов.
                                    </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>You are the one: personal branding at work</h3><p>
                                    You will learn how to discover your personal brand and articulate a unique value proposition, create your personal brand through brand story, elevator pitch and visual identity.
                                </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                                        Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
                                    <br><br></p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Сменить сферу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Новые горизонты<br><br></h3><p>Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции по выбору новой сферы.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>21 час 16 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>51 урок</p></div></div><a href="#program-9">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>РУБРИКА</h5><h3>Профориентация</h3><p>
                                        Чтобы сменить профессию или отрасль, необязательно начинать с нуля — достаточно пройти эту программу.</p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Самоопределение: профессионал в точке выбора</h3><p>
                                        Вы проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.</p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Real me: Как найти себя в работе и в жизни</h3><p>
                                        Курс поможет вам докопаться до своих ценностей, открыть в себе таланты и понять, какая работа даст вам полностью раскрыться и чувствовать себя на своем месте.
                                    <br><br></p><a href="https://careerum.ru/class/realme" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Work-life balance" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса<br><br></h3><p>
                                Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>15 часов 31 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>27 уроков</p></div></div><a href="#program-6">Что входит в программу</a></div></div><div><h4></h4><h4></h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
                                Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ПРАКТИКУМ</h5><h3>Нелинейная продуктивность<br><br></h3><p>
                                    Научитесь приходить к профессиональным результатам, не заставляя себя работать через усталость и не выгорая, а используя специальные техники.
                                </p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Work&amp;Live: баланс между работой и личной жизнью</h3><p>
                                    Вы разберете причины отсутствия баланса между работой и жизнью, научитесь с ними работать и отстаивать свое право на work-life balance с коллегами и боссом.</p></div></div></div><div data-waytarget="Выйти из декрета" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Выход из декрета</h3><p>
                                Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом.<br><br></p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>14 часов 40 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>36 уроков</p></div></div><a href="#program-7">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Как успешно выйти на работу из декрета</h3><p>
                                    Вы разберете основные сложности и страхи, с которыми можете столкнуться при выходе из декрета, и узнаете, как их преодолеть. Изучите проверенные лайфхаки, которые помогут комфортно и эффективно вернуться к работе.
                                </p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Как совмещать карьеру и материнство</h3><p>
                                    Многие думают, что успевать рулить карьерой и воспитывать детей — непосильная задача. Давайте развеем мифы!
                                </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>Первые месяцы на новой работе – трамплин к успеху или испорченной репутации</h3><p>
                                        Курс будет полезен всем, кто хочет с первых дней взять успешный старт в новой компании. Если вы уже вышли на новое место или вот-вот собираетесь, — этот курс ваш пошаговый путеводитель к очередной карьерной вершине.</p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Money Talk: финансовое планирование в карьере<br><br></h3><p>
                                    Вы научитесь грамотно управлять своими финансами, планировать декрет и смену работы, формировать «подушку безопасности», верно рассчитывать доходы и расходы при переезде за границу.
                                </p></div></div></div><div data-waytarget="Предпринимателям и фрилансерам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395126135.png" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
                                Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395178274.png" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395219831.png" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.<br><br></p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Личная эффективность</h3><p>
                                    Вы узнаете, как перестать ощущать себя «белкой в колесе» и с помощью практических упражнений научитесь сохранять баланс и полноту жизни.
                                </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>Vision: предпринимательское мышление</h3><p>
                                        Вы узнаете, в чем заключается предпринимательское мышление и как его развить. Научитесь выбирать драйвовые идеи и грамотно воплощать их в жизнь, примените эти знания на практике с помощью коучинговых фреймворков — выберете идею и сделаете первый шаг к ней.</p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Mentor Me: как найти ментора и выстроить с ним работу</h3><p>
                                    Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
                                </p></div></div></div></div><div><a href="https://careerum.ru/materials-test/" target="_blank">Посмотреть все 80+ материалов</a><a href="https://careerum.ru/club/#buy" target="_top">Вступить в клуб</a></div></div></div>
	`});

    blockManager.add('careerum-tiles-filter-tablet', {
		label: 'Фильтр программ Клуба (tablet)',
		category: category, 
		attributes: {class:''},
		content: `
        <div class="careerum-tiles-filter-tablet"><div><div><h2>300+ часов курсов и вебинаров о карьере — вот некоторые из них</h2></div><div><div><p>Популярные программы</p><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395353943.svg" alt=""></div>
        <div></div></div><div><div data-waytarget="Все программы" class="tyles-popular-items"><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Звёздный кандидат</h3><p>
                                            Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис
                                        </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>12 часов 25 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>40 уроков</p></div></div><a href="#program-1">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
                                            Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе
                                        </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 51 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>24 урока</p></div></div><a href="#program-2">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера</h3><p>
                                            Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке
                                        </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 27 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>23 урока</p></div></div><a href="#program-3">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Самооценка 2.0</h3><p>
                                            Прокачаете уверенность в себе и избавитесь от синдрома самозванца, чтобы покорять новые карьерные вершины
                                        </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>5 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>16 уроков</p></div></div><a href="#program-4">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                            Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату
                                        </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой<br><br></h3><p>
                                            Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее
                                        <br><br></p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса</h3><p>Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>15 часов 31 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>27 уроков</p></div></div><a href="#program-6">Что входит в программу</a></div></div><div data-waytarget="Молодым специалистам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                            Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div></div><div><h4></h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера<br><br></h3><p>
                                            Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 27 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>23 урока</p></div></div><a href="#program-3">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Карьерный план: создать и воплотить</h3><p>
                                                Составите собственный&nbsp; карьерный план и начнете с его помощью осознанно и с удовольствием достигать своих профессиональных целей.
                                            </p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Mentor Me: как найти ментора и выстроить с ним работу</h3><p>
                                                Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
                                            </p></div></div></div><div data-waytarget="Определиться с профессией" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                                            Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Таланты и ценности<br></h3><p>
                                                Научитесь опираться в карьере на то, что вы любите и умеете — и выбрать путь, в котором это будет хорошо оплачиваться.
                                            <br><br></p></div><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Карьерное планирование и управление рисками</h3><p>
                                                Составите карьерный план, научитесь минимизировать риски и освоите навык «быть автором своей жизни».
                                            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Самоопределение: профессионал в точке выбора</h3><p>
                                                Проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.
                                            </p></div></div></div><div data-waytarget="Найти работу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Звёздный кандидат</h3><p>
                                            Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>12 часов 25 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>40 уроков</p></div></div><a href="#program-1">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Продающее резюме</h3><p>
                                                    На этом курсе вы научитесь анализировать рынок и свой опыт, искать достижения, грамотно описывать свое образование, кастомизировать и оформлять резюме.
                                                </p><a href="https://careerum.ru/class/resume/" target="_blank">Узнать больше</a></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Эффективное интервью</h3><p>
                                                    Выясните, как нужно вести себя на различных формах собеседования, разберете алгоритм подготовки и ответы на самые популярные вопросы.
                                                </p><a href="https://careerum.ru/class/interview/" target="_blank">Узнать больше</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Как попасть в Google — секреты и подводные камни</h3><p>
                                                Узнаете, как устроиться на работу в Google и какие сложности могут встретиться на вашем пути.
                                            </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                                                    Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
                                                </p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Получить повышение" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
                                            Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 51 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>24 урока</p></div></div><a href="#program-2">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>
                                                    Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.
                                                </p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Пробей зарплатный потолок</h3><p>
                                                Большинство людей плывут в рабочей рутине, не программируя свой успех. Этот курс — ваш шанс взять свое карьерное будущее в руки и начать им управлять осознанно с помощью работающих методов.
                                            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>You are the one: personal branding at work</h3><p>
                                                You will learn how to discover your personal brand and articulate a unique value proposition, create your personal brand through brand story, elevator pitch and visual identity.
                                            </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                                                    Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
                                                </p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Сменить сферу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Новые горизонты<div><br></div></h3><p>Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции по выбору новой сферы.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>21 час 16 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>51 урок</p></div></div><a href="#program-9">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>РУБРИКА</h5><h3>Профориентация</h3><p>
                                                Участники клуба и приглашенные спикеры рассказывают о популярных профессиях, индустриях и инструментах.
                                            </p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Самоопределение: профессионал в точке выбора</h3><p>
                                                Вы проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.
                                            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Real me: Как найти себя в работе и в жизни</h3><p>
                                                    Курс поможет вам докопаться до своих ценностей, открыть в себе таланты и понять, какая работа даст вам полностью раскрыться и чувствовать себя на своем месте.
                                                </p><a href="https://careerum.ru/class/realme" target="_blank">Узнать больше</a></div></div></div><div data-waytarget="Work-life balance" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса</h3><p>Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>15 часов 31 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>27 уроков</p></div></div><a href="#program-6">Что входит в программу</a></div></div><div><h4></h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой<br><br></h3><p>
                                            Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.<br><br></p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ПРАКТИКУМ</h5><h3>Нелинейная продуктивность<br><br></h3><p>
                                                Научитесь приходить к профессиональным результатам, не заставляя себя работать через усталость и не выгорая, а используя специальные техники.
                                            </p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Work&amp;Live: баланс между работой и личной жизнью</h3><p>Вы разберете причины отсутствия баланса между работой и жизнью, научитесь с ними работать и отстаивать свое право на work-life balance с коллегами и боссом.</p></div></div></div><div data-waytarget="Выйти из декрета" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Выход из декрета</h3><p>Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом.<br><br></p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>14 часов 40 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>36 уроков</p></div></div><a href="#program-7">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>КУРС</h5><h3>Как успешно выйти на работу из декрета</h3><p>Вы разберете основные сложности и страхи, с которыми можете столкнуться при выходе из декрета, и узнаете, как их преодолеть. Изучите проверенные лайфхаки, которые помогут комфортно и эффективно вернуться к работе.</p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Как совмещать карьеру и материнство</h3><p>Многие думают, что успевать рулить карьерой и воспитывать детей — непосильная задача. Давайте развеем мифы!</p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>Первые месяцы на новой работе</h3><p>Курс будет полезен всем, кто хочет с первых дней взять успешный старт в новой компании. Если вы уже вышли на новое место или вот-вот собираетесь, — этот курс ваш пошаговый путеводитель к очередной карьерной вершине.</p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Money Talk: финансовое планирование в карьере</h3><p>
                                                Вы научитесь грамотно управлять своими финансами, планировать декрет и смену работы, формировать «подушку безопасности», верно рассчитывать доходы и расходы при переезде за границу.
                                            </p></div></div></div><div data-waytarget="Предпринимателям и фрилансерам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой<br><br></h3><p>
                                            Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.<br><br></p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>
                                                    Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.
                                                </p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Личная эффективность</h3><p>
                                                Вы узнаете, как перестать ощущать себя «белкой в колесе» и с помощью практических упражнений научитесь сохранять баланс и полноту жизни.
                                            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-course"><h5>КУРС</h5><h3>Vision: предпринимательское мышление</h3><p>Вы узнаете, в чем заключается предпринимательское мышление и как его развить. Научитесь выбирать драйвовые идеи и грамотно воплощать их в жизнь, примените эти знания на практике с помощью коучинговых фреймворков — выберете идею и сделаете первый шаг к ней.</p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>Mentor Me: как найти ментора и выстроить с ним работу</h3><p>
                                                Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
                                            </p></div></div></div></div><div><a href="https://careerum.ru/materials-test/" target="_blank">Посмотреть все 80+ материалов</a><a href="https://careerum.ru/club/#buy" target="_blank">Вступить в клуб</a></div></div></div>
	`});

    blockManager.add('careerum-tiles-filter-mobile', {
		label: 'Фильтр программ Клуба (mobile)',
		category: category, 
		attributes: {class:''},
		content: `
        <div class="careerum-tiles-filter-mobile"><div><div><h2>300+ часов курсов и вебинаров о карьере — вот некоторые из них</h2></div><div><div><p>Популярные программы</p><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395353943.svg" alt=""></div><div><div></div></div></div><div><div data-waytarget="Все программы" class="tyles-popular-items"><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Звёздный кандидат</h3><p>
        Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис
    </p><div></div><a href="#program-1">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
        Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе
    </p><div></div><a href="#program-2">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера</h3><p>
        Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке
    </p><div></div><a href="#program-3">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Самооценка 2.0</h3><p>
        Прокачаете уверенность в себе и избавитесь от синдрома самозванца, чтобы покорять новые карьерные вершины
    </p><div></div><a href="#program-4">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
        Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату
    </p><div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
        Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее
    </p><div></div><a href="#program-5">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса</h3><p>
        Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием
    </p><div></div><a href="#program-6">Что входит в программу</a></div></div><div data-waytarget="Молодым специалистам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Жизнь после оффера</h3><p>
                Научитесь быстро вливаться в рабочий процесс на новом месте и показывать крутые результаты уже на испытательном сроке.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 27 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>23 урока</p></div></div><a href="#program-3">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Карьерный план: создать и воплотить
        </h3><p>
            Составите собственный&nbsp; карьерный план и начнете с его помощью осознанно и с удовольствием достигать своих профессиональных целей.
        </p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Mentor Me: как найти ментора и выстроить с ним работу
        </h3><p>
            Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
        </p></div><div class="tyles-wrapper-block"></div></div><div data-waytarget="Определиться с профессией" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Real Me: как найти себя в работе и жизни</h3><p>
                Узнаете, на какой работе сможете полностью реализоваться, где ее искать и как совместить интересы, навыки и достойную зарплату.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>11 часов 50 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>33 урока</p></div></div><a href="https://careerum.ru/class/realme/" target="_blank">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Таланты и ценности</h3><p>
                Научитесь опираться в карьере на то, что вы любите и умеете — и выбрать путь, в котором это будет хорошо оплачиваться.
            </p></div><div class="tyles-item-course"><h5>СЕССИЯ</h5><h3>Карьерное планирование и управление рисками</h3><p>
                Составите карьерный план, научитесь минимизировать риски и освоите навык «быть автором своей жизни».
            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Самоопределение: профессионал в точке выбора
        </h3><p>
            Проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.
        </p></div></div></div><div data-waytarget="Найти работу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Звёздный кандидат</h3><p>
                Узнаете, как построить стратегию поиска работы, пройти все этапы и получить тот самый оффер — даже в кризис.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>12 часов 25 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>40 уроков</p></div></div><a href="#program-1">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Продающее резюме</h3><p>
                На этом курсе вы научитесь анализировать рынок и свой опыт, искать достижения, грамотно описывать свое образование, кастомизировать и оформлять резюме.
            </p><a href="https://careerum.ru/class/resume/" target="_blank">Узнать больше</a></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Эффективное интервью</h3><p>
                Выясните, как нужно вести себя на различных формах собеседования, разберете алгоритм подготовки и ответы на самые популярные вопросы.
            </p><a href="https://careerum.ru/class/interview/" target="_blank">Узнать больше</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Как попасть в Google — секреты и подводные камни
        </h3><p>
            Узнаете, как устроиться на работу в Google и какие сложности могут встретиться на вашем пути.
        </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
            </p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div><div class="tyles-wrapper-block"></div></div><div data-waytarget="Получить повышение" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьерная ракета</h3><p>
                Поставите цели, узнаете, как их достичь и получить повышение в должности или зарплате на текущей работе.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>10 часов 51 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>24 урока</p></div></div><a href="#program-2">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>
                Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.
            </p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Пробей зарплатный потолок</h3><p>
                Большинство людей плывут в рабочей рутине, не программируя свой успех. Этот курс — ваш шанс взять свое карьерное будущее в руки и начать им управлять осознанно с помощью работающих методов.
            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-course"><h5>КУРС</h5><h3>You are the one: personal branding at work</h3><p>
                You will learn how to discover your personal brand and articulate a unique value proposition, create your personal brand through brand story, elevator pitch and visual identity.
            </p></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Сколько я стою</h3><p>
                Вы научитесь адекватно оценивать свою работу и без стыда называть стоимость, бороться с перфекционизмом и получать удовольствие от своей деятельности, сформулируете свою ценность как специалиста и освоите навыки самопрезентации.
            </p><a href="https://careerum.ru/class/skolko-ya-stoyu/" target="_blank">Узнать больше</a></div><div class="tyles-wrapper-block"></div></div><div data-waytarget="Сменить сферу" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines-reverse"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Новые горизонты</h3><p>
        Убедитесь, что сменить профессию и отрасль — реально, и получите пошаговые инструкции по выбору новой сферы
    </p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>21 час 16 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>51 урок</p></div></div><a href="#program-9">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>РУБРИКА</h5><h3>Профриентация</h3><p>
                Участники клуба и приглашенные спикеры рассказывают о популярных профессиях, индустриях и инструментах.
            </p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Самоопределение: профессионал в точке выбора</h3><p>
                Вы проанализируете собственные карьерные мечты и желания, определите свое дальнейшее профессиональное развитие и начнете двигаться к цели.
            </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Real me: Как найти себя в работе и в жизни</h3><p>
                Курс поможет вам докопаться до своих ценностей, открыть в себе таланты и понять, какая работа даст вам полностью раскрыться и чувствовать себя на своем месте.
            </p><a href="https://careerum.ru/class/realme/" target="_blank">Узнать больше</a></div><div class="tyles-wrapper-block"></div></div><div data-waytarget="Work-life balance" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines-reverse"><div><h4>ПРОГРАММЫ:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Карьера без стресса</h3><p>
                Научитесь справляться со напряжением, контролировать эмоции, чтобы работать с удовольствием</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>15 часов 31 минута</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>27 уроков</p></div></div><a href="#program-6">Что входит в программу</a></div><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
                Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-vebinar"><h5>ПРАКТИКУМ</h5><h3>
            Нелинейная продуктивность
        </h3><p>
            Научитесь приходить к профессиональным результатам, не заставляя себя работать через усталость и не выгорая, а используя специальные техники.
        </p></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Work&amp;Live: баланс между работой и личной жизнью</h3><p>
                Вы разберете причины отсутствия баланса между работой и жизнью, научитесь с ними работать и отстаивать свое право на work-life balance с коллегами и боссом.
            </p></div><div class="tyles-wrapper-block"></div></div><div data-waytarget="Выйти из декрета" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines-reverse"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Выход из декрета</h3><p>
                Узнаете, что сделать до, после и во время декрета, чтобы остаться востребованным специалистом.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>14 часов 40 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>36 уроков</p></div></div><a href="#program-7">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course"><h5>КУРС</h5><h3>Как успешно выйти на работу из декрета</h3><p>
                Вы разберете основные сложности и страхи, с которыми можете столкнуться при выходе из декрета, и узнаете, как их преодолеть. Изучите проверенные лайфхаки, которые помогут комфортно и эффективно вернуться к работе.
            </p></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Как совмещать карьеру и материнство</h3><p>
            Многие думают, что успевать рулить карьерой и воспитывать детей — непосильная задача. Давайте развеем мифы!
        </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Первые месяцы на новой работе – трамплин к успеху или испорченной репутации</h3><p>
                Курс будет полезен всем, кто хочет с первых дней взять успешный старт в новой компании. Если вы уже вышли на новое место или вот-вот собираетесь, — этот курс ваш пошаговый путеводитель к очередной карьерной вершине.
            </p></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Money Talk: финансовое планирование в карьере</h3><p>
            Вы научитесь грамотно управлять своими финансами, планировать декрет и смену работы, формировать «подушку безопасности», верно рассчитывать доходы и расходы при переезде за границу.
        </p></div></div></div><div data-waytarget="Предпринимателям и фрилансерам" class="tyles-tyle-items"><div class="tyles-wrapper-2col-2lines-reverse"><div><h4>ПРОГРАММА:</h4><div class="tyles-item-programm-big"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395375414.svg" alt=""><h5>ПРОГРАММА</h5><h3>Работать не 24/7, а головой</h3><p>
                Прокачаете навыки постановки целей, продуктивности и самомотивации, чтобы двигаться к цели еще быстрее.</p><div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395398347.svg" alt=""><p>8 часов 55 минут</p></div><div><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1634395416777.svg" alt=""><p>13 уроков</p></div></div><a href="#program-5">Что входит в программу</a></div></div><div><h4>ПОПУЛЯРНЫЕ МАТЕРИАЛЫ ИЗ ПРОГРАММЫ:</h4><div class="tyles-item-course-with-button"><h5>КУРС</h5><h3>Цели как в Google. Результаты как в Forbes</h3><p>
                Получите рабочие инструменты, с помощью которых сможете создать надежный фундамент для построения своей карьеры.
            </p><a href="https://careerum.ru/class/goals/" target="_blank">Узнать больше</a></div><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Личная эффективность</h3><p>
            Вы узнаете, как перестать ощущать себя «белкой в колесе» и с помощью практических упражнений научитесь сохранять баланс и полноту жизни.
        </p></div></div></div><div class="tyles-1header"><h4>ЕЩЕ МАТЕРИАЛЫ ПО ТЕМЕ В КЛУБЕ:</h4></div><div class="tyles-item-course"><h5>КУРС</h5><h3>Vision: предпринимательское мышление</h3><p>
                Вы узнаете, в чем заключается предпринимательское мышление и как его развить. Научитесь выбирать драйвовые идеи и грамотно воплощать их в жизнь, примените эти знания на практике с помощью коучинговых фреймворков — выберете идею и сделаете первый шаг к ней.
            </p></div><div class="tyles-wrapper-block"><div class="tyles-item-vebinar"><h5>ВЕБИНАР</h5><h3>
            Mentor Me: как найти ментора и выстроить с ним работу</h3><p>
            Вы узнаете, как и где найти ментора, чем вы сами можете быть ему полезны и как сделать вашу совместную работу максимально продуктивной.
        </p></div></div></div></div></div></div>
	`});



    
    blockManager.add('carrerum-tarifs-with-selector-10900', {
		label: 'Тарифы с селектором (10900)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="carrerum-tarifs-with-selector-10900">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <p>
                        Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="unactive">
                        Поддержка коуча
                    </p>
                    <p class="unactive">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">7 900 ₽</p>
                        <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                        <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                    </div>
                    
                </div>
                <div class="best-choise">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <p>
                        Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="tarif-selector-header">Расчет тарифа на:</p>
                        <ul>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="1month-10900" data-amount="10 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                                <label for="1month-10900">1 месяц</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="3month-10900" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 966 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                                <label for="3month-10900">3 месяца</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="6month-10900" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                                <label for="6month-10900">6 месяцев</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="12month-10900" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                                <label for="12month-10900">12 месяцев</label>
                            </li>
                        </ul>
                        <p class="old-amount"> </p>
                        <p class="amount">10 900 ₽</p>
                        <p class="month-amount"></p>
                        <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                        <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Полное сопровождение
                    </h3>
                    <p>
                        Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="active">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">18 900 ₽</p>
                        <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                        <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-tablet-10900`, {
		label: 'Тарифы с селектором (tablet) (10900)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-tablet-10900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный <br>  &nbsp;
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">7 900 ₽</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой <br>  &nbsp;
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                        <li>
                            <input type="radio" name="tarif-selector-10900-tablet" id="1month-10900-tablet" data-amount="10 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                            <label for="1month-10900-tablet">1 месяц</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-tablet" id="3month-10900-tablet" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 966 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                            <label for="3month-10900-tablet">3 месяца</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-tablet" id="6month-10900-tablet" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                            <label for="6month-10900-tablet">6 месяцев</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-tablet" id="12month-10900-tablet" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                            <label for="12month-10900-tablet">12 месяцев</label>
                        </li>
                    </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">10 900 ₽</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">18 900 ₽</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-mobile-10900`, {
		label: 'Тарифы с селектором (mobile) (10900)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-mobile-10900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">7 900 ₽</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                        <li>
                            <input type="radio" name="tarif-selector-10900-mobile" id="1month-10900-mobile" data-amount="10 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked="checked">
                            <label for="1month-10900-mobile">1 месяц</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-mobile" id="3month-10900-mobile" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 966 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                            <label for="3month-10900-mobile">3 месяца</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-mobile" id="6month-10900-mobile" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                            <label for="6month-10900-mobile">6 месяцев</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-10900-mobile" id="12month-10900-mobile" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                            <label for="12month-10900-mobile">12 месяцев</label>
                        </li>
                    </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">10 900 ₽</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">18 900 ₽</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});


    blockManager.add('carrerum-tarifs-with-selector-9900', {
		label: 'Тарифы с селектором (9900)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="carrerum-tarifs-with-selector-9900">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <p>
                        Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="unactive">
                        Поддержка коуча
                    </p>
                    <p class="unactive">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">7 900 ₽</p>
                        <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                        <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                    </div>
                    
                </div>
                <div class="best-choise">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <p>
                        Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="tarif-selector-header">Расчет тарифа на:</p>
                        <ul>
                            <li>
                                <input type="radio" name="tarif-selector-9900" id="1month-9900" data-amount="9 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                                <label for="1month-9900">1 месяц</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-9900" id="3month-9900" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 996 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                                <label for="3month-9900">3 месяца</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-9900" id="6month-9900" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                                <label for="6month-9900">6 месяцев</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-9900" id="12month-9900" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                                <label for="12month-9900">12 месяцев</label>
                            </li>
                        </ul>
                        <p class="old-amount"> </p>
                        <p class="amount">9 900 ₽</p>
                        <p class="month-amount"></p>
                        <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                        <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Полное сопровождение
                    </h3>
                    <p>
                        Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="active">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">18 900 ₽</p>
                        <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                        <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-tablet-9900`, {
		label: 'Тарифы с селектором (tablet) (9900)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-tablet-9900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный <br>  &nbsp;
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">7 900 ₽</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой <br>  &nbsp;
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                        <li>
                            <input type="radio" name="tarif-selector-9900-tablet" id="1month-9900-tablet" data-amount="9 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked="checked">
                            <label for="1month-9900-tablet">1 месяц</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-tablet" id="3month-9900-tablet" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 996 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                            <label for="3month-9900-tablet">3 месяца</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-tablet" id="6month-9900-tablet" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                            <label for="6month-9900-tablet">6 месяцев</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-tablet" id="12month-9900-tablet" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                            <label for="12month-9900-tablet">12 месяцев</label>
                        </li>
                    </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">9 900 ₽</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">18 900 ₽</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-mobile-9900`, {
		label: 'Тарифы с селектором (mobile) (9900)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-mobile-9900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">7 900 ₽</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                        <li>
                            <input type="radio" name="tarif-selector-9900-mobile" id="1month-9900-mobile" data-amount="9 900 ₽" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked="checked">
                            <label for="1month-9900-mobile">1 месяц</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-mobile" id="3month-9900-mobile" data-amount="29 900 ₽" data-old-amount="32 700 ₽" data-month-amount="9 996 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                            <label for="3month-9900-mobile">3 месяца</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-mobile" id="6month-9900-mobile" data-amount="57 900 ₽" data-old-amount="65 400 ₽" data-month-amount="9 650 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                            <label for="6month-9900-mobile">6 месяцев</label>
                        </li>
                        <li>
                            <input type="radio" name="tarif-selector-9900-mobile" id="12month-9900-mobile" data-amount="109 900 ₽" data-old-amount="130 800 ₽" data-month-amount="9 158 ₽ за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                            <label for="12month-9900-mobile">12 месяцев</label>
                        </li>
                    </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">9 900 ₽</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">18 900 ₽</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});    


    blockManager.add('carrerum-tarifs-with-selector-eu', {
		label: 'Тарифы с селектором (EU)',
		category: category, 
		attributes: {class:''},
		content: `
    <div class="carrerum-tarifs-with-selector-10900">
        <div>
            <div>
                <h2>Тарифы</h2>
            </div>
            <div>
                <div>
                    <h3>
                        Самостоятельный <br>  &nbsp;
                    </h3>
                    <p>
                        Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="unactive">
                        Поддержка коуча
                    </p>
                    <p class="unactive">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">89 €</p>
                        <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                        <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                    </div>
                    
                </div>
                <div class="best-choise">
                    <h3>
                        С поддержкой <br>  &nbsp;
                    </h3>
                    <p>
                        Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="unactive">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="tarif-selector-header">Расчет тарифа на:</p>
                        <ul>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="1month-10900" data-amount="119 €" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                                <label for="1month-10900">1 месяц</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="3month-10900" data-amount="329 €" data-old-amount="" data-month-amount="110 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                                <label for="3month-10900">3 месяца</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="6month-10900" data-amount="639 €" data-old-amount="" data-month-amount="107 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                                <label for="6month-10900">6 месяцев</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="12month-10900" data-amount="1 229 €" data-old-amount="" data-month-amount="103 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                                <label for="12month-10900">12 месяцев</label>
                            </li>
                        </ul>
                        <p class="old-amount"> </p>
                        <p class="amount">119 €</p>
                        <p class="month-amount"></p>
                        <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                        <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                    </div>                    
                </div>
                <div>
                    <h3>
                        Полное сопровождение
                    </h3>
                    <p>
                        Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                    </p>
                    <p class="active">
                        Обучение
                    </p>                     
                    <p class="active">
                        Нетворкинг 
                    </p>
                    <p class="active">
                        Поддержка коуча
                    </p>
                    <p class="active">
                        Помощь эксперта по резюме
                    </p>
                    <p class="active">
                        Видеосессии с коучем
                    </p>
                    <div>
                        <p class="amount">219 €</p>
                        <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                        <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-tablet-eu`, {
		label: 'Тарифы с селектором (tablet) (EU)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-tablet-10900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный <br>  &nbsp;
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">89 €</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой <br>  &nbsp;
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="1month-10900" data-amount="119 €" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                                <label for="1month-10900">1 месяц</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="3month-10900" data-amount="329 €" data-old-amount="" data-month-amount="110 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                                <label for="3month-10900">3 месяца</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="6month-10900" data-amount="639 €" data-old-amount="" data-month-amount="107 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                                <label for="6month-10900">6 месяцев</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="12month-10900" data-amount="1 229 €" data-old-amount="" data-month-amount="103 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                                <label for="12month-10900">12 месяцев</label>
                            </li>
                        </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">119 €</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                <p class="amount">219 €</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});

	blockManager.add(`carrerum-tarifs-with-selector-mobile-eu`, {
		label: 'Тарифы с селектором (mobile) (EU)',
		category: category, 
		attributes: {class:''},
		content: `
<div class="carrerum-tarifs-with-selector-mobile-10900">
    <div>
        <div>
            <h2>Тарифы</h2>
        </div>
        <div>
            <div>
                <h3>
                    Самостоятельный
                </h3>
                <p>
                    Вы точно знаете свою карьерную цель и какие инструменты помогут вам ее достичь.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="unactive">
                    Поддержка коуча
                </p>
                <p class="unactive">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="amount">89 €</p>
                    <a href="#popup-form-samostoyatelnyj-info">Изучить подробнее</a>
                    <a href="#popup-form-samostoyatelnyj-30-days">Вступить в клуб</a>
                </div>
                
            </div>
            <div class="best-choise">
                <h3>
                    С поддержкой
                </h3>
                <p>
                    Вам нужен план действий и возможность в любой момент обратиться к эксперту за помощью.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="unactive">
                    Видеосессии с коучем
                </p>
                <div>
                    <p class="tarif-selector-header">Расчет тарифа на:</p>
                    <ul>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="1month-10900" data-amount="119 €" data-old-amount="" data-month-amount="" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-30-days" checked>
                                <label for="1month-10900">1 месяц</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="3month-10900" data-amount="329 €" data-old-amount="" data-month-amount="110 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-90-days">
                                <label for="3month-10900">3 месяца</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="6month-10900" data-amount="639 €" data-old-amount="" data-month-amount="107 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-180-days">
                                <label for="6month-10900">6 месяцев</label>
                            </li>
                            <li>
                                <input type="radio" name="tarif-selector-10900" id="12month-10900" data-amount="1 229 €" data-old-amount="" data-month-amount="103 € за месяц" data-popup-reserve="#popup-form-s-podderzhkoj-info" data-popup-order="#popup-form-s-podderzhkoj-360-days">
                                <label for="12month-10900">12 месяцев</label>
                            </li>
                        </ul>
                    <p class="old-amount"> </p>
                    <p class="amount">119 €</p>
                    <p class="month-amount"></p>
                    <a href="#popup-form-s-podderzhkoj-info" class="reserve-butt">Изучить подробнее</a>
                    <a href="#popup-form-s-podderzhkoj-30-days" class="order-butt">Вступить в клуб</a>
                </div>                    
            </div>
            <div>
                <h3>
                    Полное сопровождение
                </h3>
                <p>
                    Вы хотите ускорить работу над карьерой с помощью персонального коучинга.
                </p>
                <p class="active">
                    Обучение
                </p>                     
                <p class="active">
                    Нетворкинг 
                </p>
                <p class="active">
                    Поддержка коуча
                </p>
                <p class="active">
                    Помощь эксперта по резюме
                </p>
                <p class="active">
                    Видеосессии с коучем
                </p>
                <div>
                <p class="amount">219 €</p>
                    <a href="#popup-form-soprovozhdenie-info">Изучить подробнее</a>
                    <a href="#popup-form-soprovozhdenie-30-days">Вступить в клуб</a>
                </div> 
            </div>
        </div>
    </div>
</div>
	`});


    blockManager.add('carrerum-tarif-one', {
        label: 'Тариф первый',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarif-one">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
            </div>
            <div>
                <h2>
                    В мире осознанных профессионалов<br />
                    стало на одного человека больше :)
                </h2>
                <p>
                    Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе
                    «Самостоятельный».
                </p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                <p>
                    Мы уже отправили вам пароль — проверьте папки
                    «Промоакции» и «Спам» и подтвердите почту по ссылке в
                    письме, чтобы получить доступ к платформе.
                </p>
            </div>
            <div>
                <h4>Остались вопросы?</h4>
                <p>
                    Свяжитесь с нами любым из способов ниже<br />
                    или через онлайн-чат на этой странице.
                </p>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt="" /></a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-tarif-one-tablet', {
        label: 'Тариф первый (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarif-one-tablet">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
            </div>
            <div>
                <h2>
                    В мире осознанных профессионалов
                    стало<br> на одного человека больше :)
                </h2>
                <p>
                    Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе
                    «Самостоятельный».
                </p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                <p>
                    Мы уже отправили вам пароль — проверьте папки
                    «Промоакции» и «Спам» и подтвердите почту по ссылке в
                    письме, чтобы получить доступ к платформе.
                </p>
            </div>
            <div>
                <h4>Остались вопросы?</h4>
                <p>
                    Свяжитесь с нами любым из способов ниже<br />
                    или через онлайн-чат на этой странице.
                </p>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt="" /></a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-tarif-one-mobile', {
        label: 'Тариф первый (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
    <div class="carrerum-tarif-one-mobile">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
            </div>
            <div>
                <h2>
                    В мире осознанных профессионалов стало на одного
                    человека больше :)
                </h2>
                <p>
                    Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе
                    «Самостоятельный».
                </p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                <p>
                    Мы уже отправили вам пароль — проверьте папки
                    «Промоакции» и «Спам» и подтвердите почту по ссылке в
                    письме, чтобы получить доступ к платформе.
                </p>
            </div>
            <div>
                <h4>Остались вопросы?</h4>
                <p>
                    Свяжитесь с нами любым из способов ниже<br />
                    или через онлайн-чат на этой странице.
                </p>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt="" /></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt="" /></a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-tarif-two', {
        label: 'Тариф второй',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-tarif-two">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
            </div>
            <div>
                <h2>
                    В мире осознанных профессионалов<br />
                    стало на одного человека больше :)
                </h2>
                <p>
                    Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе «С
                    поддержкой».
                </p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                <p>
                    Мы уже отправили вам пароль — проверьте папки
                    «Промоакции» и «Спам» и подтвердите почту по ссылке в
                    письме, чтобы получить доступ к платформе.
                </p>
            </div>
            <div>
                <h3>
                    Вступите в клуб сразу на несколько<br />
                    месяцев и сэкономьте до 30 800 рублей
                </h3>
                <p>Предложение действует, пока вы видите эту страницу</p>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196460859.png" alt="" />
                        </div>
                        <h4>3 месяца</h4>
                        <ul>
                            <li>Поймете, чего хотите от карьеры</li>
                            <li>Построите собственный карьерный план</li>
                            <li>
                                Сделаете первые шаги к работе мечты /
                                повышению
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>2 месяца</span>:</p>
                            <p>+ 21 800 ₽</p>
                            <p>+ 19 000 ₽</p>
                            <p>9 996 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 3 месяца</a>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196512998.png" alt="" />
                        </div>
                        <h4>6 месяцев</h4>
                        <ul>
                            <li>Повысите профессиональную самооценку</li>
                            <li>Найдете опору в своих талантах</li>
                            <li>
                                Достигнете первой цели — получите работу или
                                повышение
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>5 месяцев</span>:</p>
                            <p>+ 56 800 ₽</p>
                            <p>+ 40 000 ₽</p>
                            <p>9 500 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 6 месяцев</a>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196556389.png" alt="" />
                        </div>
                        <h4>12 месяцев</h4>
                        <ul>
                            <li>Научитесь всегда работать в радость</li>
                            <li>Укрепите нужные вам soft skills</li>
                            <li>
                                Освоите навык решения любых карьерных задач,
                                даже самых сложных
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>11 месяцев</span>:</p>
                            <p>+ 120 800 ₽</p>
                            <p>+ 90 000 ₽</p>
                            <p>8 700 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 12 месяцев</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Не знаете, какой вариант подойдет вам больше?</h4>
                <p>
                    Служба поддержки поможет разобраться — свяжитесь с нами
                    любым из<br />
                    способов ниже или через онлайн-чат на этой странице.
                </p>
                <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt=""></a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-tarif-two-tablet', {
        label: 'Тариф второй (tablet)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-tarif-two-tablet">
        <div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
            </div>
            <div>
                <h2>
                    В мире осознанных профессионалов
                    стало<br> на одного человека больше :)
                </h2>
                <p>
                    Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе «С
                    поддержкой».
                </p>
            </div>
            <div>
                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                <p>
                    Мы уже отправили вам пароль — проверьте папки
                    «Промоакции» и «Спам» и подтвердите почту по ссылке в
                    письме, чтобы получить доступ к платформе.
                </p>
            </div>
            <div>
                <h3>
                    Вступите в клуб сразу на несколько
                    месяцев и<br> сэкономьте до 30 800 рублей
                </h3>
                <p>Предложение действует, пока вы видите эту страницу</p>
                <div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196460859.png" alt="" />
                        </div>
                        <h4>3 месяца</h4>
                        <ul>
                            <li>Поймете, чего хотите от карьеры</li>
                            <li>Построите собственный карьерный план</li>
                            <li>
                                Сделаете первые шаги к работе мечты /
                                повышению
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>2 месяца</span>:</p>
                            <p>+ 21 800 ₽</p>
                            <p>+ 19 000 ₽</p>
                            <p>9 996 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 3 месяца</a>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196512998.png" alt="" />
                        </div>
                        <h4>6 месяцев</h4>
                        <ul>
                            <li>Повысите профессиональную самооценку</li>
                            <li>Найдете опору в своих талантах</li>
                            <li>
                                Достигнете первой цели — получите работу или
                                повышение
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>5 месяцев</span>:</p>
                            <p>+ 56 800 ₽</p>
                            <p>+ 40 000 ₽</p>
                            <p>9 500 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 6 месяцев</a>
                        </div>
                    </div>
                    <div>
                        <div>
                            <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196556389.png" alt="" />
                        </div>
                        <h4>12 месяцев</h4>
                        <ul>
                            <li>Научитесь всегда работать в радость</li>
                            <li>Укрепите нужные вам soft skills</li>
                            <li>
                                Освоите навык решения любых карьерных задач,
                                даже самых сложных
                            </li>
                        </ul>
                        <div>
                            <p>Доплата за <span>11 месяцев</span>:</p>
                            <p>+ 120 800 ₽</p>
                            <p>+ 90 000 ₽</p>
                            <p>8 700 ₽ в месяц вместо 10 900 ₽</p>
                            <a href="#">Вступить на 12 месяцев</a>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h4>Не знаете, какой вариант подойдет вам больше?</h4>
                <p>
                    Служба поддержки поможет разобраться — свяжитесь с нами<br />
                    любым из
                    способов ниже или через онлайн-чат на этой странице.
                </p>
                <div>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt=""></a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt=""></a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt=""></a>
                <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt=""></a>
                </div>
            </div>
        </div>
    </div>`
	});


    blockManager.add('carrerum-tarif-two-mobile', {
        label: 'Тариф второй (mobile)',  // can contain any HTML markup
        category: category, // name of component section
        attributes: {class:''}, // for toolbox icon
        content: `
        <div class="carrerum-tarif-two-mobile">
            <div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666204744.png" alt="" />
                </div>
                <div>
                    <h2>
                        В мире осознанных профессионалов стало на одного
                        человека больше :)
                    </h2>
                    <p>
                        Вас ждет 1 месяц обучения в Карьерум.Клубе на тарифе «С
                        поддержкой».
                    </p>
                </div>
                <div>
                    <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666265254.svg" alt="" />
                    <p>
                        Мы уже отправили вам пароль — проверьте папки
                        «Промоакции» и «Спам» и подтвердите почту по ссылке в
                        письме, чтобы получить доступ к платформе.
                    </p>
                </div>
                <div>
                    <h3>
                        Вступите в клуб сразу на несколько<br />
                        месяцев и сэкономьте<br />
                        до 30 800 рублей
                    </h3>
                    <p>
                        Предложение действует, пока вы видите<br />
                        эту страницу
                    </p>
                    <div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196460859.png" alt="" />
                            </div>
                            <h4>3 месяца</h4>
                            <ul>
                                <li>Поймете, чего хотите от карьеры</li>
                                <li>Построите собственный карьерный план</li>
                                <li>
                                    Сделаете первые шаги к работе мечты /
                                    повышению
                                </li>
                            </ul>
                            <div>
                                <p>Доплата за <span>2 месяца</span>:</p>
                                <p>+ 21 800 ₽</p>
                                <p>+ 19 000 ₽</p>
                                <p>9 996 ₽ в месяц вместо 10 900 ₽</p>
                                <a href="#">Вступить на 3 месяца</a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196512998.png" alt="" />
                            </div>
                            <h4>6 месяцев</h4>
                            <ul>
                                <li>Повысите профессиональную самооценку</li>
                                <li>Найдете опору в своих талантах</li>
                                <li>
                                    Достигнете первой цели — получите работу или
                                    повышение
                                </li>
                            </ul>
                            <div>
                                <p>Доплата за <span>5 месяцев</span>:</p>
                                <p>+ 56 800 ₽</p>
                                <p>+ 40 000 ₽</p>
                                <p>9 500 ₽ в месяц вместо 10 900 ₽</p>
                                <a href="#">Вступить на 6 месяцев</a>
                            </div>
                        </div>
                        <div>
                            <div>
                                <img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1640196556389.png" alt="" />
                            </div>
                            <h4>12 месяцев</h4>
                            <ul>
                                <li>Научитесь всегда работать в радость</li>
                                <li>Укрепите нужные вам soft skills</li>
                                <li>
                                    Освоите навык решения любых карьерных задач,
                                    даже самых сложных
                                </li>
                            </ul>
                            <div>
                                <p>Доплата за <span>11 месяцев</span>:</p>
                                <p>+ 120 800 ₽</p>
                                <p>+ 90 000 ₽</p>
                                <p>8 700 ₽ в месяц вместо 10 900 ₽</p>
                                <a href="#">Вступить на 12 месяцев</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <h4>Не знаете, какой вариант подойдет вам больше?</h4>
                    <p>
                        Служба поддержки поможет разобраться — свяжитесь с нами
                        любым из способов ниже или через онлайн-чат на этой
                        странице.
                    </p>
                    <div>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666379000.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666446616.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666472304.svg" alt=""></a>
                    <a href="#"><img src="https://fra1.digitaloceanspaces.com/devabackenduploads/files-1639666490226.svg" alt=""></a>
                    </div>
                </div>
            </div>
        </div>`
	});

}